/* PDP STORY: si el landing está embebido, forzar scroll de documento normal — el theme deja
   html como scroll-container de altura fija (overflow:auto !important) y eso rompe position:sticky
   de STACK/DISECCIÓN. Self-guarded: solo corre cuando hay #agc-landing en la página. */
(function(){ if(document.getElementById('agc-landing')){ var d=document.documentElement,b=document.body;
  d.style.setProperty('overflow','visible','important'); d.style.setProperty('height','auto','important');
  b.style.setProperty('overflow','visible','important'); b.style.setProperty('height','auto','important'); } })();
/* ============================================================
   AGC CONFIGURATOR JS — iyO-inspired PDP (Fase 1)
   Datos reales via window.AGC_CFG (inyectado por la sección Liquid).
   Carrito real: /cart/add.js + cart-drawer.renderContents() del theme.
   Mapping (FASE0-GROUND-TRUTH.md):
     tier  = quantity del variant elegido
     color = variant_id
     plan  = selling_plan (siempre — subscription-only)
     +Set Anual = línea one-time extra
     descuento tier = automatic discount Shopify (no requiere código)
   ============================================================ */
(function () {
  'use strict';
  var CFG = window.AGC_CFG;
  if (!CFG) return;
  /* BLINDAJE tier→plan: no confiar en el orden que Shopify devuelve los selling_plan_groups.
     El descuento del plan crece con el tier (1<2<3 baños = 25<33<40%), así que ordenamos por
     pct ascendente → tierPlans[0]=tier1, [1]=tier2, [2]=tier3 sin importar el orden de origen. */
  if (CFG.tierPlans && CFG.tierPlans.length) {
    CFG.tierPlans = CFG.tierPlans.slice().sort(function (a, b) { return (parseFloat(a.pct) || 0) - (parseFloat(b.pct) || 0); });
  }
  var root = document.getElementById('agc-cfg');
  if (!root) return;
  var cfgFlow = !!document.querySelector('#agc-pg.agc-dv2-flow, #agc-lst[data-embebido="1"]'); /* astra o la landing 10-cosas: el configurador va debajo de otra sección */

  /* C24: visual loops belong to the visible configurator, not the page above it. */
  var cfgInView = !cfgFlow, cfgLoops = new Map();
  function cfgFrame(fn) {
    if (!cfgFlow) return requestAnimationFrame(fn);
    if (!cfgLoops.has(fn)) cfgLoops.set(fn, 0);
    if (!cfgInView || document.hidden || cfgLoops.get(fn)) return;
    cfgLoops.set(fn, requestAnimationFrame(function(){
      cfgLoops.set(fn, 0);
      if (cfgInView && !document.hidden) fn();
    }));
  }
  function resumeCfgFrames() { cfgLoops.forEach(function(id,fn){cfgFrame(fn);}); }
  if (cfgFlow && window.IntersectionObserver) {
    new IntersectionObserver(function(entries){
      cfgInView=entries[0].isIntersecting;
      resumeCfgFrames();
      if (window.__agcVidActiva) window.__agcVidActiva();
    },{threshold:0}).observe(root);
  } else { cfgInView=true; }
  document.addEventListener('visibilitychange',resumeCfgFrames);

  /* C24-speed: optional configurator media waits until near viewport. */
  var cfgNear = !cfgFlow, cfgNearTasks = [];
  function whenCfgNear(fn) {
    if (!cfgFlow) { fn(); return; }
    if (cfgNear) { setTimeout(fn, 0); return; }
    cfgNearTasks.push(fn);
  }
  function prepareCfgMedia() {
    if (cfgNear) return;
    cfgNear = true;
    var tasks = cfgNearTasks.splice(0);
    tasks.forEach(function (fn) { fn(); });
  }
  if (cfgFlow && window.IntersectionObserver) {
    var cfgNearObserver = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      cfgNearObserver.disconnect();
      prepareCfgMedia();
    }, { rootMargin: '1000px 0px', threshold: 0 });
    cfgNearObserver.observe(root);
  } else { prepareCfgMedia(); }

  /* C24: preserve LIVE behavior with a landing above the configurator. */
  var _cfgTop = 0;
  function cfgTop() {
    if (!cfgFlow) return 0;
    if (document.body.style.position === 'fixed') return _cfgTop;
    var rect = root.getBoundingClientRect();
    if (rect.height) _cfgTop = Math.max(0, Math.round(rect.top + (window.scrollY || 0)));
    return _cfgTop;
  }
  function cfgY() { return Math.max(0, (window.scrollY || 0) - cfgTop()); }

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
  var fmt = function (cents) { return '$' + Math.round(cents / 100).toString(); };
  /* MOCK Set Anual v4 (STAGING-ONLY, ?anual=v4 — Pedro 2026-09-19): guarda todo el JS nuevo de la
     card-fila detrás de este helper. Sin la clase, cero cambio de comportamiento. */
  function ANUALV4() { return !!(root && root.classList.contains('agc-anual-v4')); }
  /* HERO DE FOTOS (LIVE desde 2026-09-20): todo el JS del hero de 8 fotos cuelga de este helper.
     La clase la pone la sección solo en móvil y solo en la plantilla de la ducha; sin ella, el hero
     renderizado de siempre corre intacto. */
  function STORY() { return !!(root && root.classList.contains('agc-hero-story')); }

  /* El video frame-scrub NO se tinta por color (decisión Pedro 2026-06-12):
     cada acabado tendrá su propio set de frames más adelante. El cambio de
     color solo actualiza variante, precio y thumb (foto real del acabado). */
  var state = { tier: 1, colorKey: null, colors: [], step: 'config', anual: false, anualQty: null, anualQtyTouched: false, careSel: false, ritualSel: false, ritualViaRow: false, tapeteSel: false, busy: false, subOff: false, ritBaj: false, ritAlto: false };   /* ritBaj = ya vio la bajada del Ritual a $990 · ritAlto = lo aceptó a $1190 (Pedro 2026-09-30) */   /* subOff = A/B suscripción, switch OFF (Pedro 2026-09-21) */   /* Set Anual = add-on opt-in (Pedro 2026-07-30, espeja Buen Fin/feb) · tapeteSel = fila tapete, nace OFF (Pedro 2026-08-13) */

  /* primer color disponible = default */
  var firstAvail = CFG.colors.filter(function (c) { return c.available; })[0] || CFG.colors[0];
  state.colorKey = firstAvail.key;
  state.colors = [firstAvail.key]; /* color por ducha (T2/T3); default todas = 1er color */

  /* ── FUNNEL del configurador (HANDOFF-funnel-configurador.md, 2026-08-07) ─────
     Fire-and-forget a la ingesta del popup en Railway. phase = VARIANTE del step
     (care | ritual_anual) · metadata.role = theme.role → el funnel default solo
     cuenta 'main' (probar en DEBUG no ensucia). Mismo _sid que agc-popup-noti
     (misma key) para unir popup + configurador por sesión. JAMÁS rompe una
     venta: todo en try/catch, keepalive en la salida a checkout. */
  var FUN = CFG.funnel || {};
  var _fsid = (function () { var k = 'agcpn_sid', s = null; try { s = sessionStorage.getItem(k) } catch (e) { } if (!s) { s = Date.now().toString(36) + Math.random().toString(36).slice(2, 8); try { sessionStorage.setItem(k, s) } catch (e) { } } return s })();
  /* VARIANTE VISUAL VIVA (Pedro 2026-09-19): qué layout estaba en pantalla en el instante del
     evento — paso 1 en filas o tríptico, Set Anual v4 o clásico. Lee classList DIRECTO en vez de
     ROWS()/ANUALV4(): cfgTrack puede correr antes que cualquier helper y un evento jamás se
     pierde por esta lectura (try/catch → default = el layout de siempre). */
  function uiVariant() {
    var t = 'triptico', a = 'clasico', s = 'sub-ctl';   /* sub-ctl = sin switch (control) · sub-on / sub-off = brazo B (Pedro 2026-09-21) */
    try {
      var r = document.getElementById('agc-cfg');
      if (r) { if (r.classList.contains('agc-rows')) t = 'filas'; if (r.classList.contains('agc-anual-v4')) a = 'v4'; if (r.classList.contains('agc-subsw')) s = r.classList.contains('agc-suboff') ? 'sub-off' : 'sub-on'; }
    } catch (e) { }
    return { ui_tiers: t, ui_anual: a, ui_sub: s };
  }
  function cfgTrack(ev, extra) {
    try {
      var md = { role: FUN.themeRole || null, tier: state.tier, color: state.colorKey };
      if (extra) for (var k in extra) md[k] = extra[k];
      /* DESPUÉS de `extra` a propósito: la variante es un hecho de la página, no un dato que
         una llamada pueda sobrescribir. Un extra con ui_tiers/ui_anual se ignora. */
      var _uv = uiVariant(); md.ui_tiers = _uv.ui_tiers; md.ui_anual = _uv.ui_anual; md.ui_sub = _uv.ui_sub;
      /* LP split: celda del test (solo si la visita entró al sorteo) → funnel por brazo sin beacon nuevo */
      try { var _lp = (window.AGCLp && typeof AGCLp.attrs === 'function') ? AGCLp.attrs() : null; if (_lp) { md.lp_exp = _lp._agc_lp_exp; md.lp = _lp._agc_lp_var; } } catch (e) { }
      fetch('https://web-production-7de4a.up.railway.app/api/popup/event', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        /* phase = VARIANTE del step. La fila de Care es otra variante ('care_row'): así el panel
           compara step vs fila sin mezclar. La decide el JS porque ahí vive el switch. */
        body: JSON.stringify({ session_id: _fsid, event: ev, phase: (careRowOn() ? 'care_row' : (FUN.stepVariant || 'care')), metadata: md, page_path: location.pathname, user_agent: navigator.userAgent || null })
      }).catch(function () { });
    } catch (e) { }
  }
  function cfgTrackOnce(ev, extra) { try { var dk = 'agcfn_' + ev; if (sessionStorage.getItem(dk)) return; sessionStorage.setItem(dk, '1'); } catch (e) { } cfgTrack(ev, extra); }
  /* cfg_view = PRIMERA INTERACCIÓN humana (scroll/tap/tecla), NO el page load.
     En load contaba pestañas y el prefetch de Meta que ejecuta JS sin humano:
     8,732 "vistas" vs 2,883 sesiones Shopify el 09-ago (G25 de la Biblia).
     El prefetch no scrollea ni toca — con este gate, cfg_view ≈ personas que
     de verdad miraron. `once:true` + passive: cero costo en el scroll real. */
  (function () {
    var armado = false;
    function fuego() { if (armado) return; armado = true; cfgTrackOnce('cfg_view'); }
    ['pointerdown', 'scroll', 'keydown', 'touchstart'].forEach(function (evt) {
      window.addEventListener(evt, fuego, { once: true, passive: true });
    });
  })();

  function colorByKey(k) {
    for (var i = 0; i < CFG.colors.length; i++) if (CFG.colors[i].key === k) return CFG.colors[i];
    return CFG.colors[0];
  }

  /* ── pricing engine (centavos, desde precio real del variant) ──
     MODELO NUEVO: el % del descuento vive en el selling plan de CADA tier
     (CFG.tierPlans[tier-1].pct). Sin Kaching/RITUAL-A0, sin espejo subPct+tierNPct.
     base 2580 → tier1 1935 (25%), tier2 3457 (33%), tier3 4644 (40%). */
  /* ANIVERSARIO: activo solo si el toggle de la sección está prendido Y el Set Anual existe. */
  function anivOn() {
    return !!(CFG.aniv && CFG.aniv.enabled && CFG.anual && CFG.anual.variantId);
  }
  /* ── CUPÓN RECLAMADO, VISIBLE EN LOS TIERS (Pedro 2026-08-12) ────────────────
     Quien reclama un cupón no veía su descuento hasta el checkout: configuraba a
     ciegas y llegaba al pago dudando si se aplicó. Aquí se muestra el AHORRO — nunca un precio
     nuevo. Es deliberado: replicar la suma de descuentos (cupón + automáticos + el del tier)
     en el front sería una segunda fuente de verdad, y el día que cambie una promo la página
     diría un número y el checkout cobraría otro. */
  /* MULTI-CUPÓN (Pedro 2026-08-16): el registro manual fue eliminado el 2026-09-13.
     `/cart.js` detecta los códigos presentes en la sesión. Con items, Shopify entrega ahí
     valor y aplicabilidad exactos. Con carrito vacío, Railway consulta la definición viva
     en Shopify Admin: un código expirado o restringido jamás se convierte en ahorro local. */
  var CUPONES = [];
  var CUPON_API = 'https://colabs.aguacero.mx/api/storefront/discounts/validate';
  var _cupOn = {}, _cuponPreguntado = false, _cupSeq = 0;
  function upsertCupon(code, valueType, value, minimumSubtotal) {
    var hit = null, i;
    for (i = 0; i < CUPONES.length; i++) if (CUPONES[i].code === code) { hit = CUPONES[i]; break; }
    if (!hit) { hit = { code: code }; CUPONES.push(hit); }
    hit.pct = valueType === 'percentage' ? (parseFloat(value) || 0) : null;
    hit.amt = valueType === 'fixed_amount' ? (parseInt(value, 10) || 0) : null;
    hit.minimumSubtotal = parseInt(minimumSubtotal, 10) || 0;
    return hit;
  }
  function cuponesActivos() {
    var out = [], i;
    for (i = 0; i < CUPONES.length; i++) if (_cupOn[CUPONES[i].code]) out.push(CUPONES[i]);
    return out;
  }
  function chequeaCupon() {
    if (_cuponPreguntado) return;
    _cuponPreguntado = true;
    /* Solo la ÚLTIMA pregunta pinta: la de la carga puede leer un carrito viejo y resolver
       después de la que se hace tras vaciarlo (pageshow). 2026-09-14 */
    var seq = ++_cupSeq;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (seq !== _cupSeq) return;
      var l = (c && c.discount_codes) || [], codes = [], nextOn = {}, i, code;
      for (i = 0; i < l.length; i++) {
        code = String((l[i] && l[i].code) || '').trim().toUpperCase();
        if (code && codes.indexOf(code) < 0) codes.push(code);
      }
      /* Con items, `cart_level_discount_applications` manda y trae el valor exacto. Incluye los
         AUTOMÁTICOS de pedido (Pedro 2026-09-14: "SORPRESA 5% no aparece en la línea de código
         aplicado"): antes solo se leían type 'discount_code' y el automático se ignoraba. Los de
         producto (RITUAL-A0) viven en las líneas, no aquí, así que no se cuentan dos veces. */
      var apps = (c && c.cart_level_discount_applications) || [];
      for (i = 0; i < apps.length; i++) {
        if (!apps[i]) continue;
        code = String(apps[i].title || '').toUpperCase();
        if (!code) continue;
        var hitC = upsertCupon(code, apps[i].value_type === 'percentage' ? 'percentage' : 'fixed_amount',
          apps[i].value_type === 'percentage' ? apps[i].value : Math.round((parseFloat(apps[i].value) || 0) * 100));
        hitC.auto = apps[i].type !== 'discount_code';
        nextOn[code] = true;
      }
      var hayItems = ((c && c.item_count) || 0) > 0;
      if (hayItems) {
        _cupOn = nextOn;
        try { render(); } catch (e) { }
        return;
      }
      /* Carrito vacío: el automático (SORPRESA) sale del espejo CFG.autoDisc (ajustes de la sección).
         El sondeo con un carrito aparte (cartCreate) se quitó el 2026-09-14: Shopify contaba cada
         visita como sesión con carrito (hora 15: 34 de 80 sesiones, 1 al pago). En cuanto el carrito
         real se arma (colorEntryCart/careEntry re-preguntan), /cart.js reemplaza el espejo. */
      var ad = CFG.autoDisc;
      if (ad && ad.code && ad.pct > 0) {
        upsertCupon(ad.code, 'percentage', ad.pct, ad.min).auto = true;
        nextOn[ad.code] = true;
      }
      if (!codes.length) {
        _cupOn = nextOn; try { render(); } catch (e) { }
        return;
      }
      /* Carrito vacío: `applicable:false` no distingue vigente de expirado. Validamos
         únicamente los códigos que Shopify ya dejó en esta sesión. Fail-closed: si Railway
         o Admin fallan, no se resta un peso. */
      /* Tope de 6 s: una red lenta (navegador interno de WhatsApp/IG) no deja la línea colgada. */
      var ctl = window.AbortController ? new AbortController() : null;
      if (ctl) setTimeout(function () { ctl.abort(); }, 6000);
      return fetch(CUPON_API, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ codes: codes }), signal: ctl ? ctl.signal : undefined
      }).then(function (r) { if (!r.ok) throw new Error('coupon_validation_' + r.status); return r.json(); })
        .then(function (payload) {
          if (seq !== _cupSeq) return;
          var valid = (payload && payload.discounts) || [], combinables = true;
          if (valid.length > 1) for (i = 0; i < valid.length; i++) if (!valid[i].combines_with_order_discounts) combinables = false;
          for (i = 0; i < valid.length; i++) {
            var d = valid[i];
            upsertCupon(d.code, d.value_type, d.value_type === 'percentage' ? d.value : d.amount_cents, d.minimum_subtotal_cents);
            /* Si la combinación no está garantizada, se muestran los códigos pero no se
               calcula ahorro; checkout elegirá el resultado aplicable. */
            if (!combinables) { upsertCupon(d.code, null, 0); }
            nextOn[d.code] = true;
          }
          _cupOn = nextOn;
          try { render(); } catch (e) { }
        });
    }).catch(function () {
      if (seq !== _cupSeq) return;
      /* Si Railway falla, los CÓDIGOS no se afirman (fail-closed), pero el automático del espejo
         (SORPRESA) sí se queda: antes el fallo borraba también esa línea (2026-09-14). */
      var keep = {}, ad = CFG.autoDisc;
      if (ad && ad.code && ad.pct > 0) { upsertCupon(ad.code, 'percentage', ad.pct, ad.min).auto = true; keep[ad.code] = true; }
      _cupOn = keep; try { render(); } catch (e) { }
    });
  }
  /* Re-pregunta cupones/automáticos cuando el carrito real cambió por fuera de la carga. */
  function recheckCupon() { _cuponPreguntado = false; try { renderCupon(); } catch (e) { } }
  /* El popup avisa en cuanto aplica el cupón (no recarga): repintamos al instante. */
  document.addEventListener('agc:cupon', function () {
    _cuponPreguntado = false;
    try { render(); } catch (e) { }
  });
  /* POPUP KLAVIYO (Pedro 2026-09-22 06:10): al ENVIAR el popup (correo dado → paso del cupón sorpresa), el theme pega el
     código a la sesión con /cart/update.js {discount} — funciona con carrito vacío (queda applicable:false hasta que hay
     items, verificado en LIVE) — y dispara agc:cupon para que la línea "Código aplicado" aparezca sin recargar.
     Form id y código viven en los ajustes de la sección (CFG.popup); si Klaviyo cambia de form, se cambia ahí. */
  window.addEventListener('klaviyoForms', function (e) {
    var d = (e && e.detail) || {}, pc = CFG.popup || {};
    if (d.type === 'submit') cfgTrack('popup_email_submitted', { form: d.formId || null });   /* test astra vs PDP: correos captados por brazo (cfgTrack agrega lp) */
    if (!pc.code || !pc.formId || d.formId !== pc.formId || d.type !== 'submit') return;
    fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: pc.code }) })
      .then(function () { document.dispatchEvent(new Event('agc:cupon')); })
      .catch(function () { });
  });
  /* Precio grande de la card, en los 3 tiers. `cupSave` = la porción del cupón que le toca
     (0 sin código). Vive aquí y no en render() porque renderCupon() lo repinta también al
     togglear Care / Set Anual / tapete — si solo lo pintara render(), la card se quedaría con
     el ahorro de la configuración anterior.
     Pedro 2026-06-21: precio TOTAL del tier en los 3 (sin "c/u"). Tachado = gross total
     (N × $2580 = $2580 / $5160 / $7740, espeja el deal de Kaching); se oculta solo cuando
     no hay nada que tachar (ancla completa, reset 2026-07-22). */
  /* Pedro 2026-09-22 15:55: "Hoy: 3x Ducha + Filtro" + pastilla + precios SIEMPRE en una línea.
     1) todo en línea; 2) si no cabe, el tachado se apila arriba del precio ("si es necesario ponlo arriba o abajo");
     3) si aún no cabe (4-6 duchas), el título baja de tamaño hasta 12px. Se mide, no se adivina. */
  function fitDealHead() {
    var main = document.querySelector('#agc-cfg .agc-deal-main'), pr = document.querySelector('#agc-cfg .agc-deal-price'), ti = $('#agcDealTitle');
    if (!main || !pr || !ti || !main.offsetWidth) return;
    var over = function () { return main.scrollWidth > main.clientWidth + 1; };
    pr.classList.remove('agc-price-stack'); ti.style.fontSize = '';
    if (!over()) return;
    pr.classList.add('agc-price-stack');
    var fs = parseFloat(getComputedStyle(ti).fontSize) || 15.5;
    while (over() && fs > 12) { fs -= 0.5; ti.style.fontSize = fs + 'px'; }
  }
  window.addEventListener('resize', function () { try { fitDealHead(); } catch (e) { } });
  function paintDeal(cupSave) {
    var t = totals();
    var now = Math.max(0, t.today - (cupSave || 0));
    /* Precio TOTAL del tier, sin "c/u" (Pedro 2026-09-21: "vuelve a precios normales sin c/u").
       Revierte el experimento del 2026-09-19 23:26: el precio por ducha no subió el multi-baño
       (T2 11.3 % → 11.1 % en 90 pedidos) y T3 pasó de 7.8 % a 2.2 %. El precio por ducha vive
       arriba, en los botones de tier. */
    var nowEl = $('#agcDealNow'); if (nowEl) nowEl.textContent = fmt(now);
    var cuEl = $('#agcDealCu'); if (cuEl) cuEl.textContent = '';
    var wasEl = $('#agcDealWas');
    if (wasEl) { wasEl.textContent = fmt(t.gross); wasEl.style.display = (t.gross > now) ? '' : 'none'; }
    try { requestAnimationFrame(fitDealHead); } catch (e) { }
    /* % OFF REAL (Pedro 2026-09-14: "los badges 29/40/50 son falsos, ya tiene otro 5% adicional"):
       tachado vs precio con el cupón, redondeado hacia ABAJO. Sin cupón vuelve solo a 29/40/50. */
    var offEl = $('#agcDealOff');
    if (offEl) {
      var offPct = t.gross > now ? Math.floor((t.gross - now) * 100 / t.gross + 1e-9) : 0;
      offEl.textContent = offPct > 0 ? offPct + '% OFF' : '';
      offEl.style.display = offPct > 0 ? '' : 'none';
    }
    /* la tarjeta cerrada decía $1810 mientras el Total decía $1720 */
    var headEl = $('#agcHeadPrice'); if (headEl) headEl.textContent = fmt(now);
  }
  /* Precio neto de un tier con los cupones de % activos (los fijos no cambian la escalera). */
  function tierNet(tier, act) {
    var d = dealFor(tier); if (!d || d.now == null) return null;
    var pct = 0, i;
    for (i = 0; i < act.length; i++) if (act[i].pct && (!act[i].minimumSubtotal || d.now >= act[i].minimumSubtotal)) pct += act[i].pct;
    return d.now * (1 - pct / 100);
  }
  /* Framing de tiers (Pedro 2026-09-14): precio por ducha bajo cada tier, T2 "Ahorras $X" vs dos
     de 1 baño, T3 "La 3ª por $Y" (T3 − T2). Calculado en vivo de CFG.deals + cupones: si SORPRESA
     se apaga, los números bajan solos. La barra "LLEVA 3 Y AHORRA N% HOY" usa el % real del T3
     (se escribe también en data-urg-exp porque el contador la re-pinta desde ahí). */
  function paintTierFraming(act) {
    var n1 = tierNet(1, act), n2 = tierNet(2, act), n3 = tierNet(3, act), i;
    var nets = [n1, n2, n3];
    /* Precio POR DUCHA en cada botón, sin el sufijo "c/u" (Pedro 2026-09-21: "vuelve a precios normales sin c/u").
       Los botones vuelven a tener precio; el total del tier vive en la card y en "Total (n)". */
    for (i = 0; i < 3; i++) { var u = $('#agcTpu' + (i + 1)); if (u) u.textContent = nets[i] != null ? fmt(nets[i] / (i + 1)) : ''; }
    /* T2: ahorro TOTAL vs lista (Pedro 2026-09-14: "debe decir ahorro total, para convencer con más poder") */
    var d2 = dealFor(2), p2 = $('#agcTpill2'); if (p2 && d2 && d2.was && n2 != null && d2.was > n2) p2.textContent = '+ Tapete gratis';   /* Pedro 2026-09-22 (estilo Gruns/feb): etiqueta, no monto */
    var d3t = dealFor(3), p3 = $('#agcTpill3'); if (p3 && d3t && d3t.was && n3 != null && d3t.was > n3) p3.textContent = '+ 2 Tapetes gratis';
    /* tarjeta CERRADA y banner colapsado se quedan en $1810 sin SORPRESA a propósito
       (Pedro 2026-09-14: "los sorprendemos hasta que abren el config"). */
    var d3 = dealFor(3), bar = $('.agc-urgbar');
    if (bar && d3 && d3.was && n3 != null && d3.was > n3) {
      var pct3 = Math.floor((d3.was - n3) * 100 / d3.was + 1e-9);
      if (bar.dataset.urgExp) bar.dataset.urgExp = bar.dataset.urgExp.replace(/\d+%/, pct3 + '%');
      var ex = bar.querySelector('.agc-urg-exp'); if (ex && bar.dataset.urgExp) ex.textContent = bar.dataset.urgExp;
    }
  }
  /* MOCK filas (?tiers=rows, Pedro 2026-09-18): total + tachado + % OFF por fila, SIEMPRE desde
     CFG.deals vía dealFor() — el mismo dato que ya pinta paintDeal/paintTierFraming, cero precio
     nuevo. Estático a propósito: el layout de filas no lleva "Ahorras" por cupón, solo el "Ahorras
     $X" que ya pinta paintTierFraming en #agcTpill2/3 (reubicado por CSS, mismo nodo). Se llama
     UNA vez al cargar — dealFor() no cambia con state.tier ni con cupones. */
  function paintRowsStatic() {
    for (var i = 1; i <= 3; i++) {
      var d = dealFor(i);
      var offEl = $('#agcTrowOff' + i); if (offEl) offEl.textContent = d.off || '';
      var totEl = $('#agcTrowTotal' + i); if (totEl) totEl.textContent = d.now != null ? fmt(d.now) : '';
      var wasEl = $('#agcTrowWas' + i);
      if (wasEl) wasEl.textContent = (d.was != null && d.now != null && d.was > d.now) ? fmt(d.was) : '';
    }
  }
  /* MOCK filas (?tiers=rows, ronda 3 — Pedro 2026-09-19): recibo de 2 renglones que reemplaza el
     bloque "Tu ducha incluye". A diferencia de paintRowsStatic() (arriba, estático), este SÍ
     depende de state.tier — se llama desde render() en cada cambio (incluye 4/5/6 vía #agcMore).
     $590 sale de CFG.filtroCompare, el precio REAL del variant "filtro-inicial-aguacero" que ya
     manda la sección (window.AGC_CFG) — el mismo dato que arma el "inc" del deal card. Nunca un
     literal nuevo. */
  function ROWS() { var r = document.getElementById('agc-cfg'); return !!(r && r.classList.contains('agc-rows')); }
  /* MOCK filas, ronda 4 (Pedro 2026-09-19): con 4, 5 o 6 la fila de "3 Baños" SE CONVIERTE en
     "N Baños" (título, renglón chico, total, tachado, ahorro) y el control 3·4·5·6 deja bajar a 3.
     Mismos datos de siempre: dealFor(n) + tierNet(n). Solo corre en modo filas. */
  /* MOCK filas, ronda 5 (Pedro 2026-09-19, "criticar y resolver para subir AOV"): el renglón chico
     deja de repetir el título y vende el PRECIO MARGINAL de la ducha extra (T2 − T1, T3 − T2),
     calculado en vivo de dealFor(). T1 gana su "Ahorras $X" para que las 3 filas se lean igual. */
  function paintRowsMarginal() {
    if (!ROWS()) return;
    var d1 = dealFor(1), d2 = dealFor(2), d3 = dealFor(3), ord = ['', '', '2ª', '3ª'];
    function sub(t, html) { var e = document.querySelector('#agcTiers .agc-tieropt[data-tier="' + t + '"] .agc-trow-sub'); if (e) e.innerHTML = html; }
    if (d1.now != null && d2.now != null && d2.now > d1.now) sub(2, 'La ' + ord[2] + ' te sale en <b>' + fmt(d2.now - d1.now) + '</b>');
    if (d2.now != null && d3.now != null && d3.now > d2.now) sub(3, 'La ' + ord[3] + ' te sale en <b>' + fmt(d3.now - d2.now) + '</b>');
    var s1 = $('#agcTrowSave1'); if (s1 && d1.was != null && d1.now != null && d1.was > d1.now) s1.textContent = fmt(d1.was - d1.now) + ' OFF';
    var p2 = $('#agcTpill2'); if (p2 && d2.was != null && d2.now != null && d2.was > d2.now) p2.textContent = fmt(d2.was - d2.now) + ' OFF';   /* Pedro 2026-09-19: "$X OFF" en vez de "Ahorras $X" (solo filas) */
  }
  function paintRow3() {
    if (!ROWS()) return;
    var row = document.querySelector('#agcTiers .agc-tieropt[data-tier="3"]'); if (!row) return;
    var n = Math.max(3, state.tier), d = dealFor(n);
    var lb = row.querySelector('.agc-tlabel'); if (lb) lb.textContent = n + ' Baños';
    paintRowsMarginal();
    var sb = row.querySelector('.agc-trow-sub'); if (sb && n > 3 && d.now != null) sb.innerHTML = 'Cada ducha en <b>' + fmt(d.now / n) + '</b>';
    var of = $('#agcTrowOff3'); if (of) of.textContent = d.off || '';
    var tt = $('#agcTrowTotal3'); if (tt) tt.textContent = d.now != null ? fmt(d.now) : '';
    var ws = $('#agcTrowWas3'); if (ws) ws.textContent = (d.was != null && d.now != null && d.was > d.now) ? fmt(d.was) : '';
    var pl = $('#agcTpill3'); if (pl && d.was != null && d.now != null && d.was > d.now) pl.textContent = fmt(d.was - d.now) + ' OFF';
    var q = document.querySelector('#agcMore .agc-more-q'); if (q) q.textContent = '¿Cuántos baños?';
  }
  function paintRowsReceipt() {
    var n = Math.max(1, state.tier);
    var lbF = $('#agcRowsReceiptFiltroLb');
    if (lbF) lbF.textContent = 'Filtro Inicial' + (n > 1 ? ' ×' + n : '');
    var svF = $('#agcRowsReceiptFiltroSv');
    if (svF) {
      var unit = CFG.filtroCompare || 59000;
      svF.innerHTML = '<s>' + fmt(unit) + (n > 1 ? ' × ' + n : '') + '</s> <b>$0</b>';
    }
    var lbR = $('#agcRowsReceiptRenewLb');
    if (lbR) lbR.textContent = (n > 1 ? 'Filtros nuevos' : 'Filtro nuevo');
  }
  /* Sin argumentos a propósito: se llama desde render() y TAMBIÉN al quitar/poner Care en el
     paso de color, donde render() no corre. Si dependiera de un `t` prestado, quitar Care
     dejaría el ahorro inflado en $9 — un número mentiroso, que es justo lo que no queremos. */
  function renderCupon() {
    /* Blindado: la card ya NO se pinta en render(), así que un tropiezo leyendo cupones la
       dejaría sin precio. Peor caso ahora = precio sin descuento, nunca en blanco. */
    try { chequeaCupon(); } catch (e) { }
    var act = cuponesActivos();
    /* base = lo que el cliente ve en la card + los add-ons que ya marcó. El filtro inicial va
       en $0 y no suma. Los cupones pegan sobre todo el pedido (target:'all'); el % se calcula
       sobre el subtotal SIN restar los fijos — así lo hace el checkout de Shopify (verificado
       2026-08-16: $1780 − 10% − $100 = $1502). */
    var base = (totals() || {}).today || 0;
    /* Care entra al dinero SOLO en el paso 2 (Pedro 2026-08-19 v3): su fila vive ahí. En el
       paso 1 ni el Subtotal ni el Total lo cargan — cada pantalla suma exactamente lo que
       muestra; el paso 2 (donde se paga) queda idéntico al checkout. */
    var careMoney = (careRowOn() && state.careSel && CC.carePrice && (state.step === 'color' || state.step === 'anual')) ? CC.carePrice : 0;   /* anual = paso siguiente al de color: Care ya elegido sigue en el Total (lo cobra buildBaseItems) */
    base += careMoney;
    if (careRowOn() && state.tapeteSel && CC.tapetePrice && state.tier < 2) base += CC.tapetePrice;
    if (!anivOn() && state.ritualSel && CFG.anual) base += (ritPaid().price || 0) * Math.max(1, state.tier);
    /* Modo aniversario (dormido hoy): el step mete el Set Anual y Care como items propios
       (buildBaseItems). Si el aniversario se re-enciende sin estas dos líneas, el Total
       mostraría MENOS de lo que cobra el checkout — mentira de dinero. Misma fórmula de
       qty que el stepItem. */
    if (anivOn() && state.anual && CFG.anual) base += (CFG.anual.price || 0) * Math.max(1, Math.min(state.anualQty || state.tier, state.tier));
    if (anivOn() && state.careSel && CC.carePrice) base += CC.carePrice;
    var save = 0, sinValor = false, i, sv;
    for (i = 0; i < act.length; i++) {
      sv = 0;
      if (act[i].minimumSubtotal && base < act[i].minimumSubtotal) sinValor = true;
      else if (act[i].pct) sv = Math.round(base * act[i].pct / 100);
      else if (act[i].amt) sv = act[i].amt;
      else sinValor = true; /* código de sesión sin valor conocido aún (carrito vacío) */
      save += sv;
    }
    /* El ahorro también baja al precio grande de la card (Pedro 2026-09-11): antes solo vivía
       en la línea de Total y el cliente seguía viendo $2580 con el código ya aplicado. Se
       reparte A PRORRATA porque el cupón pega sobre TODO el pedido (target:'all'): la card
       solo puede mostrar la parte que le toca. Con cupones de % puro esto da exactamente el
       mismo número que aplicarle el % a su propio precio; con montos fijos reparte sin inflar.
       Sin código (o código sin valor conocido) → 0 y la card vuelve a su precio normal. */
    /* NINGÚN descuento (automático ni código) baja la tarjeta, los tiers, el c/u, "Ahorras" ni la barra
       (Pedro 2026-09-14: "lo que quiero es que se muestre 1,810, los descuentos solo quedan en código
       aplicado"). Viven únicamente en la línea de aplicado y en el Total, que es lo que cobra el checkout.
       Supersede el reparto a la card del 2026-09-11. */
    paintDeal(0);
    try { paintTierFraming([]); } catch (e) { }
    try { paintRow3(); } catch (e) { }   /* MOCK filas: la fila 3 puede ser 4/5/6; que el framing no le regrese el ahorro de 3 */
    /* TOTAL (N) — SIEMPRE visible, con o sin cupón: el cliente no suma de cabeza.
       base − ahorro = exactamente lo que verá en el checkout (mismo cálculo de arriba,
       verificado contra Shopify). Se pinta ANTES del early-return del cupón.
       N = items físicos que se lleva (v4, Pedro 2026-08-19: el Subtotal saturaba — fuera;
       su conteo vive aquí): ducha 1 c/u · Set Anual 3 c/u (sus 3 filtros, valor visible) ·
       tapete 1 · Care 0 (no cuenta como item). El Filtro Inicial tampoco: ya vive dentro
       de la card de la ducha como "Incluido". */
    var items = Math.max(1, state.tier);
    if (!anivOn() && state.ritualSel && CFG.anual) items += 3 * Math.max(1, state.tier);
    if (anivOn() && state.anual && CFG.anual) items += 3 * Math.max(1, Math.min(state.anualQty || state.tier, state.tier));
    if (careRowOn() && (state.tapeteSel || state.tier >= 2)) items += Math.max(1, giftTapQty());
    var totEl = $('#agcTotalAmt'), totLine = $('#agcTotalLine');
    var tlb = $('#agcTotLb'); if (tlb) tlb.textContent = 'Total (' + items + ')';
    if (totEl) totEl.textContent = fmt(Math.max(0, base - save));
    if (totLine) totLine.hidden = false;
    /* Línea VIVA de Care (v5) — solo paso 2, CON o SIN código, activo o no: es el control
       único de Care ahora que la card grande está oculta. is-on pinta verde/estado por CSS;
       la tachita es proxy del botón real (#agcCareRowBtn). */
    var careLine = $('#agcCareLine');
    if (careLine) {
      if (careRowOn() && (state.step === 'color' || state.step === 'anual') && CC.carePrice) {
        careLine.classList.toggle('is-on', !!state.careSel);
        var cam = $('#agcCareLineAmt'); if (cam) cam.textContent = fmt(CC.carePrice);
        var cbx = $('#agcCareLineBtn'); if (cbx) cbx.setAttribute('aria-label', (state.careSel ? 'Quitar' : 'Agregar') + ' Aguacero Care');
        var cdt = $('#agcCareLineDet'); if (cdt) cdt.textContent = state.careSel
          ? 'Robo, daño o pérdida: te la reponemos. Garantía a 100 días.'
          : 'Sin ella tu garantía queda en 60 días.';
        careLine.hidden = false;
      } else {
        careLine.hidden = true;
        var cdh = $('#agcCareLineDet'); if (cdh) cdh.hidden = true;
      }
    }
    var subLine = $('#agcCupSubRow'), subAmt = $('#agcCupSubAmt'), subLb = $('#agcCupSubLb');
    /* STACK v3 (Pedro 2026-09-22): Subtotal SIEMPRE y con el PRECIO COMPLETO; "Descuento aplicado" resta lo
       que Kaching (RITUAL-A0) quita a las duchas (deal.was − deal.now, mismo número que el checkout); los
       códigos de verdad van en su línea de siempre; el Total enseña el ahorro real. */
    var dd = dealFor(Math.max(1, state.tier)) || {};
    var dealSave = (dd.was != null && dd.now != null && dd.was > dd.now) ? (dd.was - dd.now) : 0;
    var _upL = colorUpSel(Math.max(1, state.tier)); if (_upL && dealSave) dealSave += _upL - colorUpNow(_upL, Math.max(1, state.tier));   /* el recargo del acabado también lleva el % del deal (Kaching descuenta sobre el variant) */
    if (subLine && subAmt) {
      if (subLb) subLb.textContent = 'Subtotal (' + items + ')';
      subAmt.textContent = fmt(base + dealSave);
      subLine.hidden = false;
    }
    var ddl = $('#agcDealDisc');
    if (ddl) {
      var ddc = $('#agcDealDiscCode'), dds = $('#agcDealDiscSave');
      if (ddc) ddc.textContent = CFG.dealLabel || dd.off || '';
      if (dds) dds.textContent = 'Ahorras ' + fmt(dealSave);
      ddl.hidden = !dealSave;
    }
    var box = $('#agcDealCup'); if (!box) return;
    if (!act.length) { box.hidden = true; return; }
    /* Sin "al pagar" (Pedro 2026-08-16): esos ~55px le dan aire al segundo código.
       Excepción: código sin valor conocido (carrito vacío) → no hay monto que afirmar. */
    var el = $('#agcDealCupSave'); if (el) el.textContent = (sinValor && !save) ? 'Se refleja al pagar' : 'Ahorras ' + fmt(save);
    /* Códigos junto a la etiqueta: salen del registro, nunca hardcodeados. Si el JS no corre,
       la etiqueta se queda en "Código aplicado" y nada se rompe. */
    var lb = $('#agcDealCupLb'); if (lb) lb.textContent = act.length > 1 ? 'Códigos' : (act[0].auto ? 'Descuento' : 'Código')   /* Pedro 22-sep: "aplicado" es ruido */;
    var lbc = $('#agcDealCupCode');
    if (lbc) {
      /* 2026-09-21 (Pedro): cada código en un chip (.agc-cupchip). El nombre viene de Shopify; se escapa igual. */
      var full = '', k;
      for (k = 0; k < act.length; k++) full += (k ? ' + ' : '') + '<span class="agc-cupchip">' + String(act[k].code).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }) + '</span>';
      lbc.innerHTML = full;
    }
    box.hidden = false;
    /* UNA sola línea SIEMPRE (Pedro 2026-08-16): medir el hueco real y degradar — mismo patrón
       del timer del nav. Se mide DESPUÉS de des-ocultar (hidden mide 0). El CSS trae ellipsis
       de red de seguridad por si ni la forma corta cabe. */
    var wrap = lbc ? lbc.parentNode : null;
    if (wrap && act.length > 1 && wrap.scrollWidth > wrap.clientWidth + 1) {
      lbc.textContent = act[0].code + ' +' + (act.length - 1);
    }
  }

  /* ── CARE COMO FILA (Pedro 2026-08-11) ──────────────────────────────────────
     El step dedicado de Care desaparece: la protección llega YA MARCADA dentro del paso
     de color (#agcCareRow) y se quita en un tap. El flujo queda tiers → color → pago.
     ROLLBACK = false: vuelve el step intacto (markup, CSS y handlers siguen vivos).
     Nunca aplica en aniversario — ahí el step es del Ritual y Care vive en #agcCareCard.
     Lee CFG.cart directo (no CC) para poder llamarse desde cfgTrack, que corre antes. */
  var CARE_AS_ROW = true;
  function careRowOn() {
    return CARE_AS_ROW && !anivOn() && !!(CFG.cart && CFG.cart.careVariant) && !!root.querySelector('#agcCareRow');
  }
  /* ANIVERSARIO: pinta la card de Care (add-on) + el step del Ritual (qty/precios).
     El Ritual vive en el STEP (más intención); Care baja a la card. Pedro 2026-07-30. */
  function renderAniv() {
    if (!anivOn()) return;
    var n = state.tier;
    if (!state.anualQtyTouched || state.anualQty == null || state.anualQty > n) state.anualQty = n;
    var q = state.anualQty;
    /* card de Care */
    var cc = $('#agcCareCard');
    if (cc) { cc.classList.toggle('is-on', !!state.careSel); cc.setAttribute('aria-pressed', state.careSel ? 'true' : 'false'); }
    /* step del Ritual: precios × q */
    var px = (CFG.anual.price || 0) * q, was = (CFG.anual.compare || 0) * q;
    var cta = $('#agcRitCtaPx'); if (cta) cta.textContent = '+' + fmt(px);
    var hero = $('#agcRitHeroPx'); if (hero) hero.textContent = fmt(px);
    var heroW = $('#agcRitHeroWas'); if (heroW) { heroW.textContent = fmt(was); heroW.style.display = was > px ? '' : 'none'; }
    var heroSave = $('#agcRitHeroSave');
    if (heroSave) heroSave.textContent = (was > px)
      ? '3\u00d72 \u00b7 Ahorras ' + fmt(was - px)
      : 'Un solo pago \u00b7 sin cobros al mes';   /* fallback si el compare a\u00fan no est\u00e1 puesto: nunca "Ahorras $0" */
    /* selector ¿para cuántas duchas? — solo T2/T3 */
    var row = $('#agcAnivQtyRow'), btns = $('#agcAnivQtyBtns');
    if (row && btns) {
      var show = n > 1;
      row.hidden = !show;
      if (show && btns.dataset.n !== String(n)) {
        btns.dataset.n = String(n); btns.innerHTML = '';
        for (var k = 1; k <= n; k++) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'agc-aniv-q'; b.dataset.q = k; b.textContent = k;
          btns.appendChild(b);
        }
      }
      if (show) Array.prototype.forEach.call(btns.children, function (b) {
        b.classList.toggle('on', Number(b.dataset.q) === q);
      });
    }
  }
  /* TIERS 4-6 (Pedro 2026-08-11): no tienen deal propio en CFG.deals (que solo define 1-3).
     El precio por ducha se APLANA en el del último tier definido — es lo que el carrito cobra de
     verdad: a qty 5 el descuento automático RITUAL-A0 deja $1690/ducha, idéntico al tier 3
     (verificado contra /cart/add.js el 2026-08-11). Derivarlo del último deal hace que siga sola
     a la promo vigente (aniversario o baseline) en vez de hardcodear un precio. */
  function dealFor(tier) {
    /* Compra única (switch OFF y sin Set Anual) = dealsOnce 15/20/25; con suscripción o con Set = deals 30/35/40 (Pedro 2026-09-22: "incentivar por prender la suscripción") */
    var ds = (state.subOff && !state.ritualSel && CFG.dealsOnce) ? CFG.dealsOnce : (CFG.deals || []);
    if (ds[tier - 1]) return ds[tier - 1];
    var base = ds.length, last = ds[base - 1];
    if (!last || last.now == null || last.was == null) return {};
    var filtros = (CFG.renewUnit || 0) * tier;
    return {
      title: tier + 'x Ducha + Filtro',
      off: last.off,
      inc: '',
      sub: '+ Filtros nuevos cada 3 meses · ' + fmt(filtros),
      now: Math.round((last.now / base) * tier),
      was: Math.round((last.was / base) * tier)
    };
  }
  function tierPricing(tier) {
    /* OFERTA (Pedro 2026-06-26): si el deal define precio promo (now/was), se usa para DISPLAY. ⚠️ el cobro real lo aplica el selling plan de Shopify — deben cuadrar (planes 30/30/42). */
    var d = dealFor(tier);
    if (d.now != null && d.was != null) return { gross: d.was, final: d.now };
    var base = colorByKey(state.colorKey).price; // centavos, precio lista
    var pl = (CFG.tierPlans && CFG.tierPlans[tier - 1]) ? CFG.tierPlans[tier - 1] : null;
    var pct = pl ? pl.pct : CFG.subPct;
    var gross = base * tier;
    var final_ = Math.round(gross * (1 - pct / 100));
    return { gross: gross, final: final_ };
  }
  function renewCents(tier) {
    var base = colorByKey(state.colorKey).price;
    return Math.round(base * (1 - CFG.renewPct / 100)) * tier;
  }
  /* RECARGO POR ACABADO (Pedro 22-sep): el precio de lista de cada color sale del variant en Shopify.
     Base = el acabado más barato. El extra entra con el mismo % del deal (Kaching descuenta igual
     sobre el variant), así la card cuadra con el checkout. Solo suma lo elegido; los botones de
     tier y el "desde" siguen en base. */
  function colorBase() { var m = null; (CFG.colors || []).forEach(function (c) { if (c.price != null && (m == null || c.price < m)) m = c.price; }); return m || 0; }
  function colorUpList(key) { var c = colorByKey(key); return c && c.price != null ? Math.max(0, c.price - colorBase()) : 0; }
  /* escalera 2026-10-13: un deal con `fijo` (centavos por ducha, T1 «1 DUCHA $1790» = $790) descuenta monto, no %: el recargo del acabado va completo */
  function colorUpNow(listCents, tier) { var d = dealFor(tier); return (d && d.fijo) ? listCents : (d && d.now != null && d.was) ? Math.round(listCents * d.now / d.was) : listCents; }
  function colorUpSel(tier) {
    var ks = (state.colors && state.colors.length) ? state.colors.slice(0, tier) : [state.colorKey], L = 0;
    for (var i = 0; i < ks.length; i++) L += colorUpList(ks[i]);
    return L;
  }
  function totals() {
    var t = tierPricing(state.tier);
    var upL = colorUpSel(state.tier), upN = colorUpNow(upL, state.tier);
    return { today: t.final + upN, gross: t.gross + upL, renew: renewCents(state.tier) };
  }

  /* ── showroom escena 0: filmstrip ancho derivando (2 copias seamless) + tinte ── */
  var strip = $('#agcStrip');
  var hotTrack = $('#agcHeroHotsTrack');
  var stripBuilt = {};
  /* drift JS-driven (auto-drift + swipe manual) · 3 copias = loop infinito seamless bidireccional */
  var COPIES = 3;
  var heroOffset = 0, heroCopyW = 0, heroDragging = false, heroResumeAt = 0, heroInit = false, heroPaused = false, heroFling = 0, heroLastNow = 0;
  /* TEST (Pedro 2026-06-23): INTRO estático navegado por flecha. heroTour es ESTADO DERIVADO (reversible),
     no un flag de una vía: evalHeroMode() lo recalcula cada frame desde el estado real. tour = reposo escena-0
     (flecha + estático); drift = card/cart/3D/menú abierto o scroll a la narrativa. Al volver atrás re-entra
     el tour (flecha reaparece + re-centra bullet). El cambio de color con las islas NO anima (swap en sitio,
     estático). Ver atScene0Rest/setHeroTour/evalHeroMode. */
  var heroTour = true, heroTweening = false, heroTweenTo = 0;
  function buildStrip(key) {
    if (!strip) return;
    var src = (CFG.heroStrips && CFG.heroStrips[key]);
    if (!src) return;
    strip.innerHTML = '';
    heroCopyW = 0; heroInit = false; /* recalcular tras swap de color */
    for (var i = 0; i < COPIES; i++) {
      var im = document.createElement('img');
      im.src = src;
      im.alt = '';
      im.loading = 'eager'; /* misma URL → cacheada; deben tener ancho para el loop */
      if (key === firstAvail.key && i === 0) im.fetchPriority = 'high';
      strip.appendChild(im);
    }
    stripBuilt[key] = true;
  }
  function heroDrift() {
    if (strip) {
      evalHeroMode();   /* deriva tour↔drift del estado real cada frame (reversible) */
      if (!heroCopyW && strip.scrollWidth > 0) heroCopyW = strip.scrollWidth / COPIES;
      if (heroCopyW && !heroInit) { heroOffset = -heroCopyW; heroInit = true; if (heroTour) requestAnimationFrame(function () { centerToBullet(0); }); } /* centra en copia media; en intro centra el 1er bullet */
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      /* delta-time: animación por TIEMPO, no por frame → misma velocidad en cualquier FPS (Chrome, in-app Meta/IG, ProMotion 120Hz) */
      var dt = heroLastNow ? Math.min(now - heroLastNow, 50) : 16.67; heroLastNow = now;
      var fr = dt / 16.67; /* factor vs 60fps */
      if (heroTour) {
        /* INTRO estático: sin auto-drift; tween suave hacia el bullet objetivo (flecha / snap de swipe) */
        if (!heroDragging && heroTweening) {
          heroOffset += (heroTweenTo - heroOffset) * Math.min(1, 0.26 * fr);   /* 0.16→0.26 (Pedro 2026-07-03): menos cola lenta al llegar al lock del paso color */
          if (Math.abs(heroTweenTo - heroOffset) < 1) { heroOffset = heroTweenTo; heroTweening = false; }
        }
      } else if (!heroDragging && !heroPaused) {
        /* CONFIGURANDO (Pedro 2026-09-15): auto-drift hacia la izquierda detrás del vidrio, misma velocidad que el theme viejo. */
        if (heroTweening) {
          heroOffset += (heroTweenTo - heroOffset) * Math.min(1, 0.26 * fr);
          if (Math.abs(heroTweenTo - heroOffset) < 1) { heroOffset = heroTweenTo; heroTweening = false; }
        } else if (heroCopyW) heroOffset -= (heroCopyW / 2568) * fr;
      }
      if (heroCopyW && !heroTweening) { /* mantener offset en [-2W, -W): copia media siempre llena. NO normalizar a media-tween (rompe el centrado del bullet); las copias son idénticas → el snap por W es invisible */
        while (heroOffset <= -2 * heroCopyW) heroOffset += heroCopyW;
        while (heroOffset > -heroCopyW) heroOffset -= heroCopyW;
      }
      /* translate3d → capa GPU dedicada: el drift se compositea en hardware, suave en TODOS los browsers
         (Chrome, Safari, in-app Meta/IG/TikTok). Con translateX 2D el webview rasterizaba en CPU → "mini pasitos". Pedro 2026-06-23 */
      strip.style.transform = 'translate3d(' + heroOffset + 'px,0,0)';
      if (hotTrack) hotTrack.style.transform = 'translate3d(' + heroOffset + 'px,0,0)'; /* los hotspots viajan con las imágenes */
    }
    cfgFrame(heroDrift);
  }
  cfgFrame(heroDrift);
  /* ── INTRO: flecha glassy → centra el siguiente bullet. INDEX-based (determinista): cada hotspot tiene su
     left% conocido; el target absoluto centra esa fracción de la copia media (heroOffset = cx − copyW·(1+f)). ── */
  var tourIdx = 0;
  function nBullets(hots) { return Math.round(hots.length / 3) || 8; }   /* 3 copias del strip */
  function centerToBullet(i, dir) {
    var hots = $$('#agcHeroHots .agc-hh'); if (!hots.length || !heroCopyW) return;
    var n = nBullets(hots); tourIdx = ((i % n) + n) % n; dir = dir || 0;
    /* de las 3 instancias del bullet tourIdx (copias): dir>0 → la más cercana a la DERECHA (loop hacia la derecha, sin rebobinar al pasar último→primero); dir<0 → la más cercana a la IZQUIERDA; dir=0 → la más cercana (snap/lock). Pedro 2026-06-25 */
    var cx = window.innerWidth / 2, best = null, bd = Infinity, k, r, off, d;
    for (k = tourIdx; k < hots.length; k += n) {
      r = hots[k].getBoundingClientRect(); if (!r.width) continue;
      off = r.left + r.width / 2 - cx;
      if (dir > 0) { if (off <= 4) continue; d = off; }        /* solo instancias a la derecha */
      else if (dir < 0) { if (off >= -4) continue; d = -off; } /* solo a la izquierda */
      else d = Math.abs(off);
      if (d < bd) { bd = d; best = r; }
    }
    if (!best) { /* sin instancia en la dirección pedida (borde de las copias) → la más cercana */
      bd = Infinity;
      for (k = tourIdx; k < hots.length; k += n) { r = hots[k].getBoundingClientRect(); if (!r.width) continue; d = Math.abs(r.left + r.width / 2 - cx); if (d < bd) { bd = d; best = r; } }
    }
    if (!best) return;
    /* target ABSOLUTO: heroTweenTo = cx − stripX_bullet (independiente del offset actual → estable mid-tween) */
    /* (revertido 2026-06-27: el shift -26 del 1er bullet descentraba el bullet en mobile; default = dot en el centro) */
    heroTweenTo = heroOffset + (cx - (best.left + best.width / 2));
    heroTweening = true;
  }
  function centerNextHotspot() { if (heroTour && heroCopyW) centerToBullet(tourIdx + 1, 1); }
  function snapNearestBullet() {
    var hots = $$('#agcHeroHots .agc-hh'); if (!hots.length) return;
    var n = nBullets(hots), cx = window.innerWidth / 2, best = -1, bd = Infinity;
    hots.forEach(function (h, k) { var r = h.getBoundingClientRect(); if (!r.width) return; var d = Math.abs(r.left + r.width / 2 - cx); if (d < bd) { bd = d; best = k; } });
    if (best >= 0) centerToBullet(best % n);
  }
  /* ── ESTADO derivado (reversible): tour = reposo de la escena 0; drift = configurando ── */
  function atScene0Rest() {
    return onScene0()
      && !root.classList.contains('cfg-open')      /* card expandido */
      && !root.classList.contains('cart-mode')     /* carrito */
      && !root.classList.contains('show-3d')       /* vista 3D */
      && !document.documentElement.classList.contains('agcn-open'); /* menú */
  }
  function setHeroTour(on) {
    if (on === heroTour) return;
    heroTour = on; heroTweening = false; heroLastNow = 0;
    root.classList.toggle('hero-configuring', !on);    /* CSS: oculta/muestra la flecha */
    if (on) snapNearestBullet();                        /* volver al intro → re-centra el bullet más cercano + reaparece la flecha */
    /* entrar a configurar: el fondo SIGUE deslizándose detrás del vidrio (Pedro 2026-09-15, material del theme viejo;
       supersede el lock estático del 2026-06-24). */
  }
  /* fuente única de verdad: se llama cada frame desde heroDrift → captura TODA transición
     (scroll, abrir/cerrar card-cart-3D-menú, volver atrás). El cambio de color con las islas de
     variante NO anima: setHeroColor swapea el color EN SITIO y el showroom se queda estático (Pedro 2026-06-23). */
  function evalHeroMode() { setHeroTour(atScene0Rest()); }
  var heroArrow = $('#agcHeroArrow');
  /* pointerdown (no click): dispara al PRESIONAR → no depende de dónde suelta el cursor (el botón se reposiciona cada frame por el drift del hero + el :active; con click, soltar en la orilla caía fuera). stopPropagation: que no lo secuestre el drag del hero. Pedro 2026-07-08. */
  if (heroArrow) heroArrow.addEventListener('pointerdown', function (e) { e.stopPropagation(); centerNextHotspot(); });
  /* click en cualquier bullet → centrar su escena (Pedro 2026-07-03) */
  var heroHotsEl = $('#agcHeroHots');
  if (heroHotsEl) heroHotsEl.addEventListener('click', function (e) {
    if (e.target.closest('[data-revbtn]')) return;   /* el botón Ver reseñas conserva su acción */
    var h = e.target.closest('.agc-hh'); if (!h || !heroTour || !heroCopyW) return;
    var hots = $$('#agcHeroHots .agc-hh'), k = hots.indexOf(h);
    if (k >= 0) centerToBullet(k % nBullets(hots));
  });
  var heroArrowPrev = $('#agcHeroArrowPrev');
  if (heroArrowPrev) heroArrowPrev.addEventListener('pointerdown', function (e) { e.stopPropagation(); if (heroTour && heroCopyW) centerToBullet(tourIdx - 1, -1); });
  /* SPEED (2026-06-24): NO precargar las 8 imágenes (2.35MB) en el critical path del boot — el strip activo ya entra por el preload del LCP. Los otros 3 colores + las 4 galerías "elegir" se decodifican al PRIMER pointerdown en el configurador (= intención de configurar) o en idle tardío (4s, fuera del critical path). Así el swap de color y la galería siguen instantáneos tras la 1ª interacción, sin pesar en el LCP. */
  var _cfgPreloaded = false;
  function preloadConfigAssets() {
    if (cfgFlow) return;
    if (_cfgPreloaded) return; _cfgPreloaded = true;
    if (CFG.heroStrips) Object.keys(CFG.heroStrips).forEach(function (k) { var p = new Image(); p.src = CFG.heroStrips[k]; if (p.decode) p.decode().catch(function () {}); });
    if (CFG.elegirStrips) Object.keys(CFG.elegirStrips).forEach(function (k) { var p = new Image(); p.src = CFG.elegirStrips[k]; if (p.decode) p.decode().catch(function () {}); });
  }
  /* dispara en la PRIMERA interacción real (scroll/tap) — NO en idle (requestIdleCallback dispara a ~1-2s y volvía a competir con el LCP). Si el usuario rebota sin interactuar, nunca se descargan los 2.35MB. */
  ['pointerdown', 'touchstart', 'scroll'].forEach(function (ev) { window.addEventListener(ev, preloadConfigAssets, { once: true, passive: true }); });
  function setHeroColor(key) {
    $$('.agc-htint').forEach(function (t) { t.classList.toggle('on', t.classList.contains('h-' + key)); });
    if (!strip) return;
    var src = (CFG.heroStrips && CFG.heroStrips[key]);
    if (!src) return;
    var imgs = strip.querySelectorAll('img');
    if (!imgs.length) { buildStrip(key); return; }
    /* swap de src EN SITIO — layout idéntico → la animación NO se reinicia, solo cambia el color */
    for (var i = 0; i < imgs.length; i++) { if (imgs[i].getAttribute('src') !== src) imgs[i].src = src; }
  }

  /* ── HERO DE FOTOS (LIVE 2026-09-20 · Pedro: "nos elevamos como marca") ─────────────────────
     8 fotos con personas en scroll-snap horizontal. Todo vive detrás de STORY(): sin la clase
     agc-hero-story este bloque sale en la primera línea y el hero renderizado queda intacto.
     Convivencia con el hero viejo: #agcStrip queda display:none → strip.scrollWidth = 0 →
     heroCopyW = 0 → centerToBullet/centerNextHotspot (las flechas de siempre) son no-op solos.
     setHeroColor solo toca .agc-htint y las img de #agcStrip, ambos ocultos: el color de la isla
     NO re-renderiza ni parpadea las fotos (Pedro 2026-09-19). ───────────────────────────────── */
  (function () {
    if (!STORY()) return;
    var wrap = $('#agcStory'), rail = $('#agcStoryRail');
    if (!wrap || !rail) return;
    var slides = $$('#agcStoryRail .agc-sty-slide');
    var cards = $$('#agcStoryRail .agc-sty-card');
    var styDots = $$('.agc-dots b');
    var N = slides.length;
    if (!N) return;
    var cur = -1, autoTimer = 0, idleTimer = 0, styRaf = 0, visto = {}, via = '', viaAt = 0, asomo = { n: 0, t: 0, fin: false };
    var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

    /* La card cuelga del dot. Si el dot está pegado a un borde (escena 2: 68%), se corre con --hhx
       para que quepa completa, igual que hace el carrusel viejo. Pedro 2026-09-20. */
    function clampCard(i) {
      var card = cards[i], hot = card && card.parentNode; if (!card || !hot) return;
      /* El titular centrado de la escena 2 (--sm) cabe siempre (240px en ≥375px): no se desplaza ni se voltea. */
      if (card.classList.contains('agc-sty-card--sm')) { card.style.setProperty('--hhx', '0px'); return; }
      /* En coordenadas de LAYOUT, no de pantalla: medir con getBoundingClientRect mientras el riel
         se desliza devuelve posiciones de otra slide (medido 2026-09-20: hhx de 1,289px). */
      var w = rail.clientWidth || wrap.clientWidth; if (!w) return;
      card.style.setProperty('--hhx', '0px'); card.style.maxWidth = '';
      var cw = card.offsetWidth, hx = hot.offsetLeft, m = 12, dx = 0;   /* offsetLeft = centro (translate -50%) */
      if (hx - cw / 2 < m) dx = m - (hx - cw / 2);
      else if (hx + cw / 2 > w - m) dx = (w - m) - (hx + cw / 2);
      /* Vertical: el texto NUNCA puede quedar debajo del riel de colores ni de la isla
         (Pedro 2026-09-20: "el texto de la 2da imagen quedó escondido detrás de islas"). Si no cabe
         bajo el punto, la card se voltea y sale arriba. */
      card.classList.remove('is-up');
      var rail2 = document.querySelector('.agc-toprail'), isla = document.querySelector('.agc-island');
      var lim = 1e9;
      if (rail2) { var rr = rail2.getBoundingClientRect(); if (rr.height) lim = rr.top - 10; }
      if (isla) { var ir = isla.getBoundingClientRect(); if (ir.height) lim = Math.min(lim, ir.top - 10); }
      var wr = rail.getBoundingClientRect(), hy = hot.offsetTop;   /* px de layout (fullPlace coloca en px; con % daba 896 y volteaba siempre — 2026-09-21) */
      /* Solo se voltea si el punto vive en la mitad baja de la banda; con el punto arriba (escena 1)
         siempre hay lugar debajo y Pedro lo quiere SIEMPRE abajo (2026-09-20). */
      var up = wr.height && (hy / wr.height) > 0.30 && wr.top + hy + 11 + card.offsetHeight > lim;
      if (up) card.classList.add('is-up');
      /* La píldora del VSL ("10% EXTRA") flota sobre el hero y tapaba el arranque del texto en la
         escena 1: si se cruzan, la card se corre a la derecha de la píldora. Pedro 2026-09-20. */
      var tz = document.getElementById('agcVslpTeaser');
      if (tz && wr.height) {
        var tr = tz.getBoundingClientRect();
        if (tr.width) {
          var ch = card.offsetHeight;
          var top = up ? (wr.top + hy - 11 - ch) : (wr.top + hy + 11);
          var left = wr.left + hx - cw / 2 + dx;
          if (top < tr.bottom && top + ch > tr.top && left < tr.right + 26) {
            var avail = (wr.right - m) - (tr.right + 26);   /* +26: la píldora del VSL tiene sombra fuera de su caja */
            if (cw > avail && avail >= 165) { card.style.maxWidth = Math.floor(avail) + 'px'; cw = card.offsetWidth; }
            if (cw <= avail) dx = (tr.right + 26) - (wr.left + hx - cw / 2);
          }
        }
      }
      card.style.setProperty('--hhx', Math.round(dx) + 'px');
    }
    /* el espejo del header repite la foto activa: mismo src/srcset/object-position → el navegador
       reusa el archivo ya decodificado y no baja nada extra (Pedro 2026-09-20). */
    /* MOCK ?hero=full: fotos extendidas a pantalla completa. El original ocupa desde data-full-off (%)
       con escala data-full-sc del alto; el hotspot (que se midió sobre el recorte, cover por alto y
       ancho recortado al 79% centrado) se remapea una sola vez. */
    var FULL = root.classList.contains('agc-hero-full');
    /* Pedro 2026-09-20 (iPhone real): con Safari y sus barras el viewport es más corto que 0.46, la foto
       se recorta abajo y un punto en % del slide sube ~60px respecto a lo que señala. Los puntos se
       colocan en px de la FOTO MOSTRADA (cover, 50% 0%) y se recalculan en cada resize. */
    function fullGeom(sl) {
      var im = sl.querySelector('img'), W = sl.clientWidth, H = sl.clientHeight;
      var iw = parseFloat(im && im.getAttribute('width')) || 900, ih = parseFloat(im && im.getAttribute('height')) || 1957;
      var s = Math.max(W / iw, H / ih), dw = iw * s, dh = ih * s;
      /* object-position vertical (CSS; 30% en pantallas cortas): desplaza la foto mostrada y, con ella, los puntos */
      var op = (im && getComputedStyle(im).objectPosition || '50% 0%').split(' '), py = parseFloat(op[1]) || 0;
      return { W: W, H: H, ox: (W - dw) / 2, oy: /px$/.test(op[1] || '') ? py : (H - dh) * py / 100, dw: dw, dh: dh };
    }
    /* Pedro 2026-10-20 («la primera imagen desaparece»): con la hoja de compra abierta (scroll bloqueado) o con la página abajo,
       la barra de anuncios (fija) y el hero (arriba, fuera de pantalla) no comparten coordenadas; el centrado salía en 1235px y la foto
       se dibujaba fuera de la pantalla. El centrado solo se mide con el hero en su lugar; si quedó pendiente, se mide al volver. */
    var fullPend = false, fullRaf = 0;
    function fullPlace() {
      if (!cfgNear || !FULL) return;
      var reposo = cfgFlow || Math.abs(wrap.getBoundingClientRect().top) < 2;
      fullPend = !reposo;
      slides.forEach(function (sl) {
        var im = sl.querySelector('img'); if (!im || !im.dataset.fullSrcset) return;
        if (!im.dataset.fullOn) { im.dataset.fullOn = '1'; if (im.getAttribute('src')) { im.srcset = im.dataset.fullSrcset; im.src = im.dataset.fullSrc; } }
        /* data-full-center="a,b" (Pedro 2026-09-24): el grupo título+producto (a..b del alto del lienzo) se CENTRA en el hueco libre entre
           la barra de arriba y las islas sobre la tarjeta, midiendo en cada pantalla (Instagram, Safari, Chrome). Mueve foto y puntos juntos. */
        if (im.dataset.fullCenter && reposo) {
          var fc = im.dataset.fullCenter.split(','), g0 = fullGeom(sl), sr = sl.getBoundingClientRect(), zt = 0, zb = g0.H;
          var ann = document.querySelector('#agc-cfg .agc-annbar'), isl = document.querySelector('#agc-cfg .agc-island'), trl = document.getElementById('agcTopRail');
          if (ann) { var ar = ann.getBoundingClientRect(); if (ar.height) zt = ar.bottom - sr.top; }
          if (isl) { var ir = isl.getBoundingClientRect(); if (ir.height) zb = Math.min(zb, ir.top - sr.top - 12 - ((trl && trl.offsetHeight) || 36)); }
          var ga = parseFloat(fc[0]) * g0.dh, gb = parseFloat(fc[1]) * g0.dh, oy = Math.round((zt + zb) / 2 - (ga + gb) / 2);
          if (gb - ga > zb - zt - 16) oy = Math.round(zt + 8 - ga);   /* pantalla muy corta: el título nunca se mete bajo la barra de arriba */
          im.style.setProperty('object-position', '50% ' + oy + 'px', 'important');
        }
        var off = parseFloat(im.dataset.fullOff) || 0, sc = parseFloat(im.dataset.fullSc) || 1, g = fullGeom(sl);
        if (!g.W || !g.H) return;
        sl.querySelectorAll('.agc-sty-hot').forEach(function (h) {
          /* el hotspot se midió sobre el recorte (cover por alto, ancho al 79% centrado): se guarda una vez */
          if (!h.dataset.l) { h.dataset.l = parseFloat(h.style.left) || 50; h.dataset.t = parseFloat(h.style.top) || 30; }
          var lp = 10.5 + parseFloat(h.dataset.l) * 0.79, tp = off + parseFloat(h.dataset.t) * sc;
          h.style.left = Math.round(g.ox + lp / 100 * g.dw) + 'px';
          h.style.top = Math.round(g.oy + tp / 100 * g.dh) + 'px';
        });
      });
    }
    window.__agcFullPlace = fullPlace;   /* placeToprail lo vuelve a llamar cuando la tarjeta cambia de lugar (el centrado de la escena 1 depende de ella) */
    window.addEventListener('scroll', function () { if (fullPend && !fullRaf) fullRaf = requestAnimationFrame(function () { fullRaf = 0; if (fullPend) fullPlace(); }); }, { passive: true });
    whenCfgNear(function () {
      var active = cur < 0 ? 0 : cur;
      fullPlace();
      montaCerca(active);
      vidActiva(active);
      paintMirror(active);
    });
    var mir = $('#agcStoryMir'), mirImg = mir && mir.querySelector('img');
    function paintMirror(i) {
      if (!cfgNear || !mirImg) return;
      var im = slides[i] && slides[i].querySelector('img'); if (!im) return;
      var src = im.currentSrc || im.getAttribute('src');
      if (mirImg.getAttribute('src') !== src) { mirImg.src = src; }
      mirImg.style.objectPosition = im.style.objectPosition || '';
    }
    /* Rescate 2026-09-20 (Instagram se congeló por memoria): solo viven decodificadas la escena activa y sus
       vecinas; las demás sueltan src/srcset y se remontan al acercarse (la 7 es la tira, sin foto grande). */
    function montaCerca(i) {
      if (!cfgNear || !FULL) return;
      slides.forEach(function (sl, k) {
        var im = sl.querySelector('img[data-full-src]'); if (!im) return;
        var d = Math.min(Math.abs(k - i), N - Math.abs(k - i));
        if (d <= 1) { if (!im.getAttribute('src')) { im.srcset = im.dataset.fullSrcset; im.src = im.dataset.fullSrc; } }   /* object-position lo pone el CSS (media query en pantallas cortas) */
        else if (im.getAttribute('src')) { im.removeAttribute('srcset'); im.removeAttribute('src'); }
      });
    }
    /* Video por escena (staging 2026-09-21): solo la escena ACTIVA tiene src y reproduce; las demás sueltan el archivo (memoria). */
    var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* Red lenta o ahorro de datos (Pedro 2026-09-21: "urge que cargue rápido a todos"): sin video, se queda el póster.
       Señal nativa solo donde existe (Android/Chrome); en iOS no hay API y mandan los archivos ligeros (720p ~950 kbps). */
    var NOVID = false;
    try { var _nc = navigator.connection || navigator.webkitConnection; if (_nc && (_nc.saveData || /(^|\b)(slow-2g|2g)(\b|$)/.test(_nc.effectiveType || ''))) NOVID = true;   /* '3g' NO apaga: con 1.6 Mbps los archivos ligeros arrancan en ~2 s (medido 2026-09-21) */ } catch (e) { }
    /* Primer cuadro medido en el dispositivo real, una vez por escena y sesión (percentil 75 > promedio) */
    var vidT0 = {}, vidMedido = {};
    /* Corre `fn` con el hilo libre, a más tardar 2.5 s después. NO espera al `load` de la página: en LIVE ese evento llega
       a los ~65 s (592 peticiones, 22.7 MB medidos 2026-09-21) y la precarga nunca alcanzaba a servir. El configurador ya
       existe cuando esto corre; lo que falta cargar son apps y píxeles, que no deben bloquear al hero. */
    function cuandoOciosa(fn) {
      if (window.requestIdleCallback) requestIdleCallback(function () { fn(); }, { timeout: 2500 }); else setTimeout(fn, 1200);
    }
    function vidActiva(i) {
      if (!cfgNear || !FULL || NOVID) return;
      slides.forEach(function (sl, k) {
        var v = sl.querySelector('.agc-sty-vid'); if (!v) return;
        sl.classList.add('has-vid');
        if (!v.dataset.wired) { v.dataset.wired = '1'; v.addEventListener('playing', function () { sl.classList.add('vid-ready'); if (vidT0[k] && !vidMedido[k]) { vidMedido[k] = 1; try { cfgTrack('hero_vid_ttff', { scene: k + 1, ms: Math.round(performance.now() - vidT0[k]), src: (v.dataset.vidSrc || '').split('/').pop() }); } catch (e) { } } }); v.addEventListener('timeupdate', function () { if (v.currentTime > 0.05) sl.classList.add('vid-ready'); }); }
        var d = Math.min(Math.abs(k - i), N - Math.abs(k - i));
        if (k === i && cfgInView && !REDUCE && !root.classList.contains('cfg-open')) {
          if (!v.getAttribute('src')) { vidT0[k] = performance.now(); v.preload = 'auto'; v.src = v.dataset.vidSrc; v.load(); }
          else { v.preload = 'auto'; if (!vidT0[k]) vidT0[k] = performance.now(); }
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () { });
        } else if (d === 1 && !REDUCE) {
          /* Vecina: el archivo empieza a bajar ANTES del swipe (moov + primeros cuadros), sin decodificar ni reproducir.
             Antes bajaba de cero al llegar: 7 s en 4G bueno, 23 s en 4G malo (medido 2026-09-21). */
          sl.classList.remove('vid-ready'); try { v.pause(); } catch (e) { }
          /* la SIGUIENTE (hacia donde se navega) baja completa; la anterior solo cabecera. Y SOLO cuando la página
             ya cargó y está ociosa: si arranca junto con la página, le roba ancho de banda a todo lo demás (medido 2026-09-21). */
          var sig = (k === (i + 1) % N);
          cuandoOciosa(function () {
            if (cur !== i) return;   /* ya se movió: la nueva escena activa decide sus vecinas */
            if (!v.getAttribute('src')) { v.preload = sig ? 'auto' : 'metadata'; v.src = v.dataset.vidSrc; v.load(); }
            else if (sig && v.preload !== 'auto') { v.preload = 'auto'; }
          });
        } else {
          sl.classList.remove('vid-ready');   /* al volver, el poster cubre hasta que el video vuelva a correr */
          try { v.pause(); } catch (e) { }
          if (v.getAttribute('src')) { v.removeAttribute('src'); v.load(); }
        }
      });
    }
    window.__agcVidActiva = function () { vidActiva(cur < 0 ? 0 : cur); };   /* setMode (fuera de este IIFE) pausa/reanuda al abrir o cerrar la isla */
    function setActive(i) {
      i = ((i % N) + N) % N;
      clampCard(i);   /* siempre: la píldora del VSL aparece DESPUÉS del primer pintado */
      if (i === cur) return;
      cur = i;
      montaCerca(i);
      vidActiva(i);
      paintMirror(i);
      slides.forEach(function (sl, k) { sl.classList.toggle('is-on', k === i); });
      if (i === revSlide) revStart(); else revStop();
      if (s2Head && slides[i].contains(s2Head)) { requestAnimationFrame(s2Coloca); setTimeout(s2Coloca, 600); }
      var blurEl = $('#agcStoryBlur'), imB = slides[i].querySelector('img');
      if (blurEl && imB && imB.dataset.blurSrc && blurEl.getAttribute('src') !== imB.dataset.blurSrc) blurEl.src = imB.dataset.blurSrc;
      clampCard(i);
      styDots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      /* medición (Pedro 2026-10-11: «hacerlo obvio que hay más slides»): la PRIMERA vez que se ve cada escena en esta carga y cómo se llegó.
         La escena 1 no se cuenta (es la de entrada); el denominador es cfg_view. */
      if (i > 0 && !visto[i]) { visto[i] = 1; try { cfgTrack('cfg_hero_slide', { scene: i + 1, via: via && Date.now() - viaAt < 1500 ? via : 'swipe', asomo: asomo.n }); } catch (e) { } }
    }
    function goTo(i, smooth) {
      i = ((i % N) + N) % N;
      rail.scrollTo({ left: i * rail.clientWidth, behavior: (smooth && !reduce) ? 'smooth' : 'auto' });
      setActive(i);
    }
    /* loop 8→1 (y 1→8) con salto SIN animación: rebobinar 8 pantallas se ve como un glitch */
    function next() { if (cur >= N - 1) goTo(0, false); else goTo(cur + 1, true); }

    /* ── Escena de reseñas v3: tira de baños + frases (Pedro 2026-09-20). Se coloca midiendo el hueco
       entre la barra de anuncios y el riel; la tira se encoge si el hueco es chico. ── */
    var rev = $('#agcRev'), revStrip = $('#agcRevStrip'), revQ = $('#agcRevQ'), revTxt = $('#agcRevTxt'), revNom = $('#agcRevNombre'), revTop = $('#agcRevTop');
    var revLista = rev ? $$('#agcRevLista li').map(function (li) { return { t: li.textContent, n: li.dataset.nombre || '' }; }) : [];
    var revIdx = -1, revOn = false, revListo = false, revVistas = 0, revTimer = 0, revGen = 0;
    function revPinta(i) {
      var q = revLista[i]; if (!q) return;
      revQ.classList.toggle('is-long', q.t.length > 85); revTxt.textContent = q.t; revNom.textContent = q.n;
    }
    /* La tira NO parpadea: el límite inferior es la fila de flechas/riel aunque esté a opacidad 0 (durante
       las transiciones lo está y cada reseña recalculaba un hueco distinto: Pedro 2026-09-20 "de repente se
       quita"), y su altura se fija UNA vez por hueco con la reseña más larga de la lista. */
    var revHcache = { hueco: -1, h: 150 };
    function revColoca() {
      if (!rev) return;
      var wr = wrap.getBoundingClientRect(), top = 0, bottom = wr.height;
      var ann = document.querySelector('#agc-cfg .agc-annbar'), tr = document.querySelector('.agc-toprail'), aP = document.getElementById('agcHeroArrowPrev');
      if (ann) { var ar = ann.getBoundingClientRect(); if (ar.height) top = ar.bottom - wr.top; }
      [tr, aP].forEach(function (e) { if (!e) return; var r = e.getBoundingClientRect(); if (r.height && getComputedStyle(e).display !== 'none') bottom = Math.min(bottom, r.top - wr.top); });
      revTop.style.top = Math.round(top + 8) + 'px';
      var y0 = top + 40, hueco = bottom - 16 - y0;
      revQ.classList.remove('is-tight');
      if (revHcache.hueco !== Math.round(hueco)) {
        /* altura de la tira con la reseña MÁS LARGA (medida en silencio y restaurada), para que no cambie entre reseñas */
        var t0 = revTxt.textContent, long0 = revQ.classList.contains('is-long'), mas = revLista.reduce(function (m, q) { return q.t.length > m.t.length ? q : m; }, revLista[0]);
        revTxt.textContent = mas.t; revQ.classList.toggle('is-long', mas.t.length > 85);
        var qmax = revQ.offsetHeight || 120;
        revTxt.textContent = t0; revQ.classList.toggle('is-long', long0);
        var hh = Math.min(150, hueco - qmax - 22);
        revHcache = { hueco: Math.round(hueco), h: hh >= 64 ? hh : 0 };
      }
      var h = revHcache.h, qh = revQ.offsetHeight || 120;
      if (qh + (h ? h + 22 : 0) > hueco) { revQ.classList.add('is-tight'); qh = revQ.offsetHeight || qh; }
      revStrip.style.display = h ? '' : 'none';
      rev.style.setProperty('--rev-h', Math.round(h) + 'px');
      var usado = (h ? h + 22 : 0) + qh, slack = Math.max(0, (hueco - usado) / 2);
      revStrip.style.top = Math.round(y0 + slack) + 'px';
      revQ.style.top = Math.round(y0 + slack + (h ? h + 22 : 0)) + 'px';
    }
    function revCiclo() {
      var gen = revGen;
      revQ.classList.add('is-out');
      revTimer = setTimeout(function () {
        if (gen !== revGen) return;
        revIdx = (revIdx + 1) % revLista.length; revPinta(revIdx); revColoca(); revQ.classList.remove('is-out');
        var nx = $('#agcRevNext'); if (nx) { nx.querySelectorAll('i').forEach(function (e) { e.style.animation = 'none'; }); void nx.offsetWidth; nx.querySelectorAll('i').forEach(function (e) { e.style.animation = ''; }); }
        revVistas++; if (revVistas >= 3) revListo = true;
        revTimer = setTimeout(revCiclo, 4300);
      }, 460);
    }
    function revStart() {
      if (!rev || revOn) return;
      revOn = true; revGen++; revVistas = 0; revListo = false; revIdx = 0;
      document.documentElement.classList.add('agc-rev-on');
      revPinta(0); revQ.classList.remove('is-out'); revColoca(); setTimeout(revColoca, 600);
      revTimer = setTimeout(revCiclo, 4300);
    }
    function revStop() { revOn = false; revGen++; clearTimeout(revTimer); document.documentElement.classList.remove('agc-rev-on'); }
    /* ── Escena 2 v2: titular bajo la barra de anuncios, pies bajo los puntos, todo medido (Pedro 2026-09-20). ── */
    var s2Caps = $('#agcS2Caps'), s2Head = s2Caps;   /* (el titular grande se quitó; el nombre se conserva para los hooks) */
    function s2Coloca() {
      if (!s2Caps) return;
      var sl = s2Caps.closest('.agc-sty-slide'), wr = wrap.getBoundingClientRect();
      var ann = document.querySelector('#agc-cfg .agc-annbar'), tr = document.querySelector('.agc-toprail'), aP = document.getElementById('agcHeroArrowPrev');
      var pins = $$('.agc-sty-hot--pin', sl), caps = $$('.agc-sty-cap', s2Caps), W = sl.clientWidth || wr.width;
      var yMax = 0, yMin = 1e9; pins.forEach(function (h) { var r = h.getBoundingClientRect(); yMax = Math.max(yMax, r.bottom - wr.top); yMin = Math.min(yMin, r.top - wr.top); });
      var bottom = wr.height;
      [tr, aP].forEach(function (e) { if (!e) return; var r = e.getBoundingClientRect(); if (r.height && getComputedStyle(e).opacity !== '0') bottom = Math.min(bottom, r.top - wr.top); });
      s2Caps.classList.remove('is-tight');
      var g = FULL ? fullGeom(sl) : { ox: 0, dw: W };
      caps.forEach(function (cp) { var x = parseFloat(cp.dataset.x) || 50, ddx = parseFloat(cp.dataset.dx) || 0; cp.style.left = Math.round(g.ox + (10.5 + x * 0.79 + ddx) / 100 * g.dw) + 'px'; });   /* dx: aire entre los dos pies */
      var h = Math.max.apply(null, caps.map(function (cp) { return cp.offsetHeight; }));
      var y = yMax + 12;
      if (y + h > bottom - 10) {   /* no caben debajo: van ARRIBA de los puntos, nunca encima (Pedro 2026-09-20) */
        if (sl.classList.contains('has-vid')) {   /* con video el titular vive arriba: los pies se quedan ABAJO, apretados y pegados al límite (2026-09-21) */
          s2Caps.classList.add('is-tight'); h = Math.max.apply(null, caps.map(function (cp) { return cp.offsetHeight; })); y = Math.min(y, bottom - 10 - h);
        } else {
          y = yMin - 12 - h;
          if (y < 0) { s2Caps.classList.add('is-tight'); h = Math.max.apply(null, caps.map(function (cp) { return cp.offsetHeight; })); y = Math.max(0, yMin - 12 - h); }
        }
      }
      s2Caps.style.top = Math.round(y) + 'px';
      var up = y < yMin; s2Caps.classList.toggle('is-up', up);
      /* Hilo: del punto del día 90 (pin 2) al punto del titular, recortado al borde de cada anillo.
         Si los pies quedaron ARRIBA de los puntos (pantalla corta), el hilo nace de la píldora "Día 90"
         para no cruzarle el texto (Pedro 2026-09-20). */
      var link = sl.querySelector('#agcS2Link'), dotT = sl.querySelector('.agc-sty-hot:not(.agc-sty-hot--pin) .agc-sty-dot'), dot90 = pins[1] && pins[1].querySelector('.agc-sty-dot');
      var pill90 = up && s2Caps.querySelector('.agc-sty-cap--b b');
      if (link && dotT && dot90) {
        var sr = sl.getBoundingClientRect(), a = (pill90 || dot90).getBoundingClientRect(), b = dotT.getBoundingClientRect();
        var ax = a.left + a.width / 2 - sr.left, ay = (pill90 ? a.top : a.top + a.height / 2) - sr.top, bx = b.left + b.width / 2 - sr.left, by = b.top + b.height / 2 - sr.top;
        var dx = bx - ax, dy = by - ay, L = Math.hypot(dx, dy), g = pill90 ? 6 : 11;
        if (L > g * 2) {
          /* Curva suave que bordea el filtro por su lado izquierdo (control cerca del punto de arriba), en vez de cruzarle la cara. */
          var ux = dx / L, uy = dy / L, ln = link.lastElementChild;
          var cx = bx + (ax - bx) * 0.08, cy = ay - (ay - by) * 0.18;
          var d = 'M' + (ax + ux * g).toFixed(1) + ' ' + (ay + uy * g).toFixed(1) + ' Q' + cx.toFixed(1) + ' ' + cy.toFixed(1) + ' ' + bx.toFixed(1) + ' ' + (by + g).toFixed(1);
          Array.prototype.forEach.call(link.children, function (pth) { pth.setAttribute('d', d); });
          link.style.setProperty('--len', (ln.getTotalLength() + 1).toFixed(1));
        }
      }
    }
    var revSlide = rev ? slides.indexOf(rev.closest('.agc-sty-slide')) : -1;
    /* Thumb de la card colapsada: en pantalla completa ya no hay muestras de color en el hero, así que la
       ducha del card cicla los 4 acabados como en el menú (Pedro 2026-09-20). Mismos PNG del nav. */
    (function () {
      if (!root.classList.contains('agc-hero-full')) return;
      var cyc = $$('#agcThumbCycle img'); if (cyc.length < 2) return;
      var k = 0;
      setInterval(function () {
        if (document.hidden || island.classList.contains('open')) return;
        k = (k + 1) % cyc.length; cyc.forEach(function (im, i) { im.classList.toggle('on', i === k); });
      }, 2400);
    })();
    if (rev) window.addEventListener('resize', function () { if (revOn) revColoca(); }, { passive: true });
    window.addEventListener('resize', function () { fullPlace(); if (s2Head) s2Coloca(); }, { passive: true });
    function prev() { if (cur <= 0) goTo(N - 1, false); else goTo(cur - 1, true); }

    /* sincronía dots/pie ↔ slide visible: scrollLeft/ancho redondeado en rAF (determinista y sin
       los bordes raros de IntersectionObserver durante el snap) */
    rail.addEventListener('scroll', function () {
      if (styRaf) return;
      /* con el riel oculto (ancho 0) la cuenta daba una foto al azar y montaCerca descargaba la activa: foto en blanco (Pedro 2026-10-05) */
      styRaf = requestAnimationFrame(function () { styRaf = 0; if (rail.clientWidth) setActive(Math.round(rail.scrollLeft / rail.clientWidth)); });
    }, { passive: true });

    /* El hero SIEMPRE se mueve (Pedro 2026-09-20: "las imágenes siempre tienen que estar animadas,
       llegó un punto en donde se quedó estático"). La interacción lo PAUSA, no lo mata: 9 s sin tocar
       y vuelve solo. Antes el primer toque lo apagaba para el resto de la sesión. */
    function startAuto() {
      if (reduce || autoTimer) return;
      if (root.classList.contains('agc-hero-full')) return;   /* pantalla completa: las fotos las cambia el usuario (Pedro 2026-09-20) */
      autoTimer = setInterval(function () {
        if (document.hidden || !wrap.offsetParent) return;   /* pestaña en 2º plano o hero oculto (card abierta / paso color) */
        if (cur === revSlide && !revListo) return;             /* reseñas: 3 frases antes de seguir */
        next();
      }, 4500);
    }
    function stopAuto() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = 0; }
      clearTimeout(idleTimer);
      if (!reduce) idleTimer = setTimeout(startAuto, 9000);
    }
    if (!reduce) {
      startAuto();
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { wrap.addEventListener(ev, stopAuto, { passive: true }); });
    }

    /* flechas de siempre: el handler viejo ya es no-op (heroCopyW = 0); aquí mueven UNA foto */
    var aN = $('#agcHeroArrow'), aP = $('#agcHeroArrowPrev');
    if (aN) aN.addEventListener('pointerdown', function (e) { e.stopPropagation(); via = 'flecha'; viaAt = Date.now(); stopAuto(); next(); });
    if (aP) aP.addEventListener('pointerdown', function (e) { e.stopPropagation(); via = 'flecha'; viaAt = Date.now(); stopAuto(); prev(); });
    styDots.forEach(function (d, k) { if (k < N) d.addEventListener('click', function () { via = 'punto'; viaAt = Date.now(); stopAuto(); goTo(k, true); }); });

    /* ASOMO (Pedro 2026-10-11: «el que se queda en esta pantalla y no sabe que hay otro slide, motivarlo a que dé click al siguiente»):
       en pantalla completa no hay autoplay. A los 2.5 s sin tocar, las fotos se corren a la izquierda y se ve el borde de la siguiente,
       regresan, y la flecha late. Una vez más a los 8 s; nunca después de tocar el hero, ni con el configurador abierto, ni con la intro
       encima, ni con movimiento reducido. Se mueven las slides (transform), no el scroll: el snap no se entera. */
    function asomoFin() { asomo.fin = true; clearTimeout(asomo.t); }
    function asomar() {
      if (asomo.fin || cur > 0) return asomoFin();
      var H = document.documentElement, r = wrap.getBoundingClientRect();
      var ocupado = document.hidden || document.getElementById('agcDi') || H.classList.contains('agc-uno-open') || root.classList.contains('cfg-open') || !wrap.offsetParent || r.bottom < innerHeight * 0.5 || r.top > innerHeight * 0.3;
      if (ocupado) { asomo.t = setTimeout(asomar, 1500); return; }
      asomo.n++;
      /* v2 (Pedro 2026-10-11: «algo más sutil, más smooth, y que tarde un poquito más»): ~60 px (16%), 1.8 s con curva seno, a los 5 s */
      var d = Math.round(Math.min(64, (rail.clientWidth || 390) * 0.16)), k = [{ transform: 'translate3d(0,0,0)' }, { transform: 'translate3d(' + (-d) + 'px,0,0)', offset: 0.4 }, { transform: 'translate3d(' + (-d) + 'px,0,0)', offset: 0.6 }, { transform: 'translate3d(0,0,0)' }];
      [slides[0], slides[1]].forEach(function (sl) { if (sl && sl.animate) sl.animate(k, { duration: 1800, easing: 'cubic-bezier(.37,0,.63,1)' }); });
      try { cfgTrack('cfg_hero_asomo', { n: asomo.n, tipo: 'fotos' }); } catch (e) { }
      if (asomo.n < 2) asomo.t = setTimeout(asomar, 6000); else asomoFin();
    }
    /* la flecha late sola a los 2.5 s (Pedro 2026-10-11: «la flecha hacia la derecha esa sí puede ser a los 2.5 seg») */
    function flechaLate() {
      if (asomo.fin || cur > 0 || !aN) return;
      var H = document.documentElement;
      if (document.hidden || document.getElementById('agcDi') || H.classList.contains('agc-uno-open') || root.classList.contains('cfg-open') || !wrap.offsetParent) { setTimeout(flechaLate, 1500); return; }
      aN.classList.remove('is-asomo'); void aN.offsetWidth; aN.classList.add('is-asomo'); setTimeout(function () { aN.classList.remove('is-asomo'); }, 1700);
      try { cfgTrack('cfg_hero_asomo', { n: 0, tipo: 'flecha' }); } catch (e) { }
    }
    if (FULL && !reduce) {
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { wrap.addEventListener(ev, function () { via = via && Date.now() - viaAt < 1500 ? via : 'swipe'; viaAt = Date.now(); asomoFin(); }, { passive: true }); });
      setTimeout(flechaLate, 2500);
      asomo.t = setTimeout(asomar, 5000);
    }

    setActive(0);
    setTimeout(function () { clampCard(cur < 0 ? 0 : cur); }, 2600);   /* recalcula cuando ya está el teaser del VSL */
    /* la píldora del VSL entra deslizando (.62s) después de aparecer: al terminar su transición, se re-ajusta el texto */
    var tzEl = document.getElementById('agcVslpTeaser');
    if (tzEl) tzEl.addEventListener('transitionend', function () { clampCard(cur < 0 ? 0 : cur); });
    /* el navegador restaura scrollLeft al volver atrás → realinear con la slide 1 tras el layout */
    requestAnimationFrame(function () { if (rail.scrollLeft) { rail.scrollLeft = 0; setActive(0); } });
    window.addEventListener('resize', function () { var c = cur < 0 ? 0 : cur; rail.scrollTo({ left: c * rail.clientWidth, behavior: 'auto' }); clampCard(c); }, { passive: true });
    /* Pedro 2026-10-05: «escroleo para abajo y luego hasta arriba y desaparece la foto principal». Cada vez que el hero vuelve a verse,
       el riel se realinea con la foto activa y esa foto (y sus vecinas) se vuelven a montar si las soltaron. */
    function heroResync() {
      var c = cur < 0 ? 0 : cur, w = rail.clientWidth; if (!w) return;
      if (Math.abs(rail.scrollLeft - c * w) > 2) rail.scrollTo({ left: c * w, behavior: 'auto' });
      if (fullPend) fullPlace();
      montaCerca(c);
      var im = slides[c] && slides[c].querySelector('img[data-full-src]');
      if (im && (!im.getAttribute('src') || (im.complete && !im.naturalWidth))) { if (im.dataset.fullSrcset) im.srcset = im.dataset.fullSrcset; im.src = im.dataset.fullSrc; }
      clampCard(c);
    }
    if (window.IntersectionObserver) new IntersectionObserver(function (es) { if (es[0] && es[0].isIntersecting) heroResync(); }, { threshold: 0.2 }).observe(wrap);
  })();

  /* ── render ── */
  var _thumbIntent = 0;
  function syncThumb() {
    var key = state.colorKey;
    var c = colorByKey(key);
    var img = $('#agcThumbImg');
    var thumbIntent = ++_thumbIntent;
    /* swap del thumb vía decode() — evita el "recuadro con sombra": si seteamos src directo y el PNG no está cacheado, el img queda vacío un instante y el filter:drop-shadow se proyecta desde su caja cuadrada. Decodificamos primero y recién ahí swapeamos (el thumb viejo se queda hasta que el nuevo esté listo). Pedro 2026-06-22 */
    if (img && c.img && img.getAttribute('src') !== c.img) {
      var pre = new Image(); pre.src = c.img;
      if (pre.decode) { pre.decode().then(function () { if (thumbIntent === _thumbIntent && state.colorKey === key) img.src = c.img; }).catch(function () { if (thumbIntent === _thumbIntent && state.colorKey === key) img.src = c.img; }); }
      else { img.src = c.img; }
    }
    var lado = $('#agcThumbLado');                                            /* expandido: foto de lado del acabado elegido */
    if (lado) { var lurl = (CFG.lado && CFG.lado[state.colorKey]) || ''; if (lurl && lado.getAttribute('src') !== lurl) lado.src = lurl; }
    var ph = $('#agcProdHeroImg');                                            /* card de producto (gemela Care): la imagen sigue al acabado elegido — misma fuente CFG.lado (Pedro 2026-07-23) */
    if (ph) { var purl = (CFG.lado && CFG.lado[state.colorKey]) || ''; if (purl && ph.getAttribute('src') !== purl) ph.src = purl; }
    $$('.agc-sw').forEach(function (x) { x.classList.toggle('on', x.dataset.c === state.colorKey); });
  }
  /* etiqueta de color del config: T1 = color hero; T2/T3 = colores POR DUCHA (abreviados a 1ª palabra) (Pedro 2026-06-21) */
  function colorsLabel() {
    var fw = function (s) { return (s || '').split(' ')[0]; };
    if (state.tier === 1) { var c1 = colorByKey(state.colorKey); return fw(c1 && c1.name); }
    var names = (state.colors || []).slice(0, state.tier).map(function (k) { var c = colorByKey(k); return fw(c && c.name); }).filter(Boolean);
    if (!names.length) { var c0 = colorByKey(state.colorKey); return fw(c0 && c0.name); }
    return names.every(function (n) { return n === names[0]; }) ? names[0] : names.join(' + ');
  }
  /* "o 6 pagos de $X sin intereses" bajo el precio de la card (Pedro 2026-08-06). Reencuadra el
     número sin esconderlo ni perder el tachado.
     ⚠️ Solo aparece a partir de $1700, que es el mínimo real de la promo — el mismo que declara
     la barra de anuncios del configurador ("Hasta 6 MSI · compra mínima $1700"). Debajo de ese
     monto prometerlo sería mentir, así que se oculta.
     Vive DENTRO de .agc-islprice a propósito: así hereda el display:none que ya oculta el precio
     cuando la card se abre, sin CSS nuevo. Importes en centavos; se redondea el pago HACIA
     ARRIBA para no anunciar una mensualidad menor a la real. */
  var MSI_N = 6, MSI_MIN_CENTS = 140000;   /* mínimo REAL de Shopify Payments (Pedro 2026-08-07, captura del panel: 3 y 6 meses activos, mínimo $1400). La barra del theme decía $1700 — dato viejo. */
  function renderMsi(cents) {
    var host = document.querySelector('#agc-cfg .agc-islprice');
    if (!host) return;
    var el = $('#agcIslMsi');
    if (!(cents >= MSI_MIN_CENTS)) { if (el) el.style.display = 'none'; return; }
    if (!el) {
      host.style.flexWrap = 'wrap';
      host.style.rowGap = '0px';   /* el gap:11px del contenedor también separa las filas al hacer wrap → la línea quedaba flotando lejos del precio */
      el = document.createElement('div');
      el.id = 'agcIslMsi';
      /* var(--lt-faint) (blanco 46%) se perdía sobre la card clara — Pedro 2026-08-06: "casi no
         se ve". 75% se lee bien y sigue por debajo del precio, que es blanco pleno y bold. */
      el.style.cssText = 'flex:0 0 100%;margin-top:2px;font-size:10.5px;font-weight:400;letter-spacing:-.01em;line-height:1;color:rgba(255,255,255,.75);font-feature-settings:"tnum"';
      host.appendChild(el);
    }
    el.textContent = 'o ' + MSI_N + ' pagos de ' + fmt(Math.ceil(cents / MSI_N / 100) * 100) + ' sin intereses';
    el.style.display = '';
  }

  /* ═══ PRE-VENTA del dorado (Pedro 2026-08-08) ═══════════════════════════════
     El dorado se vende en pre-orden: despacho 10-15 días. Los demás salen inmediato.
     CONSERVADOR A PROPÓSITO: si CUALQUIER ducha del pedido es dorada, todo el pedido
     comunica la fecha larga. Nunca prometemos más rápido de lo que podemos entregar;
     una ETA optimista aquí se paga en contracargos.
     Un solo punto de verdad: `render()` lo llama, y render corre en todo cambio de
     color venga de donde venga (isla, pill del top, o el step por ducha). */
  /* 🔴 PRE-VENTA APAGADA — Pedro 2026-09-11: "GOLD ya está disponible, oculta eso de pre-venta;
     cuando te pida activar te aviso en caso de que entre a pre-venta de nuevo".
     PARA REACTIVAR: volver a poner 'dorado' (o la key del color que entre a pre-venta) en esta
     línea. Es el ÚNICO interruptor — el aviso, la ETA de 10-15 días y el ocultamiento de la barra
     de stock cuelgan todos de aquí, así que con este cambio el color vuelve a comportarse como
     cualquier otro y nada más se toca. Con null, `hayPreventa()` da false para todo color. */
  var PREVENTA_KEY = null;
  function hayPreventa() {
    if (state.colorKey === PREVENTA_KEY) return true;
    for (var i = 0; i < state.tier; i++) { if (state.colors[i] === PREVENTA_KEY) return true; }
    return false;
  }
  var _etaOrig = null;
  function syncPreventa() {
    var on = hayPreventa();
    var aviso = $('#agcPreventa');
    if (aviso) aviso.hidden = !on;

    /* la ETA del buy box: "Llega gratis 10-13 agosto" no aplica al dorado */
    var etas = document.querySelectorAll('#agcEta .agc-eta-msg');
    if (etas.length) {
      if (_etaOrig === null) _etaOrig = etas[0].textContent;
      /* primero y su duplicado del final (loop del ticker) */
      [etas[0], etas.length > 1 ? etas[etas.length - 1] : null].forEach(function (el) { if (el) el.textContent = on ? 'Pre-venta · despacho en 10-15 días' : _etaOrig; });
    }
    /* La barra "Stock disponible | Sale hoy" la reescribe un setInterval de 1s en
       agc-configurator.liquid:1279. Pelearle el texto es perder: cada segundo lo repone.
       Se OCULTA la barra completa — el timer sigue escribiendo dentro, pero nadie la ve,
       y así no queda contradiciendo al aviso de pre-venta que está justo abajo. */
    /* Se oculta con estilo INLINE, no con [hidden]: la barra tiene display por clase y
       `[hidden]{display:none}` (especificidad 0,0,1) pierde — es la trampa documentada en
       cro-patterns §7. El inline (1,0,0,0) no la pierde nunca. */
    var readybar = document.querySelector('.agc-readybar');
    if (readybar) readybar.style.display = on ? 'none' : '';
  }

  function render() {
    var c = colorByKey(state.colorKey);
    var t = totals();
    var sep = '<span class="sep">/</span>';
    $('#agcCfgText').innerHTML = state.tier + ' baño' + (state.tier > 1 ? 's' : '') + ' ' + sep + ' ' + colorsLabel() + ' ' + sep + (state.subOff ? ' Compra única' : ' Filtro cada 3 meses');   /* sin "Aguacero Plus+" (Pedro 22-sep 15:50) */
    /* precio headline = tier 1 (1 unidad) con su plan: precio + precio de comparación (lista) */
    var ipNow = $('#agcIslPriceNow'), ipWas = $('#agcIslPriceWas');
    if (ipNow) { var t1 = tierPricing(1); ipNow.textContent = fmt(t1.final);
      if (ipWas) { if (t1.gross > t1.final) { ipWas.textContent = fmt(t1.gross); ipWas.style.display = ''; } else { ipWas.style.display = 'none'; } }
      renderMsi(t1.final); }
    var headPrice = $('#agcHeadPrice'); if (headPrice) headPrice.textContent = fmt(t.today);
    var payBig = $('#agcPayBig'), renewBig = $('#agcRenewBig');
    if (payBig) payBig.textContent = fmt(t.today);
    if (renewBig) renewBig.textContent = fmt(t.renew);
    $('#agcColorName').textContent = c.name;
    var ctaPrice = $('#agcCtaPrice');
    if (ctaPrice) ctaPrice.textContent = fmt(t.today);
    /* deal card — el precio vive aquí, cambia con el tier (framing live) */
    var deal = dealFor(state.tier);
    if (deal.title == null) deal = CFG.deals[0];
    $('#agcDealTitle').textContent = deal.title; try { requestAnimationFrame(fitDealHead); } catch (e) { }   /* Pedro 22-sep 15:50: "Hoy: Ducha + Filtro" / abajo "Cada 3 meses: Filtro nuevo" */
    var _dOff = $('#agcDealOff'); _dOff.textContent = deal.off; _dOff.style.display = deal.off ? '' : 'none';
    var incEl = $('#agcDealInc'); if (incEl) incEl.innerHTML = deal.inc || '';
    $('#agcDealSub').textContent = deal.sub;
    try { paintTapRow(); } catch (e) { }
    syncSubSw();   /* A/B suscripción: la fila del switch sigue al tier (plural y precio) */
    if (anivOn()) renderAniv();
    try {
    var _gt = $('#agcGiftTap');   /* tapete de regalo (Pedro 22-sep): 1 desde 2 duchas, 2 desde 3 */
    if (_gt) { var _gq = giftTapQty(); _gt.hidden = !_gq; var _gn = $('#agcGiftTapN'); if (_gn) _gn.textContent = _gq > 1 ? _gq + ' Tapetes' : 'Tapete DiatoMAT'; var _gw = $('#agcGiftTapWas'); if (_gw) _gw.textContent = fmt(119000 * Math.max(1, _gq)); }
    } catch (e) { }   /* el regalo nunca tumba el render de la tarjeta (bug 22-sep 18:05) */
    /* card del Set Anual (cross-sell T1, solo con aniversario OFF) */
    var rtc = $('#agcRitualCard');
    if (rtc) {
      /* Ahora vive en TODOS los tiers (Pedro 2026-08-12). Cantidad = duchas, sin selector: la
         suscripción es por ducha, así que un solo set en un pedido de 2 regaderas dejaría la
         segunda cobrando al día 90 — y la card promete "Primer cobro día 365". Cualquier otra
         cantidad convierte esa línea en mentira. */
      var _rn = Math.max(1, state.tier);
      rtc.hidden = false;
      rtc.classList.toggle('is-on', !!state.ritualSel);
      rtc.setAttribute('aria-pressed', state.ritualSel ? 'true' : 'false');
      var _rp = $('#agcRitPx'); if (_rp) _rp.textContent = fmt((CFG.anual.price || 0) * _rn);
      var _rw = $('#agcRitWas'); if (_rw) _rw.textContent = fmt((CFG.anual.compare || 0) * _rn);
      /* El precio de la columna es el TOTAL; el "por ducha" explica abajo. Con los dos números
         arriba no se entendía cuál se cobra (Pedro lo cachó en la maqueta). */
      /* En T2/T3 la columna de precio crece ($3540 + $5310) y la card se iba de 2 a 4 líneas:
         el subtítulo suelta el "365 días" (el estado marcado ya lo repite en el micro-texto).
         El título es FIJO en los tres tiers — "Lleva" cabe donde "Agrega" empujaba el badge 3×2
         a otro renglón, así que ya no se recorta el verbo en T2/T3 (Pedro 2026-08-12). */
      var _rs = $('#agcRitSub');
      if (_rs) _rs.textContent = _rn > 1
        ? (_rn + ' sets · ' + fmt(CFG.anual.price || 0) + ' por ducha')
        : '365 días de agua limpia';
      var _rt = $('#agcRitTOn');
      if (_rt) _rt.textContent = _rn > 1 ? ('Set Anual agregado · ' + _rn + ' sets') : 'Set Anual agregado';
    }
    syncPreventa();
    /* El precio de la card lo pinta paintDeal(), llamado DENTRO de renderCupon(): el cupón
       tiene que poder bajarlo y renderCupon() es quien conoce el ahorro. Pintarlo aquí también
       lo dejaría siempre sin descuento (esta línea corre después). */
    renderCupon();
    /* Filtro = $290 por ducha. Plural en T2/T3. Plus+ lo regala (strike $X); única lo cobra ("Filtro(s) $X"). Pedro 2026-06-27 */
    var _plural = state.tier > 1;
    var _fpx = '$' + (290 * state.tier).toString();
    var _oncePx = document.querySelector('#agcPlan .agc-plan-row--once .agc-plan-tag--price');
    if (_oncePx) _oncePx.textContent = '+' + _fpx;   /* "+$290/+$580/+$870" */
    var _strike = document.querySelector('#agcPlan .agc-plan-strike');
    if (_strike) _strike.textContent = _fpx;
    var _fword = document.querySelector('#agcPlan .agc-plan-fword');
    if (_fword) _fword.textContent = _plural ? 'Filtros iniciales' : 'Filtro inicial';
    var _bword = document.querySelector('#agcPlan .agc-plan-bword');
    if (_bword) _bword.textContent = _plural ? 'Tus filtros iniciales' : 'Tu filtro inicial';
    var _perf = document.querySelector('#agcPlan .agc-plan-perf');
    if (_perf) _perf.textContent = _plural ? ' c/filtro' : '';   /* T2/T3: $590 es por filtro, no total */
    /* regalos incluidos por tier (filas con thumbnail, estilo Kaching): tapete T2+, Care T3 — Pedro 2026-06-26 */
    var anyGift = false;
    $$('#agcGifts .agc-gift').forEach(function (g) { var show = state.tier >= +g.getAttribute('data-gift-min'); g.style.display = show ? 'flex' : 'none'; if (show) anyGift = true; });
    var giftsBox = $('#agcGifts'); if (giftsBox) giftsBox.style.display = anyGift ? 'flex' : 'none';
    /* el selector de tier (config) SIEMPRE refleja state.tier — single source of truth.
       Evita desync: ej. al vaciar el carrito el back-arrow resetea state.tier a 1, pero antes
       el .on visual se quedaba en el tier viejo → mostraba 2 y agregaba 1. */
    /* con tier 4-6 la card marcada sigue siendo la de 3 baños: el control "¿Necesitas más?" es
       una extensión de ese tier, no una card nueva (Pedro 2026-08-11). */
    var tierCard = Math.min(state.tier, 3);
    $$('.agc-opt[data-tier]').forEach(function (x) { x.classList.toggle('on', +x.dataset.tier === tierCard); });
    /* control 4-6: aparece SOLO con el tier 3 ya elegido (o ya estando en 4-6). */
    var more = $('#agcMore');
    if (more) {
      more.hidden = state.tier < 3;
      $$('#agcMoreBtns .agc-more-b').forEach(function (b) { b.classList.toggle('on', +b.dataset.tier === state.tier); });
    }
    paintRow3();
    paintRowsReceipt();   /* MOCK filas (?tiers=rows, ronda 3): recibo reacciona a cada cambio de tier, incluye 4/5/6 */
  }

  /* ── coreografía scroll + frame-scrub ── */
  var scroller = $('#agcScroller');
  var prod = $('#agcProd');
  var floor = $('#agcFloor');
  var frameImg = $('#agcFrame');
  var envs = [$('#agcE0'), $('#agcE1'), $('#agcE2'), $('#agcE3'), $('#agcE4')];
  var spot = $('#agcSpot');
  var dots = $$('.agc-dots b');
  var scenes = $$('.agc-scene');
  /* 6 escenas: 0=showroom (sin producto-video), 1=hero texto, 2=problema, 3=mecanismo, 4=prueba, 5=oferta */
  var ST = [
    { x: 0, y: 22, s: 1.12, r: -8 },
    { x: 0, y: 22, s: 1.12, r: -8 },
    { x: 78, y: -6, s: 0.8, r: 7 },
    { x: 0, y: -18, s: 1.62, r: 0 },
    { x: -74, y: -4, s: 0.72, r: -7 },
    { x: 0, y: 18, s: 0.62, r: 0 }
  ];
  var NS = 5; /* índice máximo de escena (0..5) */
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var cl = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  /* frames: primeros 40 eager, resto en idle — total ~4MB */
  var NF = CFG.frameCount, FR = [];
  function frameUrl(n) { return CFG.frameBase.replace('001', String(n).padStart(3, '0')); }
  for (var n = 1; n <= NF; n++) FR.push(frameUrl(n));
  var preloaded = 0;
  function preload(upTo) {
    if (cfgFlow) return;
    while (preloaded < upTo && preloaded < NF) { var im = new Image(); im.src = FR[preloaded]; preloaded++; }
  }
  /* SPEED (2026-07-02): los frames NO compiten con el LCP. En 4G el idle disparaba ~3.3MB
     al boot (requestIdleCallback = CPU libre, no red libre) y ahogaba el pipe del LCP.
     40 frames al primer gesto (intención de scrubbing) o post-load idle; los 182 solo tras load+idle.
     El scrub es on-demand (frameImg.src=FR[fi]) → sin precarga igual funciona. */
  var _fBoot = false;
  function preloadBoot() { if (_fBoot) return; _fBoot = true; preload(40); }
  ['pointerdown', 'touchstart', 'scroll', 'wheel'].forEach(function (ev) { window.addEventListener(ev, preloadBoot, { once: true, passive: true }); });
  function _afterLoad(f) { if (document.readyState === 'complete') { f(); } else { window.addEventListener('load', f, { once: true }); } }
  _afterLoad(function () {
    (window.requestIdleCallback || function (f) { setTimeout(f, 800); })(function () { preloadBoot(); preload(NF); });
  });

  var lastIdx = -1, lastScroll = -1, lastScrollH = -1, scrollDirty = true;
  function markScrollerDirty() { scrollDirty = true; }
  scroller.addEventListener('scroll', markScrollerDirty, { passive: true });
  window.addEventListener('resize', markScrollerDirty, { passive: true });
  if (window.ResizeObserver) new ResizeObserver(markScrollerDirty).observe(scroller);
  var showroom = $('#agcShowroom'), heroEnv = $('#agcHeroEnv'), prodstage = $('#agcProdstage'), colorPillEl = $('#agcColorPill');
  var heroHots = $('#agcHeroHots');
  var pillHeroVis = 1;
  function tick() {
    if (scrollDirty) {
      scrollDirty = false;
      var H = scroller.clientHeight || 1;
      var top = scroller.scrollTop;
      if (top !== lastScroll || H !== lastScrollH) {
      lastScroll = top; lastScrollH = H;
      /* fuera de la primera pantalla (scene 0) → la card colapsa a solo-footer + se ocultan colores/3D toggle */
      root.classList.toggle('scrolled', top > H * 0.5);
      root.classList.toggle('agc-tr-gone', top > 28 || cfgY() > 28); /* el toprail se va apenas scrollean (Pedro 2026-06-25) */
      var p = cl(top / H, 0, NS);
      /* handoff de capas: escena 0 = showroom puro; escenas 1+ = narrativa con video */
      var heroVis = cl(1 - p * 1.6, 0, 1);
      var videoVis = cl((p - 0.45) * 1.9, 0, 1);
      if (showroom) {
        showroom.style.opacity = heroVis;
        showroom.style.transform = 'translateY(' + (-p * 90 - 28) + 'px)';   /* -28 = lift base: el hero quedaba muy abajo con mucho espacio arriba (Pedro 2026-06-26) */
        showroom.style.visibility = heroVis === 0 ? 'hidden' : 'visible';
      }
      if (heroHots) {
        var hhHidden = root.classList.contains('cfg-open') || root.classList.contains('show-3d') || root.classList.contains('scrolled') || document.documentElement.classList.contains('agcn-open');
        heroHots.style.opacity = hhHidden ? 0 : heroVis;
        heroHots.style.transform = 'translateY(' + (-p * 90 - 28) + 'px)';   /* lift base espejo del showroom para que los hotspots no se desincronicen (Pedro 2026-06-26) */
        heroHots.style.visibility = (hhHidden || heroVis === 0) ? 'hidden' : 'visible';
      }
      pillHeroVis = heroVis;
      if (heroEnv) heroEnv.style.opacity = heroVis;
      if (prodstage) prodstage.style.opacity = videoVis;
      var i = Math.min(ST.length - 2, Math.floor(p)), t = p - i;
      var a = ST[i], b = ST[i + 1] || ST[i];
      prod.style.setProperty('--x', lerp(a.x, b.x, t) + 'px');
      prod.style.setProperty('--y', lerp(a.y, b.y, t) + 'px');
      prod.style.setProperty('--s', lerp(a.s, b.s, t));
      prod.style.setProperty('--r', lerp(a.r, b.r, t) + 'deg');
      floor.style.setProperty('--x', lerp(a.x, b.x, t) + 'px');
      floor.style.setProperty('--y', lerp(a.y, b.y, t) + 'px');
      floor.style.setProperty('--s', lerp(a.s, b.s, t));
      floor.style.opacity = cl(1 - Math.abs(p - 3), 0.15, 1) * videoVis;
      /* el video arranca fresco en la escena 1 (hero texto) y recorre su arco hasta la 5 */
      var vp = cl((p - 1) / (NS - 1), 0, 1);
      var fi = Math.min(NF - 1, Math.max(0, Math.round(vp * (NF - 1))));
      if (NF > 0 && frameImg && fi !== lastIdx) { frameImg.src = FR[fi]; lastIdx = fi; }
      /* envs e0..e4 acompañan las escenas narrativas 1..5 */
      envs.forEach(function (e, k) { if (e) e.style.opacity = cl(1 - Math.abs(p - (k + 1)), 0, 1); });
      if (spot) spot.style.opacity = cl(1 - Math.abs(p - 3) * 0.7, 0.2, 1);
      var cur = Math.round(p);
      /* en hero story los mismos dots indican la FOTO activa (los maneja el bloque STORY) */
      if (!STORY()) dots.forEach(function (d, k) { d.classList.toggle('on', k === cur); });
      }
    }
    /* SIEMPRE (fuera del guard de scroll): el pill se oculta con menú/isla abiertos, sin depender de scroll */
    if (colorPillEl) {
      var pillVis = ((island && island.classList.contains('open')) || (nav && nav.classList.contains('open')) || document.documentElement.classList.contains('agcn-open')) ? 0 : pillHeroVis;
      colorPillEl.style.opacity = pillVis;
      colorPillEl.style.pointerEvents = pillVis > 0.5 ? 'auto' : 'none';
    }
    cfgFrame(tick);
  }
  cfgFrame(tick);

  /* ── swipe horizontal del showroom con INERCIA estilo iyO (solo escena 0) ── */
  var hgStartX = 0, hgStartY = 0, hgStartOffset = 0, hgDir = null, hgLastX = 0, hgVel = 0;
  /* Cacheado (2026-09-15): heroDrift lo consultaba en CADA cuadro y, con la tarjeta animando su altura, cada lectura
     forzaba un layout completo de la página (perfil CPU 4x: 142ms en 1.5s al abrir). Se recalcula solo con scroll/resize. */
  var _scene0 = true;
  function _upScene0() { _scene0 = scroller.scrollTop < scroller.clientHeight * 0.5; }
  scroller.addEventListener('scroll', _upScene0, { passive: true });
  window.addEventListener('resize', _upScene0, { passive: true });
  _upScene0();
  function onScene0() { return _scene0; }
  scroller.addEventListener('touchstart', function (e) {
    if (!onScene0()) return;
    var t = e.touches[0];
    hgStartX = t.clientX; hgStartY = t.clientY; hgStartOffset = heroOffset; hgDir = null;
    hgLastX = t.clientX; hgVel = 0; heroFling = 0; /* agarrar la imagen detiene la inercia previa */
  }, { passive: true });
  scroller.addEventListener('touchmove', function (e) {
    if (!onScene0() || hgDir === 'v') return;
    var t = e.touches[0];
    var dx = t.clientX - hgStartX, dy = t.clientY - hgStartY;
    if (hgDir === null && (Math.abs(dx) > 7 || Math.abs(dy) > 7)) {
      hgDir = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'h' : 'v';
    }
    if (hgDir === 'h') {
      e.preventDefault();              /* el swipe horizontal no dispara el scroll vertical */
      heroDragging = true;
      heroOffset = hgStartOffset + dx;
      hgVel = (t.clientX - hgLastX) * 0.55 + hgVel * 0.45; /* velocidad suavizada (px/frame) */
      hgLastX = t.clientX;
    }
  }, { passive: false });
  function endHeroDrag() {
    if (hgDir === 'h') {
      if (heroTour) {
        /* un swipe normal = avanza UNA escena (igual que click a la flecha). Umbral bajo: cualquier
           deslizamiento real avanza; solo un toque casi inmóvil regresa al más cercano (Pedro 2026-06-24) */
        heroDragging = false;
        var _dx = heroOffset - hgStartOffset;   /* negativo = swipe izquierda → siguiente */
        /* deadzone 10px: cualquier swipe horizontal real avanza UNA escena (como click a la flecha) */
        if (_dx < -10 || hgVel < -0.25) centerToBullet(tourIdx + 1, 1);
        else if (_dx > 10 || hgVel > 0.25) centerToBullet(tourIdx - 1, -1);
        else snapNearestBullet();
      }
      else {
        heroDragging = false;
        /* configurando: tras un arrastre el fondo retoma su deslizamiento desde donde quedó (Pedro 2026-09-15) */
      }
    }
    hgDir = null; heroDragging = false;
  }
  scroller.addEventListener('touchend', endHeroDrag, { passive: true });
  scroller.addEventListener('touchcancel', endHeroDrag, { passive: true });

  /* ── Hotspots del hero: AUTO-narran al pasar por el centro de la pantalla (sin tap), con fade antes del borde —
     la imagen le "habla" al usuario, estilo Apple. Opacidad = caída suave según distancia al centro (Pedro 2026-06-20) ── */
  (function () {
    var hots = $$('#agcHeroHots .agc-hh');
    if (!hots.length) return;
    var cards = []; hots.forEach(function (h) { cards.push(h.querySelector('.agc-hh-card')); });
    var dots = []; hots.forEach(function (h) { dots.push(h.querySelector('.agc-hh-dot')); });
    var annEl = $('#agcAnnBar');
    var nudgeLock = [];   /* una escritura de --hhy por aparición de card; se suelta al ocultarse o al rotar */
    var narrateHidden = false;
    addEventListener('resize', function () { nudgeLock.length = 0; }, { passive: true });
    /* SEAMLESS (Pedro 2026-07-07): antes corría a 70ms (~14fps) contra el strip a 60fps → opacidad a saltos, y la curva op² atenuaba AMBAS cards a ~25% en el cruce (flash oscuro). Ahora: 60fps con lecturas/escrituras separadas (cero layout thrash) + curva LINEAL (el cruce se mantiene brillante, crossfade constante). Cero fricción por frame. */
    function narrate() {
      var hidden = root.classList.contains('scrolled') || root.classList.contains('cfg-open') || root.classList.contains('show-3d') || document.documentElement.classList.contains('agcn-open');
      if (hidden) {
        if (!narrateHidden) {
          cards.forEach(function (card) { if (card && card.style.opacity !== '0') card.style.opacity = '0'; });
          narrateHidden = true;
        }
        return;
      }
      narrateHidden = false;
      var isDsk = innerWidth >= 900;
      var cx = innerWidth / 2, band = isDsk ? Math.min(innerWidth * 0.16, 330) : innerWidth * 1.0;   /* mobile: banda ≈ separación entre bullets (~480px) para que el cruce no caiga a negro (Pedro 2026-07-07) */
      var annBottom = 0; if (annEl) { var arr = annEl.getBoundingClientRect(); if (arr.height) annBottom = arr.bottom; }
      var N = hots.length, hr = new Array(N), cr = new Array(N), k;
      for (k = 0; k < N; k++) { hr[k] = hots[k].getBoundingClientRect(); cr[k] = cards[k] ? cards[k].getBoundingClientRect() : null; }   /* FASE LECTURA en batch */
      for (k = 0; k < N; k++) {                                                                                                       /* FASE ESCRITURA en batch */
        var card = cards[k]; if (!card) continue;
        if (hidden) { card.style.opacity = '0'; continue; }
        var r = hr[k];
        if (!r.width) { card.style.opacity = '0'; continue; }
        var dx = Math.abs(r.left + r.width / 2 - cx);
        var t = dx >= band ? 1 : dx / band; var op = 1 - t * t;   /* PLATEAU (1-t²): centro brillante en zona amplia, cae rápido al borde → cruce sin dip oscuro (Pedro 2026-07-07) */
        if (!isDsk) {
          /* gate de borde (Pedro 2026-07-14): el texto del bullet VECINO no debe asomarse — se apaga cerca de los bordes del viewport. Margen 12% ≈ 47px: en el cruce (bullets a ~308px) ambos centros quedan a ~41px del borde → eop ~.87, el crossfade NO cae a negro. */
          var bcx = r.left + r.width / 2;
          var edge = Math.min(bcx, innerWidth - bcx), m = innerWidth * 0.12;
          op *= edge <= 0 ? 0 : edge >= m ? 1 : edge / m;
        }
        card.style.opacity = op.toFixed(3);
        if (dots[k]) dots[k].style.opacity = isDsk ? (0.3 + op * 0.7).toFixed(2) : '';
        if (op > 0.35 && annBottom && cr[k]) {
          /* El empujón anti-choque con la barra se calcula UNA vez, cuando la card aparece, y no
             se vuelve a escribir mientras siga visible (Pedro 2026-08-12: "quiero quitar esa
             animación de bounce"). Antes se recalculaba a 60fps midiendo la card YA transformada:
             cada medición caía a media transición, el valor oscilaba y las cards que quedan
             ARRIBA del dot ("Esto es lo que absorbes" y "90 días") rebotaban. Solo pasaba en
             móviles con notch: `env(safe-area-inset-top)` baja la barra ~47px y es ahí donde
             empieza a chocar — por eso no se ve en escritorio. El lock se suelta al ocultarse
             la card (y en resize/rotación, abajo). */
          if (!nudgeLock[k]) {
            var cur = parseFloat(card.style.getPropertyValue('--hhy')) || 0;
            var natTop = cr[k].top - cur;
            var need = (annBottom + 8) - natTop;
            card.style.setProperty('--hhy', need > 0 ? Math.round(need) + 'px' : '0px');
            nudgeLock[k] = true;
          }
        } else {
          nudgeLock[k] = false;
          card.style.setProperty('--hhy', '0px');
        }
      }
    }
    (function loop() { narrate(); cfgFrame(loop); })();
  })();

  /* ── Announcement bar: cicla 3 mensajes con crossfade+blur. Pace premium 4s (ref cro-patterns: ≥4s). ── */
  (function () {
    var bar = $('#agcAnnBar');
    if (!bar) return;
    var msgs = bar.querySelectorAll('.agc-annbar-msg');
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('on');
    }, 4000);
  })();

  /* ── Reseñas rotativas: crossfade premium 4.5s (mismo patrón que annbar). Pausa en reposo no requerida. ── */
  (function () {
    var box = $('#agcRevTkr');
    if (!box) return;
    var items = box.querySelectorAll('.agc-revtkr-item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('on');
      i = (i + 1) % items.length;
      items[i].classList.add('on');
    }, 4500);
  })();

  /* ── Promo bar: countdown live al domingo 23:59 CST + posicionado arriba del card (SOLO colapsado) ── */
  (function () {
    var bar = $('#agcPromoBar'); if (!bar) return;
    var tEls = document.querySelectorAll('.agc-promo-timer-val');   /* timer compartido: isla colapsada + barra expandida (Pedro 2026-06-21) */
    /* TARGET = hoy 23:59 CST; rueda DIARIO (Pedro 2026-06-22) → nunca expira, termina 11:59pm cada día */
    function computeTarget() {
      var now = Date.now(), OFF = 6 * 3600 * 1000; /* CST = UTC-6 */
      var cst = new Date(now - OFF);
      cst.setUTCHours(23, 59, 0, 0); /* hoy 23:59 CST */
      var ms = cst.getTime() + OFF;
      if (ms <= now) ms += 24 * 3600 * 1000; /* ya pasó → mañana 23:59 CST */
      return ms;
    }
    var TARGET = computeTarget();
    function fmt(ms) {
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      var p = function (n) { return (n < 10 ? '0' : '') + n; };
      return (d > 0 ? d + 'd ' : '') + p(h) + ':' + p(m) + ':' + p(s);
    }
    var timer;
    function tick() {
      var diff = TARGET - Date.now();
      if (diff <= 0) { TARGET = computeTarget(); diff = TARGET - Date.now(); }  /* rueda a la siguiente semana, NUNCA oculta las islas */
      var txt = fmt(diff);
      for (var i = 0; i < tEls.length; i++) tEls[i].textContent = txt;
    }
    function place() {
      /* las islas (Ver en acción / Reseñas / promo) SIEMPRE visibles en colapsado; el CSS las oculta al expandir */
      bar.hidden = false;
    }
    tick(); timer = setInterval(tick, 1000);
    window.__agcPlacePromo = place;
    window.addEventListener('resize', place);
    requestAnimationFrame(function () { requestAnimationFrame(place); });
  })();

  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('show'); });
  }, { root: scroller, threshold: 0.55 });
  scenes.forEach(function (s) { io.observe(s); });

  /* ── menú bento (morph del nav pill, patrón iyO) ── */
  var nav = $('#agcNav'), navBg = $('#agcNavBg');
  var cycleTimer = null, cycleIdx = 0;
  function startCycle() {
    var imgs = $$('#agcMenuCycle img');
    if (!imgs.length || cycleTimer) return;
    cycleTimer = setInterval(function () {
      imgs[cycleIdx].classList.remove('on');
      cycleIdx = (cycleIdx + 1) % imgs.length;
      imgs[cycleIdx].classList.add('on');
    }, 2600);
  }
  function stopCycle() {
    if (cycleTimer) { clearInterval(cycleTimer); cycleTimer = null; }
  }
  function closeMenu() {
    if (window.AGCNav) window.AGCNav.close();   /* barra compartida agc-nav */
    if (nav) nav.classList.remove('open');
    if (navBg) navBg.classList.remove('show');
    root.classList.remove('menu-open');
    stopCycle();
  }
  /* la barra compartida avisa al abrir → cerramos la isla de config (comportamiento original) */
  document.addEventListener('agcn:toggle', function (e) {
    if (!e.detail) return;
    var open = e.detail.open;
    if (open) setIsland(false);
    /* Recompute INMEDIATO de la visibilidad gated por el menú. El rAF tick (que setea la opacidad de
       #agcColorPill = islas de variantes, y de los hotspots del hero) se throttlea en tabs de fondo /
       Chrome automatizado → al cerrar el menú se quedaban en opacity:0 (bug Pedro 2026-07-13, "en page load").
       Lo resolvemos aquí en el evento, sin depender del loop. */
    evalHeroMode();
    placeToprail();   /* reposiciona el toprail (islas de variantes + 3D): su follow() rAF se congela bajo throttle → las islas quedaban "hasta abajo detrás del card" (Pedro 2026-07-13). */
    placeAnnBar();
    /* y otra vez cuando el card TERMINA su transición de cierre — el pase inmediato lo agarra a media
       animación (posición stale). setTimeout corre aunque el rAF esté throttled. */
    setTimeout(function () { placeToprail(); placeAnnBar(); }, 480);
    var blockPill = open || (island && island.classList.contains('open')) || root.classList.contains('scrolled') || root.classList.contains('cfg-open') || root.classList.contains('show-3d');
    if (colorPillEl) {
      colorPillEl.style.opacity = blockPill ? 0 : pillHeroVis;
      colorPillEl.style.pointerEvents = (!blockPill && pillHeroVis > 0.5) ? 'auto' : 'none';
    }
    if (heroHots) {
      var hh = open || root.classList.contains('cfg-open') || root.classList.contains('show-3d') || root.classList.contains('scrolled');
      heroHots.style.opacity = hh ? 0 : pillHeroVis;
      heroHots.style.visibility = (hh || pillHeroVis === 0) ? 'hidden' : 'visible';
    }
  });
  var menuBtn = $('#agcMenuBtn');
  if (menuBtn) menuBtn.addEventListener('click', function () {
    var willOpen = !nav.classList.contains('open');
    if (willOpen) setIsland(false);
    nav.classList.toggle('open', willOpen);
    navBg.classList.toggle('show', willOpen);
    root.classList.toggle('menu-open', willOpen);
    if (willOpen) startCycle(); else stopCycle();
  });
  if (navBg) navBg.addEventListener('click', closeMenu);

  /* ── reseñas: widget glass propio (datos de la BD) + vista Loox con fotos ── */
  var revOverlay = $('#agcReviewsOverlay');
  var REVIEWS = null, revShown = 0, revPhotosMode = false;
  var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  function fmtRevDate(d) {
    if (!d) return '';
    var p = d.split('-');
    return parseInt(p[2], 10) + ' ' + (MESES[parseInt(p[1], 10) - 1] || '') + ' ' + p[0];
  }
  function revCard(rv) {
    var el = document.createElement('div');
    el.className = 'agc-revcard' + (rv.img ? ' has-img' : '');
    var stars = '★★★★★'.slice(0, rv.r) + '<span class="off">' + '★★★★★'.slice(rv.r) + '</span>';
    el.innerHTML =
      (rv.img ? '<div class="rc-img"><img loading="lazy" alt=""></div>' : '') +
      '<div class="rc-body">' +
      '<div class="rc-head"><span class="rc-name"></span>' +
      (rv.src === 'ml' ? '<span class="rc-verified rc-ml"><img src="' + CFG.reviewsUrl.replace(/agc-reviews\.json.*$/, 'agc-ml-logo.png') + '" alt="Mercado Libre" width="14" height="10" loading="lazy">Compra verificada</span>' : rv.v ? '<span class="rc-verified">✓ Verificada</span>' : '') + '</div>' +
      '<div class="rc-meta"><span class="rc-stars">' + stars + '</span><span class="rc-date">' + fmtRevDate(rv.d) + '</span></div>' +
      '<p class="rc-text"></p></div>';
    if (rv.img) el.querySelector('.rc-img img').src = rv.img;
    el.querySelector('.rc-name').textContent = rv.n;
    el.querySelector('.rc-text').textContent = rv.t;
    return el;
  }
  var revFilter = 'all'; /* Todas / Con fotos / Sin fotos (Pedro 2026-07-14) */
  function revFiltered() {
    if (!REVIEWS) return [];
    if (revFilter === 'img') return REVIEWS.filter(function (r) { return !!r.img; });
    if (revFilter === 'txt') return REVIEWS.filter(function (r) { return !r.img; });
    return REVIEWS;
  }
  function renderRevBatch() {
    var grid = $('#agcRevGrid');
    if (!grid || !REVIEWS) return;
    var list = revFiltered();
    var frag = document.createDocumentFragment();
    list.slice(revShown, revShown + 18).forEach(function (rv) { frag.appendChild(revCard(rv)); });
    revShown = Math.min(revShown + 18, list.length);
    grid.appendChild(frag);
    var more = $('#agcRevMore');
    if (more) more.style.display = revShown >= list.length ? 'none' : '';
  }
  var revFilterBar = $('#agcRevFilter');
  if (revFilterBar) revFilterBar.addEventListener('click', function (e) {
    var b = e.target.closest('[data-revf]');
    if (!b || b.classList.contains('on')) return;
    revFilter = b.getAttribute('data-revf');
    revFilterBar.querySelectorAll('.agc-revf-btn').forEach(function (x) { x.classList.toggle('on', x === b); });
    var grid = $('#agcRevGrid');
    if (grid) grid.innerHTML = '';
    revShown = 0;
    renderRevBatch();
  });
  function loadReviews() {
    if (REVIEWS) return;
    fetch(CFG.reviewsUrl).then(function (r) { return r.json(); }).then(function (d) {
      REVIEWS = d;
      renderRevBatch();
    }).catch(function () {
      /* sin datos: caer a la vista Loox */
      setPhotosMode(true);
    });
  }
  function setPhotosMode(on) {
    revPhotosMode = on;
    var sheet = revOverlay ? revOverlay.querySelector('.agc-reviews-sheet') : null;
    if (sheet) sheet.classList.toggle('photos', on);
    var btn = $('#agcRevPhotos');
    if (btn) btn.textContent = on ? '← Volver a reseñas' : 'Ver reseñas con fotos →';
  }
  /* Pedro 2026-06-22: si abre un modal del product card (reseñas / en acción) estando scrolleado fuera del above-the-fold, deslizar la página de regreso arriba — igual que "Comprar ahora". Así al cerrar el modal aterriza sobre el card, no varado en el objsec. No-op si no hay scroll. */
  function slideUpToCard() {
    /* "scrolleado fuera del above-the-fold" = ventana O scroller interno O clase scrolled (en embed scrollea la ventana, no el scroller; por eso revisamos ambos). */
    var wy = cfgY();
    var sy = scroller ? scroller.scrollTop : 0;
    if (wy < 40 && sy < 40 && !root.classList.contains('scrolled')) return false;
    try {
      if (window.__agcLenis) window.__agcLenis.scrollTo(cfgTop());
      else window.scrollTo({ top: cfgTop(), behavior: 'smooth' });
      if (scroller) scroller.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {}
    return true;
  }
  /* ── Cierre animado de overlays (Pedro 2026-07-13): la entrada anima con .show, pero quitar .show
     hacía display:none INSTANTÁNEO (cierre de fregadazo). .closing corre la animación inversa (CSS:
     salida ~60% de la duración de entrada, curva acelerada estilo Apple) y al terminar recién se esconde. ── */
  function animClose(ov) {
    if (!ov || !ov.classList.contains('show')) return;
    ov.classList.remove('show');
    ov.classList.add('closing');
    setTimeout(function () { ov.classList.remove('closing'); }, 440);   /* > salida más larga (.4s) */
  }
  var reviewsWasOpen = false;
  /* candado de documento para el modal de reseñas (Pedro 2026-07-03): la clase html.agc-sheet pierde contra
     el overflow:visible!important INLINE que pone el motor SMOOTH de la landing — se pelea inline vs inline
     (mismo patrón que el lockPage del boleto). Al cerrar se restaura visible!important si hay landing. */
  function revLockDoc(on) {
    var d = document.documentElement.style, b = document.body.style;
    if (on) { d.setProperty('overflow', 'hidden', 'important'); b.setProperty('overflow', 'hidden', 'important'); }
    else if (document.getElementById('agc-landing')) { d.setProperty('overflow', 'visible', 'important'); b.setProperty('overflow', 'visible', 'important'); }
    else { d.removeProperty('overflow'); b.removeProperty('overflow'); }
  }
  function openReviews() {
    closeMenu();
    /* si venía scrolleado: primero deslizamos de regreso al card, y abrimos el modal cuando llega arriba (~420ms). El modal bloquea el scroll, así que NO puede abrir antes del slide o lo congela. Pedro 2026-06-22 */
    var slid = slideUpToCard();
    var run = function () {
      reviewsWasOpen = islandOpen();   /* recuerda si el card estaba expandido para regresar igual al cerrar (Pedro 2026-06-21) */
      setIsland(false);
      if (revOverlay) { revOverlay.classList.remove('closing'); revOverlay.classList.add('show'); }
      document.documentElement.classList.add('agc-sheet'); /* esconde la barra compartida */
      revLockDoc(true);
      loadReviews();
    };
    if (slid) setTimeout(run, 420); else run();
  }
  function closeReviews() {
    animClose(revOverlay);
    document.documentElement.classList.remove('agc-sheet');
    revLockDoc(false);
    if (reviewsWasOpen) { setIsland(true); reviewsWasOpen = false; }   /* regresa al card expandido si así estaba */
  }
  var revMore = $('#agcRevMore');
  if (revMore) revMore.addEventListener('click', renderRevBatch);
  /* infinite scroll (Pedro 2026-07-03): el botón queda invisible como sentinel — al acercarse al fondo del modal dispara el mismo batch. Fallback: sin IntersectionObserver el botón se ve y funciona igual. */
  if (revMore && 'IntersectionObserver' in window) {
    revMore.classList.add('agc-rev-more--auto');
    var _revLastBatch = 0;
    new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var now = Date.now();
        if (now - _revLastBatch < 280) return;   /* throttle: el fling rápido disparaba N batches → N re-layouts de la masonry (jank) */
        _revLastBatch = now;
        renderRevBatch();
      });
    }, { rootMargin: '600px 0px' }).observe(revMore);
  }
  var revWrite = $('#agcRevWrite');
  if (revWrite) revWrite.addEventListener('click', function () {
    if (window.LOOX && typeof window.LOOX.showReviewForm === 'function') { try { window.LOOX.showReviewForm(); return; } catch (e) {} }
    setPhotosMode(true);
  });
  var revBtn = $('#agcReviewsBtn');
  if (revBtn) revBtn.addEventListener('click', openReviews);
  var menuRev = $('#agcMenuReviews');
  if (menuRev) menuRev.addEventListener('click', openReviews);
  var headRev = $('#agcHeadReviews');
  if (headRev) headRev.addEventListener('click', function (e) { e.stopPropagation(); openReviews(); });
  /* islas top (Pedro 2026-06-21): Vela en acción → modal de video (#agcVideoModal de theme.liquid); Ver reseñas → mismo widget */
  var velaIsle = $('#agcVelaIsle');
  if (velaIsle) velaIsle.addEventListener('click', function () {
    var slid = slideUpToCard();   /* mismo patrón que reseñas: desliza al card, abre el video cuando llega (Pedro 2026-06-22) */
    var run = function () {
      var m = document.getElementById('agcVideoModal'), p = document.getElementById('agcVideoPlayer');
      if (m) { m.classList.add('active'); document.body.style.overflow = 'hidden'; }
      if (p) { try { p.currentTime = 0; p.play(); } catch (e) {} }
    };
    if (slid) setTimeout(run, 420); else run();
  });
  var revIsle = $('#agcReviewsIsle');
  if (revIsle) revIsle.addEventListener('click', function (e) { e.stopPropagation(); openReviews(); });
  /* botón "Ver reseñas" dentro de la escena 7 del carrusel → mismo modal (Pedro 2026-06-24) */
  $$('[data-revbtn]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); openReviews(); }); });
  /* click en stars/puntuación → abre reseñas (Pedro 2026-06-21) */
  var priceStars = $('#agcPriceStars');
  if (priceStars) {
    priceStars.addEventListener('click', function (e) { e.stopPropagation(); openReviews(); });
    priceStars.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openReviews(); } });
  }
  /* ═══ Cross-sells como mini-tarjetas (Pedro 2026-09-21 13:40). Orden Care · Tapete · Set Anual. "¿Qué es?" abre un sheet
     (clon del del tapete) con el copy real de Care; "Detalles" abre el sheet real del tapete; el Set Anual no lleva botón. ═══ */
  var XS = [
    { row: 'agcCareRow', n: 'Care', img: 'https://cdn.shopify.com/s/files/1/0706/9063/6024/files/caretoggle.png?v=1776031378&width=120', more: '¿Qué es?', sheet: 'care' },
    { row: 'agcTapRow', n: 'Tapete<small>DiatoMAT</small>', img: (CFG.frameBase || '').replace(/agc-cf-001\.jpg.*$/, 'agc-tapete-menu.png'), more: 'Detalles', sheet: 'tapete' },
    { row: 'agcRitRow', n: 'Set Anual', img: (CFG.frameBase || '').replace(/agc-cf-001\.jpg.*$/, 'agc-ritual-3filtros.png'), more: 'Detalles', sheet: 'set' }
  ];
  var xsBox = $('#agcXsellCards');
  function paintXsell() {
    if (!xsBox) return;
    var h = '';
    XS.forEach(function (d) {
      var row = document.getElementById(d.row); if (!row || row.hidden) return;
      var px = row.querySelector('.agc-carerow-px'), was = row.querySelector('.agc-carerow-was'), badge = row.querySelector('.agc-rit3x2'), on = row.classList.contains('is-on');
      h += '<button type="button" class="agc-xsell-card' + (on ? ' on' : '') + '" data-row="' + d.row + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
           (badge ? '<span class="agc-xsell-b">' + badge.textContent.trim() + '</span>' : '') + '<span class="agc-xsell-ck" aria-hidden="true"></span>' +
           '<img src="' + d.img + '" alt="" loading="lazy"><span class="agc-xsell-n">' + d.n + '</span>' +
           '<span class="agc-xsell-p">' + (px ? px.textContent.trim() : '') + (was ? '<s>' + was.textContent.trim() + '</s>' : '') + '</span>' +
           (d.more ? '<span class="agc-xsell-more" data-sheet="' + d.sheet + '" role="button">' + d.more + '</span>' : '') + '</button>';
    });
    xsBox.innerHTML = h;
  }
  /* Sheets propios de Care y Set Anual (Pedro 2026-09-21 14:20: "más estético… sin la foto de la ducha… 'Cerrar' en vez de 'No, continuar'; quitar se hace desde el step") */
  var XSHEET = {
    care: { row: 'agcCareRow', t: 'Aguacero Care', sub: 'Protección total por 12 meses, un solo pago.', img: 'https://cdn.shopify.com/s/files/1/0706/9063/6024/files/caretoggle.png?v=1776031378&width=480',
            li: ['Reposición ante robo, daño o pérdida en envío', 'Garantía extendida a 100 días', 'Soporte VIP: te contestamos primero', 'Un solo pago, cubre 12 meses'] },
    set:  { row: 'agcRitRow', t: 'Set Anual', sub: 'Tus 3 filtros del año, listos desde hoy.', img: (CFG.frameBase || '').replace(/agc-cf-001\.jpg.*$/, 'agc-ritual-3filtros.png'),
            li: ['3 filtros: uno nuevo cada 3 meses', '$330 cada uno en vez de $590', 'Llegan con tu ducha, envío gratis', 'Pausa o cancela cuando quieras'] }
  };
  function xsSheet(kind) {
    var d = XSHEET[kind], base = document.getElementById('agcTapSheet'), row = d && document.getElementById(d.row); if (!d || !base || !row) return;
    var id = 'agcXsellSheet_' + kind, ov = document.getElementById(id);
    if (!ov) {
      ov = base.cloneNode(true); ov.id = id; ov.classList.remove('show', 'closing'); ov.classList.add('agc-xsell-sheet');
      ov.querySelectorAll('[id]').forEach(function (e) { e.id = e.id + '_' + kind; });
      var wrap = ov.querySelector('.agc-tapsheet-imgswrap'); if (wrap) wrap.innerHTML = '<div class="agc-xsell-sheet-hero"><img src="' + d.img + '" alt="" loading="eager"></div>';
      var tt = ov.querySelector('.agc-tapsheet-title'); if (tt) tt.innerHTML = d.t + '<span class="agc-xsell-sheet-sub">' + d.sub + '</span>';
      var ul = ov.querySelector('.agc-tapsheet-feats'); if (ul) { ul.classList.add('agc-xsell-sheet-li'); ul.innerHTML = d.li.map(function (x) { return '<li>' + x + '</li>'; }).join(''); }
      var sk = ov.querySelector('.agc-tapsheet-skip'); if (sk) sk.textContent = 'Cerrar';
      document.body.appendChild(ov);
      function shut() { ov.classList.add('closing'); ov.classList.remove('show'); setTimeout(function () { ov.classList.remove('closing'); }, 320); }
      var cl = ov.querySelector('.agc-tapsheet-close'); if (cl) cl.addEventListener('click', shut);
      if (sk) sk.addEventListener('click', shut);
      ov.addEventListener('click', function (e) { if (e.target === ov) shut(); });
      var cta = ov.querySelector('.agc-tapsheet-cta'); if (cta) cta.addEventListener('click', function () { var b = row.querySelector('.agc-carerow-btn'); if (b && !state.busy && !row.classList.contains('is-on')) b.click(); shut(); });
    }
    if (kind === 'set') { var li2 = ov.querySelectorAll('.agc-tapsheet-feats li')[1], RS = ritNow(); if (li2 && RS && RS.price) li2.textContent = fmt(RS.price / 3) + ' cada uno en vez de ' + fmt((CFG.filtroCompare || 59000)); }   /* por filtro, al precio vigente del Set */
    var cta2 = ov.querySelector('.agc-tapsheet-cta'), px = row.querySelector('.agc-carerow-px'), was = row.querySelector('.agc-carerow-was');
    if (cta2) cta2.innerHTML = row.classList.contains('is-on') ? 'Ya está en tu pedido' : 'Agregar &mdash; ' + (px ? px.textContent.trim().replace('+', '') : '') + (was ? '&nbsp;<s>' + was.textContent.trim() + '</s>' : '');
    ov.classList.remove('closing'); ov.classList.add('show');
  }
  if (xsBox) {
    xsBox.addEventListener('click', function (e) {
      var m = e.target.closest('.agc-xsell-more');
      if (m) { e.stopPropagation(); var w = m.getAttribute('data-sheet'); if (w === 'tapete') { try { openTapeteOrCare('tapete'); } catch (err) { } } else xsSheet(w); cfgTrack('cfg_xsell_more', { addon: w }); return; }
      var card = e.target.closest('.agc-xsell-card'); if (!card || state.busy) return;
      var row = document.getElementById(card.getAttribute('data-row')), btn = row && row.querySelector('.agc-carerow-btn'); if (btn) btn.click();
    });
    paintXsell();
    XS.forEach(function (d) { var r = document.getElementById(d.row); if (r) new MutationObserver(paintXsell).observe(r, { attributes: true, attributeFilter: ['class', 'hidden'], childList: true, subtree: true, characterData: true }); });
  }
  var fijaStars = $('#agcFijaStars');   /* estrellas dentro de la frase de la tarjeta cerrada (2026-09-21) */
  if (fijaStars) {
    fijaStars.addEventListener('click', function (e) { e.stopPropagation(); openReviews(); });
    fijaStars.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openReviews(); } });
  }
  var revClose = $('#agcReviewsClose');
  if (revClose) revClose.addEventListener('click', closeReviews);
  if (revOverlay) revOverlay.addEventListener('click', function (e) { if (e.target === revOverlay) closeReviews(); });

  /* === Modal "Problemas que atendemos" — mismo patrón slide-up que reseñas (Pedro 2026-06-26) === */
  var bnOverlay = $('#agcBenefitsOverlay');
  var benefitsWasOpen = false;
  function openBenefits() {
    closeMenu();
    var slid = slideUpToCard();   /* si venía scrolleado, regresa al card y abre cuando llega arriba */
    var run = function () {
      benefitsWasOpen = islandOpen();
      setIsland(false);
      if (bnOverlay) { bnOverlay.classList.remove('closing'); bnOverlay.classList.add('show'); }
      document.documentElement.classList.add('agc-sheet'); /* esconde la barra compartida */
    };
    if (slid) setTimeout(run, 420); else run();
  }
  function closeBenefits() {
    animClose(bnOverlay);
    document.documentElement.classList.remove('agc-sheet');
    if (benefitsWasOpen) { setIsland(true); benefitsWasOpen = false; }
  }
  var bnIsle = $('#agcBenefitsIsle');
  if (bnIsle) bnIsle.addEventListener('click', function (e) { e.stopPropagation(); openBenefits(); });
  var bnClose = $('#agcBenefitsClose');
  if (bnClose) bnClose.addEventListener('click', closeBenefits);
  /* tabs Cabello/Piel + acordeón single-open + cerrar al tocar el backdrop — todo delegado en el overlay */
  if (bnOverlay) bnOverlay.addEventListener('click', function (e) {
    if (e.target === bnOverlay) { closeBenefits(); return; }
    var tab = e.target.closest && e.target.closest('.agc-bn-tab');
    if (tab) {
      var key = tab.getAttribute('data-bntab');
      $$('#agcBenefitsOverlay .agc-bn-tab').forEach(function (x) { x.classList.toggle('on', x === tab); });
      $$('#agcBenefitsOverlay .agc-bn-panel').forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-bnpanel') === key); });
      return;
    }
    var q = e.target.closest && e.target.closest('.agc-bn-q');
    if (q) {
      var item = q.parentNode, wasOpen = item.classList.contains('on');
      var panel = item.closest('.agc-bn-panel');
      if (panel) panel.querySelectorAll('.agc-bn-item.on').forEach(function (it) { it.classList.remove('on'); }); /* single-open por panel */
      if (!wasOpen) item.classList.add('on');
    }
  });

  /* ── hoja de objeciones: Chat (AI shell) ── */
  var askOverlay = $('#agcAskOverlay');
  var OBJ = [];
  try { var od = document.getElementById('agcObjData'); OBJ = od ? JSON.parse(od.textContent) : []; } catch (e) { OBJ = []; }
  var askChat = $('#agcAskChat');
  var typeTimer = null;

  /* FAQ-first: abre mostrando el FAQ (no el chat); el chat se revela on-demand (Pedro 2026-06-20) */
  /* scroll-lock a prueba de iOS: overflow:hidden NO frena el touch-scroll en Safari — body position:fixed con compensación de scrollY sí */
  var lockY = 0;
  function lockScroll(on) {
    var de = document.documentElement.style, bs = document.body.style;
    if (on) {
      lockY = window.scrollY || window.pageYOffset || 0;
      de.overflow = 'hidden';
      bs.position = 'fixed'; bs.top = (-lockY) + 'px'; bs.left = '0'; bs.right = '0'; bs.width = '100%'; bs.overflow = 'hidden';
    } else {
      de.overflow = '';
      bs.position = ''; bs.top = ''; bs.left = ''; bs.right = ''; bs.width = ''; bs.overflow = '';
      window.scrollTo(0, lockY);
    }
  }
  function openAsk() { closeMenu(); setIsland(false); if (askOverlay) { askOverlay.classList.remove('closing'); askOverlay.classList.add('show'); } document.documentElement.classList.add('agc-sheet'); lockScroll(true); var b = $('#agcDudasBody'); if (b) b.classList.remove('chat-on'); var v = $('#agcAskVariants'); if (v) v.hidden = true; }
  function closeAsk() { animClose(askOverlay); document.documentElement.classList.remove('agc-sheet'); lockScroll(false); if (typeTimer) { clearInterval(typeTimer); typeTimer = null; } }
  /* Esc cierra el sheet (desktop) */
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && askOverlay && askOverlay.classList.contains('show')) closeAsk(); });
  /* swipe-down sobre grab/header cierra el sheet (mobile) — umbral 70px, solo gesto descendente */
  (function () {
    var sheet = askOverlay && askOverlay.querySelector('.agc-ask-sheet'); if (!sheet) return;
    var y0 = null, dy = 0;
    [sheet.querySelector('.agc-ask-grab'), sheet.querySelector('.agc-ask-top')].forEach(function (z) {
      if (!z) return;
      z.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; dy = 0; sheet.style.transition = 'none'; }, { passive: true });
      z.addEventListener('touchmove', function (e) {
        if (y0 === null) return;
        dy = Math.max(0, e.touches[0].clientY - y0);
        sheet.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true });
      z.addEventListener('touchend', function () {
        sheet.style.transition = ''; sheet.style.transform = '';
        if (dy > 70) closeAsk();
        y0 = null; dy = 0;
      });
    });
  })();
  /* accordion FAQ (un item abierto a la vez) */
  var faqWrap = $('#agcDudasFaq');
  if (faqWrap) faqWrap.addEventListener('click', function (e) {
    var q = e.target.closest('.agc-faq-q'); if (!q) return;
    var item = q.parentElement, wasOpen = item.classList.contains('open');
    faqWrap.querySelectorAll('.agc-faq-item.open').forEach(function (x) { x.classList.remove('open'); });
    if (!wasOpen) item.classList.add('open');
  });
  /* mini botón "Chatea con nosotros" → revela el chat existente (objection sheet) */
  var dudasChat = $('#agcDudasChat');
  if (dudasChat) dudasChat.addEventListener('click', function () {
    var b = $('#agcDudasBody'), v = $('#agcAskVariants');
    if (v) v.hidden = false;
    if (b) b.classList.add('chat-on');
    buildChat();
  });
  var dudasGo = $('#agcDudasGo'); if (dudasGo) dudasGo.addEventListener('click', agcGoConfig);
  var askBtn = $('#agcAskBtn'); if (askBtn) askBtn.addEventListener('click', openAsk);
  var askClose = $('#agcAskClose'); if (askClose) askClose.addEventListener('click', closeAsk);
  if (askOverlay) askOverlay.addEventListener('click', function (e) { if (e.target === askOverlay) closeAsk(); });
  var askAtc = $('#agcAskAtc'); if (askAtc) askAtc.addEventListener('click', agcGoConfig); /* Fase 2: ATC sticky → puente al configurador */

  /* — CHAT — */
  function scrollChat(log) { if (log) log.scrollTop = log.scrollHeight; }
  function typeText(el, text, log, done) {
    if (typeTimer) clearInterval(typeTimer);
    var words = text.split(' '), n = 0;
    typeTimer = setInterval(function () {
      el.textContent = words.slice(0, n + 1).join(' '); n++; scrollChat(log);
      if (n >= words.length) { clearInterval(typeTimer); typeTimer = null; if (done) done(); }
    }, 32);
  }
  /* — Fase 2: burbujas multi-beat · ATC sticky · resalte del siguiente chip · puente al configurador — */
  function splitAnswer(a) {
    var idx = a.indexOf('. ', 30);  /* primer punto tras char 30 → recon | resto */
    if (idx > 30 && idx < a.length - 25) return [a.slice(0, idx + 1), a.slice(idx + 2)];
    return [a];
  }
  function typeBubbles(parts, log, idx) {
    if (idx >= parts.length) return;
    var b = document.createElement('div'); b.className = 'agc-msg agc-msg-bot';
    b.innerHTML = '<div class="agc-msg-av">🌊</div><div class="agc-bubble"><span class="agc-typing"><i></i><i></i><i></i></span></div>';
    log.appendChild(b); scrollChat(log);
    setTimeout(function () {
      var bub = b.querySelector('.agc-bubble'); bub.textContent = '';
      typeText(bub, parts[idx], log, function () { typeBubbles(parts, log, idx + 1); });
    }, idx === 0 ? 600 : 380);
  }
  function revealAtc() {
    var foot = $('#agcAskFoot');
    if (foot && foot.hidden) { foot.hidden = false; requestAnimationFrame(function () { foot.classList.add('show'); }); }
  }
  function highlightNext() {
    var chips = $$('#agcChatChips .agc-chatchip');
    chips.forEach(function (c) { c.classList.remove('is-next'); });
    for (var j = 0; j < chips.length; j++) {
      if (!chips[j].classList.contains('used')) { chips[j].classList.add('is-next'); break; }
    }
  }
  /* puente: cierra el chat → expande la card → scroll al selector de tier con el default pre-resaltado */
  function agcGoConfig() {
    closeAsk();
    setMode('config');
    setTimeout(function () {
      var tiers = $('#agcTiers');
      if (tiers) {
        try { tiers.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        var def = tiers.querySelector('.agc-opt[data-tier="1"]') || tiers.querySelector('.agc-opt.on');
        if (def) { def.classList.add('agc-tierpulse'); setTimeout(function () { def.classList.remove('agc-tierpulse'); }, 1700); }
      }
    }, 700);
  }
  function chatAsk(i, chipEl) {
    var o = OBJ[i]; if (!o) return;
    var log = $('#agcChatLog'); if (!log) return;
    var u = document.createElement('div'); u.className = 'agc-msg agc-msg-user';
    u.innerHTML = '<div class="agc-bubble"></div>'; u.querySelector('.agc-bubble').textContent = o.q;
    log.appendChild(u);
    if (chipEl) chipEl.classList.add('used');
    revealAtc();                       /* ATC sticky desde la respuesta #1 */
    var chipsWrap = $('#agcChatChips');
    if (chipsWrap && !chipsWrap.querySelector('.agc-chatchip:not(.used)')) {
      chipsWrap.innerHTML = '<span class="agc-chat-chiplbl">Lo demás se siente en la primera regadera 🌊</span>';
    } else { highlightNext(); }         /* resalta la siguiente pregunta lógica */
    scrollChat(log);
    typeBubbles(splitAnswer(o.a), log, 0);  /* respuesta en burbujas multi-beat */
  }
  function buildChat() {
    if (!askChat) return;
    if (typeTimer) { clearInterval(typeTimer); typeTimer = null; }
    var chips = OBJ.map(function (o, i) { return '<button class="agc-chatchip" data-i="' + i + '" type="button">' + o.c + '</button>'; }).join('');
    askChat.innerHTML =
      '<div class="agc-chat-log" id="agcChatLog">' +
        '<div class="agc-msg agc-msg-bot"><div class="agc-msg-av">🌊</div><div class="agc-bubble">Aquí no te voy a vender nada. Pregúntame lo que de verdad te frena — te respondo claro.</div></div>' +
      '</div>' +
      '<div class="agc-chat-chips" id="agcChatChips"><span class="agc-chat-chiplbl">Toca lo que estás pensando</span>' + chips + '</div>';
    askChat.querySelectorAll('.agc-chatchip').forEach(function (c) {
      c.addEventListener('click', function () { chatAsk(parseInt(c.getAttribute('data-i'), 10), c); });
    });
    /* resaltar el chip 1 (pregunta recomendada para empezar) + resetear el ATC sticky */
    var firstChip = askChat.querySelector('.agc-chatchip'); if (firstChip) firstChip.classList.add('is-next');
    var foot = $('#agcAskFoot'); if (foot) { foot.hidden = true; foot.classList.remove('show'); }
    /* 2ª burbuja de apertura, ~550ms después (ritmo humano) */
    setTimeout(function () {
      var log = $('#agcChatLog'); if (!log) return;
      var b = document.createElement('div'); b.className = 'agc-msg agc-msg-bot';
      b.innerHTML = '<div class="agc-msg-av">🌊</div><div class="agc-bubble">Mucha gente llega con la misma duda. Toca la tuya 👇</div>';
      log.appendChild(b); scrollChat(log);
    }, 550);
  }

  /* ── ticker de confianza arriba del CTA: auto-scroll vertical infinito, igual al theme viejo #162810462456 (Pedro 2026-09-15:
     "iguala lo que teníamos de los textos cambiantes encima del CTA"). El último mensaje duplica al primero → loop sin salto. ── */
  (function () {
    var track = document.querySelector('#agcEta .agc-eta-track');
    if (!track || track.children.length < 2) return;
    var n = track.children.length, idx = 0, EASE = 'transform .6s cubic-bezier(.65,0,.35,1)';
    setInterval(function () {
      if (document.hidden) return;
      var h = track.children[0].offsetHeight || 14;
      idx++;
      track.style.transition = EASE;
      track.style.transform = 'translateY(' + (-idx * h) + 'px)';
      if (idx >= n - 1) setTimeout(function () { track.style.transition = 'none'; track.style.transform = 'translateY(0)'; idx = 0; }, 620);
    }, 3200);
  })();

  /* ── módulos flotantes DESKTOP: carrusel de reseñas (izq) + verdad minimal (arriba-der) ── */
  (function () {
    if (!document.querySelector('#agcDeskFloat')) return;
    var rail = $('#agcDfRevRail'), nextBtn = $('#agcDfRevNext'), mVerdad = $('#agcDfVerdad');
    var VERDAD = [];
    try { var vd = document.getElementById('agcVerdadData'); VERDAD = vd ? JSON.parse(vd.textContent) : []; } catch (e) { VERDAD = []; }

    /* RESEÑAS — carrusel INFINITO: todas las de Loox (imágenes primero), solo la izquierda se lee */
    var revPool = [], STEP = 316, revAnimating = false; /* card 300 + gap 16 */
    function buildRevCards(arr) {
      var ok = arr.filter(function (r) { return r.t && r.t.length > 20 && r.t.length < 240; });
      var withImg = ok.filter(function (r) { return !!r.img; });
      var noImg = ok.filter(function (r) { return !r.img; });
      revPool = withImg.concat(noImg); /* todas las con imagen primero, luego el resto (fondo sólido = sin perf hit) */
      if (!revPool.length) revPool = arr.slice();
      if (!rail) return;
      rail.innerHTML = '';
      revPool.forEach(function (rv) {
        var stars = '★★★★★'.slice(0, rv.r || 5);
        var card = document.createElement('div'); card.className = 'dfrev-card';
        card.innerHTML = '<div class="dfrev-top">' + (rv.img ? '<img class="dfrev-img" src="' + rv.img + '" alt="" loading="lazy">' : '') +
          '<div class="dfrev-id"><span class="dfrev-stars">' + stars + '</span><span class="dfrev-name"></span></div></div>' +
          '<p class="dfrev-text"></p>';
        card.querySelector('.dfrev-name').textContent = rv.n + (rv.v ? '  ·  ✓' : '');
        card.querySelector('.dfrev-text').textContent = '“' + rv.t + '”';
        rail.appendChild(card);
      });
    }
    /* avance infinito: anima -1 card, luego mueve la 1ª al final y resetea sin transición (sin saltos, sin fin) */
    function advanceRev() {
      if (revPool.length < 2 || !rail || revAnimating) return;
      revAnimating = true;
      rail.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1)';
      rail.style.transform = 'translateX(' + (-STEP) + 'px)';
      var fired = false;
      var done = function (e) {
        if (e && e.propertyName && e.propertyName !== 'transform') return;
        if (fired) return; fired = true;
        clearTimeout(fb);
        rail.removeEventListener('transitionend', done);
        rail.style.transition = 'none';
        if (rail.firstElementChild) rail.appendChild(rail.firstElementChild);
        rail.style.transform = 'translateX(0)';
        void rail.offsetWidth; /* fuerza reflow para que el siguiente avance vuelva a animar */
        revAnimating = false;
      };
      rail.addEventListener('transitionend', done);
      var fb = setTimeout(done, 720); /* fallback si transitionend no dispara */
    }
    if (nextBtn) nextBtn.addEventListener('click', advanceRev);
    if (typeof REVIEWS !== 'undefined' && REVIEWS) buildRevCards(REVIEWS);
    else fetch(CFG.reviewsUrl).then(function (r) { return r.json(); }).then(buildRevCards).catch(function () {});
    setInterval(function () { advanceRev(); }, 7000);

    /* VERDAD — detalle minimal arriba a la derecha, rota suave */
    if (mVerdad && VERDAD.length) {
      mVerdad.innerHTML = '<span class="dfv-eyebrow">El agua que no ves</span><p class="dfv-text"></p>';
      var vEl = mVerdad.querySelector('.dfv-text'), verIdx = 0;
      vEl.textContent = VERDAD[0];
      setInterval(function () {
        verIdx++;
        vEl.style.opacity = '0';
        setTimeout(function () { vEl.textContent = VERDAD[verIdx % VERDAD.length]; vEl.style.opacity = '1'; }, 600);
      }, 5500);
    }
  })();

  /* ── modelo 3D real (model-viewer): toggle Ver Filtro / Ver Tecnología (estilo iyo) ── */
  (function () {
    var mv = $('#agcMv'), stage = $('#agc3d');
    var toggle = $('#agcViewToggle'), dock = $('#agcViewDock'), hint = $('#agc3dHint');
    if (!mv || !stage || !toggle) return;
    var MODELS = CFG.models3d || {};
    var active = false, subMode = 'normal', loadedColor = null, raf = null, hintTimer = null;

    function showHint() {
      if (!hint) return;
      hint.classList.remove('show'); void hint.offsetWidth; hint.classList.add('show');
      if (hintTimer) clearTimeout(hintTimer);
      hintTimer = setTimeout(function () { hint.classList.remove('show'); }, 4200);
    }
    function hideHint() { if (hint) hint.classList.remove('show'); if (hintTimer) { clearTimeout(hintTimer); hintTimer = null; } }
    mv.addEventListener('camera-change', function (e) { if (e.detail && e.detail.source === 'user-interaction') hideHint(); });

    function cancelAnims() { if (raf) cancelAnimationFrame(raf); raf = null; }
    function watchUntil(stopAt, after) {
      cancelAnimationFrame(raf);
      var w = function () { if (mv.currentTime >= stopAt - 0.03) { mv.pause(); after && after(); return; } raf = requestAnimationFrame(w); };
      raf = requestAnimationFrame(w);
    }
    /* auto-rotate (built-in) da la vida en reposo; se pausa al tocar y se reanuda tras el delay */
    function autoRotate(on) { if (on) mv.setAttribute('auto-rotate', ''); else mv.removeAttribute('auto-rotate'); }
    function closeHots() { mv.querySelectorAll('.agc-hot.open').forEach(function (h) { h.classList.remove('open'); }); }
    /* modelo normal cerrado — gira/zoom libre + auto-rotate idle */
    function showNormal() {
      cancelAnims(); mv.classList.remove('tech'); closeHots(); mv.setAttribute('shadow-intensity', '0.55');
      try { mv.animationName = 'abrir'; } catch (e) {}
      mv.currentTime = 0; mv.pause();
      mv.cameraTarget = '0m -0.05m 0m'; mv.cameraOrbit = '38deg 60deg 1.08m'; autoRotate(true);
    }
    function playFiltro() {
      cancelAnims(); mv.classList.remove('tech'); closeHots(); mv.setAttribute('shadow-intensity', '0.55');
      try { mv.animationName = 'abrir'; } catch (e) {}
      mv.currentTime = 0; mv.cameraTarget = '0m -0.14m 0m'; mv.cameraOrbit = '28deg 80deg 1.2m'; autoRotate(false);
      mv.play(); watchUntil(2.5, function () { mv.pause(); autoRotate(true); });
    }
    function playTech() {
      cancelAnims(); mv.setAttribute('shadow-intensity', '0');
      try { mv.animationName = 'tecnologia'; } catch (e) {}
      mv.currentTime = 0; mv.cameraTarget = '-0.004m -0.135m 0m'; mv.cameraOrbit = '40deg 86deg 0.92m'; autoRotate(false);
      mv.play(); watchUntil(2.3, function () { mv.pause(); mv.classList.add('tech'); if (mv.jumpCameraToGoal) mv.jumpCameraToGoal(); autoRotate(false); });  /* zoom in + queda FIJA en la posición centrada (ref Pedro); el usuario gira manual si quiere */
    }
    function applySub() { if (subMode === 'filtro') playFiltro(); else if (subMode === 'tech') playTech(); else showNormal(); }
    /* SPEED: model-viewer se carga LAZY on-tap del 3D (self-host), no eager. Compartido vía customElements + window.__mvP (idempotente, también lo reusa el showcase del landing). */
    function ensureMV(cb) {
      if (window.customElements && customElements.get('model-viewer')) { cb && cb(); return; }
      if (!window.__mvP) { window.__mvP = new Promise(function (res) { var sc = document.createElement('script'); sc.type = 'module'; sc.src = CFG.mvUrl; sc.onload = res; sc.onerror = res; document.head.appendChild(sc); }); }
      window.__mvP.then(function () { cb && cb(); });
    }
    var pendingOnLoad = null;
    function ensureModel(cb) {
      var key = state.colorKey;                 /* fija el color pedido AHORA, no el que esté activo al disparar load */
      var url = MODELS[key];
      if (!url) { cb && cb(); return; }
      /* ya cargado Y el src actual ES el de este color → listo (antes faltaba el check de src → falso early-return mid-swap) */
      if (loadedColor === key && mv.loaded && mv.getAttribute('src') === url) { cb && cb(); return; }
      /* descarta cualquier listener pendiente de un color anterior (evita doble-fire / loadedColor stale al switchear rápido) */
      if (pendingOnLoad) { mv.removeEventListener('load', pendingOnLoad); pendingOnLoad = null; }
      var onLoad = function () { mv.removeEventListener('load', onLoad); pendingOnLoad = null; loadedColor = key; cb && cb(); };
      pendingOnLoad = onLoad;
      if (mv.getAttribute('src') !== url) { mv.addEventListener('load', onLoad); mv.src = url; }
      else if (mv.loaded) { pendingOnLoad = null; loadedColor = key; cb && cb(); }
      else { mv.addEventListener('load', onLoad); }
    }
    function setToggle() { toggle.querySelectorAll('button').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-view') === (active ? '3d' : '2d')); }); }
    function setDock() { if (!dock) return; dock.querySelectorAll('button').forEach(function (b) { b.classList.toggle('on', active && b.getAttribute('data-mode') === subMode); }); }
    function open3d() {
      if (active) return;
      active = true; subMode = 'normal';
      root.classList.add('show-3d'); closeMenu(); setIsland(false);
      stage.hidden = false; requestAnimationFrame(function () { stage.classList.add('show'); });
      showHint();
      setToggle(); setDock(); ensureMV(function () { ensureModel(applySub); });
      requestAnimationFrame(function () { requestAnimationFrame(placeToprail); });   /* pega el toprail al viewdock (Pedro 2026-06-22) */
      /* SPEED/UX: en vista 3D, bloquear el scroll de página (no scrollear a la historia). */
      var d3 = document.documentElement, b3 = document.body;
      d3.style.setProperty('overflow', 'hidden', 'important'); b3.style.setProperty('overflow', 'hidden', 'important');
    }
    function close3d() {
      active = false; subMode = 'normal'; cancelAnims(); mv.classList.remove('tech'); closeHots(); hideHint();
      root.classList.remove('show-3d'); stage.classList.remove('show');
      if (document.getElementById('agc-landing')) { var d3=document.documentElement, b3=document.body; d3.style.setProperty('overflow', 'visible', 'important'); b3.style.setProperty('overflow', 'visible', 'important'); }
      setTimeout(function () { if (!active) stage.hidden = true; }, 560);
      setToggle(); setDock();
      requestAnimationFrame(placeToprail);   /* vuelve a anclar el toprail arriba del card al salir de 3D (Pedro 2026-06-22) */
    }
    function setSub(m) {
      if (!active || subMode === m) return;   /* selección directa (Modelo / Filtro / Tecnología) */
      subMode = m;
      setDock(); applySub();
    }
    toggle.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { if (b.getAttribute('data-view') === '3d') open3d(); else close3d(); });
    });
    if (dock) dock.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { setSub(b.getAttribute('data-mode')); });
    });
    /* tap-to-reveal: tocar un dot revela su nombre y cierra los demás */
    mv.querySelectorAll('.agc-hot').forEach(function (h) {
      h.addEventListener('click', function (e) { e.stopPropagation(); var was = h.classList.contains('open'); closeHots(); if (!was) h.classList.add('open'); });
    });
    window.__agc3dSync = function () { if (active) ensureModel(applySub); };
    /* salir del 3D al abrir la card (reset de fondo a imagen) — close3d NO toca la isla */
    window.__agc3dExit = function () { if (active) close3d(); };
  })();

  /* ── interacción isla (CTA de dos tiempos: Comprar ahora → expandir → Agregar) ── */
  var island = $('#agcIsland');
  function islandOpen() { return island.classList.contains('open'); }
  function inCart() { return island.classList.contains('cart'); }
  /* Centrado del media de fondo con la card de producto (US-validated, Pedro 2026-07-23): con cfg-open en móvil
     el media scrolleable queda anclado muy abajo — paddingBottom = viewport − top de la isla + 2·ty, donde ty es el
     translateY inline que tick() mete al showroom (lift −28px; sin compensarlo ×2 el media queda 56px arriba del
     centro — medido en US). Fuera de la condición se limpia el inline y regresa el 25vh del CSS. */
  /* Galería del paso de color centrada ARRIBA de la tarjeta (regla del paso de color). Solo en ese paso: en el paso 1 la foto se queda
     detrás del vidrio (Pedro 2026-09-15). Fuera de ese paso sale sin medir nada (la apertura del paso 1 no paga layout por cuadro). */
  function syncShowroomPad() {
    if (!showroom || !island) return;
    if (!(root.classList.contains('agc-step-color') && root.classList.contains('cfg-open') && window.innerWidth <= 1023)) { if (showroom.style.paddingBottom) showroom.style.paddingBottom = ''; return; }
    var ty = 0, tr = getComputedStyle(showroom).transform;
    if (tr && tr !== 'none') { var mm = tr.match(/matrix\(([^)]+)\)/); if (mm) ty = parseFloat(mm[1].split(',')[5]) || 0; }
    var pad = window.innerHeight - island.getBoundingClientRect().top + 2 * ty;
    showroom.style.paddingBottom = Math.max(0, Math.round(pad)) + 'px';
  }
  if (window.ResizeObserver) { new ResizeObserver(function () { syncShowroomPad(); }).observe(island); }
  window.addEventListener('resize', syncShowroomPad);
  syncShowroomPad();
  /* modos: 'collapsed' | 'config' | 'cart' */
  /* Announcement bar: en CONFIG se reposiciona arriba del card (que es bottom-anchored → su bottom es estable)
     con fondo oscuro; en COLLAPSED vuelve arriba (CSS top:72); en CART el CSS lo esconde. */
  var annRaf;
  /* ── Reseñas: centra el card glass en la banda libre entre el techo y la última isla (annbar/card).
     Si no cabe (espacio < altura del card) → NO se muestra (clase agc-rev-fits). Pedro 2026-06-27 ── */
  /* FLUIDEZ (2026-09-14, Pedro: "se siente trabado al abrir el configurador y al cambiar de tier"):
     medido en LIVE, esta función corría en cada frame del follow() y reescribía class+top de la
     zona (card con blur 26px) ~70 veces/s aunque no cambiaran, y leía rects DESPUÉS de que follow()
     escribía estilos → layout forzado por frame. Ahora: medidas entran ya tomadas (antes de escribir)
     y solo se escribe al DOM cuando el valor cambia. */
  function setRevZone(zone, fits, top) {
    if (zone.classList.contains('agc-rev-fits') !== fits) zone.classList.toggle('agc-rev-fits', fits);
    if (zone.style.top !== top) zone.style.top = top;
  }
  function placeRevZone(m) {   /* m opcional = { islandTop, barH, cardH } medidos antes de escribir */
    var zone = $('#agcRevTkr'); if (!zone) return;
    var off = !island.classList.contains('open')
      || root.classList.contains('cart-mode')
      || root.classList.contains('agc-step-color')
      || root.classList.contains('show-3d')
      || root.classList.contains('menu-open')
      || root.classList.contains('scrolled')
      || document.documentElement.classList.contains('agcn-open');
    if (off) { setRevZone(zone, false, ''); return; }
    var floor, cardH;
    if (m) {
      /* el annbar se ancla con bottom = innerHeight - islandTop + 12 → su borde superior es islandTop - 12 - barH */
      floor = (m.barH > 4 ? m.islandTop - 12 - m.barH : m.islandTop) - 12;
      cardH = m.cardH;
    } else {
      var bar = $('#agcAnnBar');
      var lower = (bar && bar.getBoundingClientRect().height > 4) ? bar : island;
      floor = lower.getBoundingClientRect().top - 12;            /* arriba de la última isla */
      var card = zone.querySelector('.agc-revcard');
      cardH = (card ? card.offsetHeight : 96) + 16;              /* + cola de los ghosts */
    }
    var CEIL = 54;                                               /* techo (bajo el status bar) */
    var avail = floor - CEIL;
    if (avail < cardH + 8) {                                     /* no cabe → ocúltalo */
      setRevZone(zone, false, '');
    } else {
      setRevZone(zone, true, Math.round(CEIL + (avail - cardH) / 2) + 'px');   /* centrado vertical */
    }
  }

  function placeAnnBar() {
    var bar = $('#agcAnnBar'); if (!bar) return;
    cancelAnimationFrame(annRaf);
    if (root.classList.contains('cart-mode')) { placeRevZone(); return; } /* en cart lo esconde el CSS */
    if (island.classList.contains('open')) {
      /* config: el annbar SIGUE al card (que se expande con transición) → aparece al instante y
         sube con él. Anclado 12px arriba del card y CENTRADO SOBRE EL CARD (no sobre la pantalla)
         → en desktop el card está a la derecha, así el annbar queda encima de él. Fondo oscuro. */
      bar.classList.add('is-oncard');
      bar.style.top = 'auto';
      var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
      var revCard = document.querySelector('#agcRevTkr .agc-revcard');
      (function follow() {
        /* TODAS las lecturas primero, escrituras después (sin layout forzado por frame) */
        var r = island.getBoundingClientRect();
        var m = { islandTop: r.top, barH: bar.getBoundingClientRect().height, cardH: (revCard ? revCard.offsetHeight : 96) + 16 };
        var L = Math.round(r.left + r.width / 2) + 'px', B = Math.round(window.innerHeight - r.top + 12) + 'px';
        if (bar.style.left !== L) bar.style.left = L;
        if (bar.style.bottom !== B) bar.style.bottom = B;
        placeRevZone(m);   /* recoloca las reseñas mientras el card se expande */
        var now = (window.performance && performance.now) ? performance.now() : Date.now();
        if (now - t0 < 1000) annRaf = requestAnimationFrame(follow); /* sigue durante la transición (~.85s) */
      })();
    } else {
      /* collapsed: vuelve arriba (CSS top:72, centrado en pantalla) */
      bar.style.top = ''; bar.style.bottom = ''; bar.style.left = '';
      bar.classList.remove('is-oncard');
      placeRevZone();
    }
  }
  window.addEventListener('resize', placeAnnBar);
  /* toprail (color pills + toggle 3D) anclado ARRIBA del product card en colapsado (Pedro 2026-06-21) */
  var trRaf;
  function placeToprail() {
    var tr = $('#agcTopRail'); if (!tr) return;
    cancelAnimationFrame(trRaf);
    if (root.classList.contains('cart-mode') || island.classList.contains('open')) return;
    /* 3D: el toprail se PEGA al viewdock (Modelo/Filtro/Tech); colapsado: arriba del card (Pedro 2026-06-22) */
    var in3d = root.classList.contains('show-3d');
    var anchorEl = in3d ? $('#agcViewDock') : island;
    if (!anchorEl) return;
    var gap = in3d ? 7 : 12;
    var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
    tr.style.transition = 'none';   /* SMOOTH: seguir el card por TRANSFORM (compositado), sin la transición CSS que mete lag. Pedro 2026-06-23 */
    (function follow() {
      if (island.classList.contains('open')) { tr.style.transition = ''; return; }
      var r = anchorEl.getBoundingClientRect();
      /* Pedro 2026-09-24: en celular (sin 3D) las islas van ANCLADAS a la tarjeta (absolute en #agc-cfg): scrollean con ella, sin perseguirla */
      var anc = window.innerWidth < 900 && !in3d, rb = anc ? root.getBoundingClientRect() : null;
      if (anc) r = { top: r.top - rb.top, left: r.left - rb.left, right: r.right - rb.left, width: r.width };
      var _pos = anc ? 'absolute' : '';
      tr.style.position = _pos;
      ['agcHeroArrowPrev', 'agcHeroArrow'].forEach(function (id) { var e = document.getElementById(id); if (e) e.style.position = _pos; });
      tr.style.top = '0px'; tr.style.bottom = 'auto'; tr.style.left = '0px';
      /* translate3d → GPU, no dispara layout. En mobile el GRUPO COMPLETO (píldora+cubo + ambas flechas a la derecha) se centra como unidad sobre el ancla (Pedro 2026-07-06: "todas las islas centradas"). */
      var railY = Math.round(r.top - gap - tr.offsetHeight);
      var railX = Math.round(r.left + r.width / 2 - tr.offsetWidth / 2);
      if (window.innerWidth < 900) {
        var aP = document.getElementById('agcHeroArrowPrev'), aN = document.getElementById('agcHeroArrow');
        if (aP && aN) {
          var extra = 8 + aP.offsetWidth + 8 + aN.offsetWidth;   /* ‹ y › van a la derecha del rail */
          railX = Math.round(r.left + r.width / 2 - (tr.offsetWidth + extra) / 2);   /* centrar píldora+cubo+flechas como un solo grupo */
          if (root.classList.contains('agc-hero-full')) railX = Math.round(r.right - 14 - (tr.offsetWidth + extra));   /* pantalla completa: cubo+flechas a la derecha (Pedro 2026-09-20) */
          var arrL = railX + tr.offsetWidth + 8, arrR = arrL + aP.offsetWidth + 8;
          var over = (arrR + aN.offsetWidth) - ((anc ? rb.width : window.innerWidth) - 4);
          if (over > 0) { railX -= over; arrL -= over; arrR -= over; }
          if (railX < 4) { var d = 4 - railX; railX += d; arrL += d; arrR += d; }
          var cy = railY + tr.offsetHeight / 2 - aP.offsetHeight / 2;
          aP.style.right = 'auto'; aP.style.left = arrL + 'px'; aP.style.top = cy + 'px'; aP.style.transform = 'none';
          aN.style.right = 'auto'; aN.style.left = arrR + 'px'; aN.style.top = cy + 'px'; aN.style.transform = 'none';
        }
      }
      tr.style.transform = 'translate3d(' + railX + 'px,' + railY + 'px,0)';
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      if (now - t0 < 800) trRaf = requestAnimationFrame(follow);
      else { tr.style.transition = ''; if (anc && window.__agcFullPlace) window.__agcFullPlace(); }   /* restaurar la transición para el open/close; re-centra la escena 1 con la tarjeta ya quieta */
    })();
  }
  window.addEventListener('resize', placeToprail);
  requestAnimationFrame(function () { requestAnimationFrame(placeToprail); });
  /* AUTO-CORRECCIÓN (Pedro 2026-09-20: "las islas de variantes... se quedan arriba"). El rail se
     coloca por JS relativo al card, así que cualquier camino que mueva el card sin pasar por
     setMode() lo dejaba colgado donde estaba. En vez de parchar caminos, se re-coloca ante todo
     cambio de clase (del root o del card) y ante todo cambio de tamaño del card: si alguna vez
     queda desfasado, se corrige solo en el siguiente frame. placeToprail no toca clases ni el
     tamaño del card, así que no hay realimentación. */
  var _trSync = 0;
  function syncToprail() {
    clearTimeout(_trSync);
    _trSync = setTimeout(function () {
      /* si el rail está oculto no hay nada que seguir (y durante el scroll lo está): se recoloca
         solo cuando vuelva a aparecer, porque eso también es un cambio de clase. */
      if (root.classList.contains('agc-tr-gone') || root.classList.contains('cfg-open')
        || root.classList.contains('menu-open') || root.classList.contains('cart-mode')
        || island.classList.contains('open')
        || document.documentElement.classList.contains('agcn-open')) return;
      /* ya alineado → no gastar el rAF: el root cambia de clase cada 5 s por el glow del CTA */
      var tr = $('#agcTopRail');
      if (tr && !root.classList.contains('show-3d')) {
        var a = tr.getBoundingClientRect(), i = island.getBoundingClientRect();
        if (a.height && i.height && Math.abs(a.top + a.height + 12 - i.top) <= 1) return;
      }
      placeToprail();
    }, 60);
  }
  if (window.MutationObserver) {
    var _trObs = new MutationObserver(syncToprail);
    _trObs.observe(root, { attributes: true, attributeFilter: ['class'] });
    _trObs.observe(island, { attributes: true, attributeFilter: ['class'] });
  }
  if (window.ResizeObserver) new ResizeObserver(syncToprail).observe(island);
  function setMode(mode) {
    try { setTimeout(function () { if (window.__agcVidActiva) window.__agcVidActiva(); }, 0); } catch (e) { }
    if (mode !== 'collapsed' && window.__agc3dExit) window.__agc3dExit();  /* abrir card → fondo vuelve a imagen */
    island.classList.toggle('open', mode !== 'collapsed');
    island.classList.toggle('cart', mode === 'cart');
    root.classList.toggle('cfg-open', mode !== 'collapsed');
    root.classList.toggle('cart-mode', mode === 'cart');
    document.documentElement.classList.toggle('agc-cfgopen', mode !== 'collapsed'); /* barra compartida se oculta al expandir la card */
    /* En el cart: bloquear el scroll de página (no scrollear a la historia embebida) + subir al tope para que el cart se vea.
       El scroll INTERNO del cart (.agc-cartscroll) sigue funcionando. Sale del cart → restaura el scroll de documento. */
    var d = document.documentElement, b = document.body;
    if (mode === 'cart') {
      window.scrollTo(0, cfgTop());
      d.style.setProperty('overflow', 'hidden', 'important'); b.style.setProperty('overflow', 'hidden', 'important');
    } else if ((document.getElementById('agc-landing') || document.querySelector('#agc-pg.agc-dv2-flow')) && !root.classList.contains('show-3d') && !document.documentElement.classList.contains('agc-sheet')) {
      /* agc-sheet = modal de reseñas abierto → NO restaurar el scroll del documento (Pedro 2026-07-03: el modal debe bloquear la landing) */
      d.style.setProperty('overflow', 'visible', 'important'); b.style.setProperty('overflow', 'visible', 'important');
    }
    /* EL BOLETO (Pedro 2026-07-02): la 1ª vez que abren la card en la sesión, el step Atínale va antes de los deal cards */
    if (mode === 'config' && window.__agcMunMaybeOpen) window.__agcMunMaybeOpen();
    /* transición de modo top-level → siempre arranca en el paso 'config' (no atorar en color step) */
    state.step = 'config';
    root.classList.remove('agc-step-color');
    root.classList.remove('agc-step-care');
    updateCta();
    placeAnnBar();
    placeToprail();
    if (window.__agcPlacePromo) window.__agcPlacePromo();
  }
  function setIsland(open) { setMode(open ? 'config' : 'collapsed'); }
  /* TEST (Pedro 2026-06-24): tras elegir color, el CTA va DIRECTO a checkout (no abre el cart). El cart NO se elimina — solo se omite este paso por mientras. Revert = false. */
  var CTA_DIRECT_CHECKOUT = true;
  /* Pedro 2026-10-26: «quita el precio del config cerrado, y cambia CTA a "ELEGIR MI AGUACERO" así descubren el precio hasta el config y
     verán el popup». Solo en la PDP de diario (AgcEnCfg con tienda, sin landing_promo ni gdl_promo); las landings de evento siguen igual. */
  var SIN_PRECIO = (function () {
    try { var c = JSON.parse(document.getElementById('AgcEnCfg').textContent); return !!c.tienda && !String(c.landing_promo || '').trim() && !String(c.gdl_promo || '').trim(); } catch (e) { return false; }
  })();
  if (SIN_PRECIO) document.documentElement.classList.add('agc-sin-precio');
  /* CTA con crossfade de copy (transición Apple) */
  var _ctaLabelTimer = 0;
  function setCtaLabel(html) {
    var label = $('#agcCtaLabel');
    if (!label) return;
    if (label.dataset.cur === html) { return; }
    if (_ctaLabelTimer) { clearTimeout(_ctaLabelTimer); _ctaLabelTimer = 0; }
    label.dataset.cur = html;
    label.style.transition = 'opacity .18s ease';
    label.style.opacity = '0';
    _ctaLabelTimer = setTimeout(function () {
      _ctaLabelTimer = 0;
      if (label.dataset.cur !== html) return;
      label.innerHTML = html;
      if (!inCart()) render();
      label.style.opacity = '1';
    }, 180);
  }
  function updateCta() {
    var btn = $('#agcAddBtn');
    /* color por estado: comprar=negro · agregar=verde · finalizar=beige (espejo del menu drawer) */
    function ctaTone(t) { if (!btn) return; btn.classList.remove('cta-add', 'cta-checkout'); if (t) btn.classList.add(t); }
    if (btn) btn.classList.remove('cta-elegir');   /* reset flechita del paso "Elegir mi acabado" (Pedro 2026-06-21) */
    if (inCart()) { if (btn) btn.classList.remove('is-soldout'); ctaTone('cta-checkout'); setCtaLabel('Finalizar pedido'); return; }
    /* el ATC se inhabilita SOLO con la card abierta y color agotado; "Comprar ahora" nunca se bloquea */
    if (islandOpen() && colorSoldOut()) {
      if (btn) btn.classList.add('is-soldout');
      ctaTone(null);
      setCtaLabel('Agotado&nbsp;&nbsp;→&nbsp;&nbsp;Elige otro color');
      return;
    }
    if (btn) btn.classList.remove('is-soldout');
    /* Opción A CRO: negro constante en comprar + agregar; el color (verde=go) se reserva para el checkout */
    if (islandOpen()) {
      ctaTone(null);
      if (state.step === 'config') { if (btn) btn.classList.add('cta-elegir'); setCtaLabel(state.tier === 1 ? 'Elegir mi acabado' : 'Elegir mis acabados'); }
      else { if (btn) btn.classList.add('cta-elegir'); setCtaLabel(CTA_DIRECT_CHECKOUT ? 'Siguiente: Ir al pago' : 'Agregar a mi carrito'); }   /* step acabados (Pedro 2026-07-23: "IR AL PAGO" + flechita vía .cta-elegir) */
    }
    else { ctaTone(null); setCtaLabel(SIN_PRECIO ? 'Elegir mi Aguacero' : 'Comprar ahora'); }   /* Pedro 2026-10-18 ~17:45: «el CTA principal… ponle mejor "COMPRAR AHORA"» */   /* Pedro 2026-10-06: «cambia CTA por "ELEGIR MI AGUACERO"» */   /* colapsado (Pedro 2026-10-05: «dale con ELEGIR MI DUCHA», el botón abre el configurador, aún no compran) (Pedro 2026-09-14: "CTA de quiero aguacero cámbialo a COMPRAR AHORA"; supersede el "quiero" del 2026-08-06). Abre el configurador, no cobra */
  }
  $('#agcCfgRow').addEventListener('click', function () {
    closeMenu();
    setMode(islandOpen() ? 'collapsed' : 'config');
  });
  var urgChev = $('#agcUrgChev');
  if (urgChev) urgChev.addEventListener('click', function (e) { e.stopPropagation(); closeMenu(); setMode('collapsed'); });
  /* #B — la flecha "regresar" del cart VACÍA el carrito (asumimos que quiere reconfigurar desde cero) */
  var cartBack = $('#agcCartBack');
  if (cartBack) cartBack.addEventListener('click', function () {
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () { state.tier = 1; setMode('config'); if (typeof refreshCount === 'function') refreshCount(); })
      .catch(function () { setMode('config'); });
  });
  /* "Seguir comprando" del estado vacío → vuelve a configurar (sin tocar el carrito) */
  var emptyCta = $('#agcCartEmptyCta');
  if (emptyCta) emptyCta.addEventListener('click', function () { state.tier = 1; setMode('config'); });

  /* Volver arriba con el product card EXPANDIDO — usado por el CTA glass Y por el loop de scroll infinito. */
  window.AGCReturnToConfig = function () {
    if (window.__agcLenis) window.__agcLenis.scrollTo(cfgTop()); else window.scrollTo({ top: cfgTop(), behavior: 'smooth' });
    if (scroller) scroller.scrollTo({ top: 0, behavior: 'smooth' });
    setMode('config');
  };
  /* CTA glass "Configurar": aparece al perder de vista el product card (scroll a la historia embebida). */
  var backTopBtn = document.getElementById('agcBackTop');
  /* Loop "scroll infinito": al llegar al fondo de la historia (donde estaba el showcase removido),
     regresa al configurador. Guard de settle (no pelea con el momentum: solo al borde mismo). */
  var loopArmed = false, loopT = 0;
  if (backTopBtn) {
    var btRaf = 0;
    function btUpd() {
      btRaf = 0;
      var y = window.scrollY || window.pageYOffset || 0;
      backTopBtn.classList.toggle('show', y > cfgTop() + innerHeight * 0.6);
      /* borde inferior: el usuario llegó al final → re-arma y, tras settle, hace loop al configurador */
      var atBottom = (y + innerHeight) >= (document.documentElement.scrollHeight - 6);
      if (atBottom) {
        if (!loopArmed) {
          loopArmed = true;
          clearTimeout(loopT);
          loopT = setTimeout(function () { if (loopArmed) { loopArmed = false; window.AGCReturnToConfig(); } }, 420);
        }
      } else { loopArmed = false; clearTimeout(loopT); }
    }
    window.addEventListener('scroll', function () { if (!btRaf) btRaf = requestAnimationFrame(btUpd); }, { passive: true });
    btUpd();
    backTopBtn.addEventListener('click', function () { window.AGCReturnToConfig(); });
  }
  /* islas FIJAS (annbar/toprail/promobar position:fixed): en embed la ventana scrollea, así que las ocultamos al pasar la 1ª pantalla (Pedro 2026-06-20) */
  (function () {
    var ir = 0;
    function iupd() { ir = 0; var _sy = cfgY(); root.classList.toggle('agc-isle-gone', _sy > innerHeight * 0.5); root.classList.toggle('agc-tr-gone', _sy > 28 || (scroller && scroller.scrollTop > 28)); /* Pedro 2026-06-25: el toprail se VA apenas scrollean (umbral 28px, cualquier scroll), no a la mitad — "luego luego se van con el scroll". Estático (sin follow). */ }
    window.addEventListener('scroll', function () { if (!ir) ir = requestAnimationFrame(iupd); }, { passive: true });
    iupd();
  })();
  /* hook para el basket del nav (.agcn-cartbtn): el onclick inline del snippet llama AGCNavCart() → abre el cart-morph, no navega a /cart */
  window.AGCNavCart = function () {
    getCart().then(function (cart) {
      /* renderCart maneja el caso vacío (muestra el empty state con "Seguir comprando"),
         así que SIEMPRE abrimos el cart — con items o vacío, como el cart live. */
      renderCart(cart); loadTapeteSheet(); setMode('cart'); startCartBar();
    }).catch(function () {
      /* fetch falló (sin red / in-app browser): abrir el morph IGUAL (vacío o último cacheado) en vez de navegar fuera (Pedro 2026-06-20) */
      try { renderCart(LASTCART || { items: [], item_count: 0, total_price: 0, items_subtotal_price: 0, original_total_price: 0, total_discount: 0, currency: 'MXN' }); loadTapeteSheet(); setMode('cart'); startCartBar(); } catch (e) {}
    });
    return true;
  };

  /* #7 — Modal Aguacero Care al finalizar pedido. Regla del cart LIVE: aparece SOLO si hay Ducha y NO hay Care (sin localStorage).
     id/clase renombrados a agcCfgCare* / .agc-cfg-care-* → 0 colisión con el #agcCareOverlay global de cart-drawer.liquid.
     El nodo se MUEVE a <body> en init: lo inmuniza del foster-parenting del parser y del CSS scopeado a #agc-cfg
     (el CSS de este overlay es standalone, posición fixed, vive donde viva). */
  var careOverlay = (function () {
    var ov = document.getElementById('agcCfgCareOverlay');
    if (ov && ov.parentElement !== document.body) document.body.appendChild(ov); /* idempotente: si ya está en body, no-op */
    return ov;
  })();
  /* F35 PIXEL: única salida a checkout del gate cart-island — commit de atribución y luego navegar. Fail-open: si el pixel no existe o falla, la venta sigue igual. */
  function _agcPxGo() {
    cfgTrack('cfg_checkout_click');   /* funnel: única salida a checkout — keepalive porque la página navega */
    return (window.AGCAttr ? AGCAttr.beforeCheckout().catch(function () {}) : Promise.resolve())
      .then(function () { window.location.href = '/checkout'; });
  }
  function checkoutOrCare() {
    getCart().then(function (cart) {
      var hasCare = cart.items.some(function (i) { return i.variant_id === CC.careVariant; });
      var hasDucha = cart.items.some(function (i) { return i.product_id === CFG.duchaProductId && i.original_price !== 0; });
      if (hasCare || !hasDucha) { _agcPxGo(); return; }
      var ov = careOverlay || document.getElementById('agcCfgCareOverlay');
      if (!ov) { _agcPxGo(); return; }
      ov.classList.remove('closing'); ov.classList.add('show'); ov.setAttribute('aria-hidden', 'false');
    }).catch(function () { _agcPxGo(); });
  }
  (function () {
    var ov = careOverlay; if (!ov) return;
    function closeCare() { animClose(ov); ov.setAttribute('aria-hidden', 'true'); }
    var yes = ov.querySelector('#agcCfgCareYes'), no = ov.querySelector('#agcCfgCareNo');
    if (yes) yes.addEventListener('click', function () {
      yes.disabled = true; yes.textContent = 'Agregando…';
      jpost('/cart/add.js', { items: [{ id: CC.careVariant, quantity: 1 }] })
        .then(function () { _agcPxGo(); })
        .catch(function () { _agcPxGo(); });
    });
    if (no) no.addEventListener('click', function () { _agcPxGo(); });
    var x = ov.querySelector('#agcCfgCareX'); if (x) x.addEventListener('click', closeCare); /* X arriba-izq → cerrar (si vuelven de checkout y el modal quedó abierto) */
    ov.addEventListener('click', function (e) { if (e.target === ov) closeCare(); }); /* backdrop → cerrar, quedarse en cart */
  })();

  $('#agcTiers').addEventListener('click', function (e) {
    var o = e.target.closest('.agc-opt'); if (!o) return;
    $$('.agc-opt[data-tier]').forEach(function (x) { x.classList.remove('on'); });
    o.classList.add('on');
    if (ROWS() && +o.dataset.tier === 3 && state.tier > 3) return;   /* la fila dice "N Baños": tocarla no debe bajar a 3 (para eso está el control 3·4·5·6) */
    state.tier = +o.dataset.tier;
    cfgTrack('cfg_tier_selected');
    ensureColorsLen(); /* ajusta colores por ducha al nuevo tier */
    render();
    updateCta();   /* refresca "Elegir mi acabado" ↔ "Elegir mis acabados" según tier (Pedro 2026-06-21) */
    requestAnimationFrame(placeAnnBar);   /* el card cambia de altura con el tier → reanclar annbar y ocultar la reseña si ya no cabe (Pedro 2026-07-03) */
  });

  /* control "¿Necesitas más? 4 · 5 · 6" — mismo efecto que tocar una card de tier, pero sin
     tocar la jerarquía de las 3 cards. Re-tocar el número activo regresa a 3. (Pedro 2026-08-11) */
  var moreBtns = $('#agcMoreBtns');
  if (moreBtns) moreBtns.addEventListener('click', function (e) {
    var b = e.target.closest('.agc-more-b'); if (!b) return;
    var t = +b.dataset.tier;
    state.tier = (state.tier === t && !ROWS()) ? 3 : t;
    cfgTrack('cfg_tier_selected');
    ensureColorsLen();
    render();
    updateCta();
    requestAnimationFrame(placeAnnBar);
  });

  /* cambio de color compartido (isla + color pill) — agotados SÍ seleccionables */
  function colorSoldOut() { var c = colorByKey(state.colorKey); return c && !c.available; }
  /* Silueta del colchón en el paso de color (Pedro 2026-09-15): máscara SVG en la tarjeta. Cada gota i es un cuenco = círculo de
     radio R centrado en la gota; el borde es el máximo suave (log-sum-exp) de los cuencos → curvas redondas entre gotas, sin picos.
     Solo la última fila toca la tarjeta. Se calcula en eventos (entrar, elegir, resize), nunca por cuadro; la hundida anima ~420ms. */
  var _dentW = 0;
  function dentShape(balls, W, H) {
    var k = 0.35, pts = [], x, i, sum, y, pad = 5;
    for (x = 0; x <= W; x += 2) {
      sum = 1;   /* término del borde plano (y = 0) */
      for (i = 0; i < balls.length; i++) {
        var b = balls[i], R = b.r + pad + b.sink * 0.5, dx = x - b.cx;
        var d = (Math.abs(dx) < R) ? Math.max(0, b.cy + b.sink + Math.sqrt(R * R - dx * dx)) : 0;
        sum += Math.exp(k * d) - 1;   /* fuera del cuenco aporta 0 → borde plano exacto en y = 0 */
      }
      y = Math.log(sum) / k;
      pts.push(x + ',' + Math.min(H - 1, Math.max(0, y)).toFixed(1));
    }
    return pts;
  }
  function paintDents() {
    var sc = document.querySelector('#agc-cfg .agc-islscroll'); if (!sc) return;
    var onColor = root.classList.contains('agc-step-color') && island.classList.contains('open');
    if (!onColor) {
      /* limpiar TODO lo que puso la silueta: dejar mask-size colgado recortaba el vidrio del paso 1 a una franja */
      if (sc.style.maskImage || sc.style.webkitMaskImage) {
        ['webkitMaskImage', 'maskImage', 'webkitMaskSize', 'maskSize', 'webkitMaskPosition', 'maskPosition', 'webkitMaskRepeat', 'maskRepeat'].forEach(function (k) { sc.style[k] = ''; });
      }
      return;
    }
    var rows = document.querySelectorAll('#agcColorHero .agc-csrow'), last = rows[rows.length - 1];
    var sws = last ? last.querySelectorAll('.agc-cssw') : []; if (!sws.length) return;
    /* posiciones de MAQUETACIÓN (offset*), no de pantalla: no cambian mientras la isla o las gotas entran deslizando */
    function layoutPos(el) { var x = 0, y = 0; while (el && el !== island) { x += el.offsetLeft; y += el.offsetTop; el = el.offsetParent; } return { x: x, y: y }; }
    var sp = layoutPos(sc), W = sc.offsetWidth, H = 64, balls = [], n;
    for (n = 0; n < sws.length; n++) {
      var bp = layoutPos(sws[n]), off = parseFloat(getComputedStyle(sws[n]).top) || 0, bw = sws[n].offsetWidth;
      balls.push({ cx: bp.x - sp.x + bw / 2, cy: bp.y - off - sp.y + sws[n].offsetHeight / 2, r: bw / 2, sink: sws[n].classList.contains('on') ? 5 : 0 });
    }
    _dentW = W;
    /* UNA sola pasada por cambio (Pedro 2026-09-16: "el configurador de fondo parpadea"): animar la máscara obligaba a repintar
       el blur de toda la tarjeta ~14 veces en 420ms. La gota sí conserva su hundimiento con rebote (CSS). */
    var pts = dentShape(balls, W, H);
    var mask = 'url("data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="' + W + '" height="' + H + '" viewBox="0 0 ' + W + ' ' + H + '"><path d="M0,' + H + ' L' + pts.join(' L') + ' L' + W + ',' + H + ' Z" fill="#000"/></svg>') + '"), linear-gradient(#000,#000)';
    sc.style.webkitMaskImage = sc.style.maskImage = mask;
    sc.style.webkitMaskSize = sc.style.maskSize = W + 'px ' + H + 'px, 100% calc(100% - ' + (H - 1) + 'px)';
    sc.style.webkitMaskPosition = sc.style.maskPosition = '0 0, 0 ' + (H - 1) + 'px';
    sc.style.webkitMaskRepeat = sc.style.maskRepeat = 'no-repeat';
  }
  window.addEventListener('resize', paintDents, { passive: true });
  /* el ancho de la tarjeta puede cambiar sin resize de ventana (desktop, isla que se ajusta): redibujar SOLO si cambia el ancho */
  if (window.ResizeObserver) {
    var _dentSc = document.querySelector('#agc-cfg .agc-islscroll');
    if (_dentSc) new ResizeObserver(function () { if (_dentSc.offsetWidth !== _dentW && root.classList.contains('agc-step-color')) paintDents(); }).observe(_dentSc);
  }
  var elegirImageIntent = 0, elegirImageInflight = Object.create(null);
  function swapElegirImage(key) {
    var img = $('#agcElegirImg'), src = CFG.elegirStrips && CFG.elegirStrips[key], intent = ++elegirImageIntent;
    if (!img || !src || !root.classList.contains('agc-step-color') || img.getAttribute('src') === src) return;
    function apply() {
      if (intent === elegirImageIntent && state.colorKey === key && root.classList.contains('agc-step-color') && img.getAttribute('src') !== src) img.src = src;
    }
    var flight = elegirImageInflight[src];
    if (!flight) {
      var pending = new Image(); pending.src = src;
      if (!pending.decode) { apply(); return; }
      try {
        flight = pending.decode();
        if (!flight || !flight.then) { apply(); return; }
        elegirImageInflight[src] = flight;
        flight.then(function () {
          if (elegirImageInflight[src] === flight) delete elegirImageInflight[src];
        }, function () {
          if (elegirImageInflight[src] === flight) delete elegirImageInflight[src];
        }).catch(function () {});
      } catch (e) { apply(); return; }
    }
    try {
      flight.then(apply, apply).catch(function () {});
    } catch (e) { apply(); }
  }
  function selectColor(key) {
    var c = colorByKey(key);
    if (!c) return;
    state.colorKey = key;
    syncThumb();              /* actualiza thumb + .on de las swatches de la isla */
    setHeroColor(key);        /* swap del strip + tinte SIN reiniciar la animación */
    /* paso "elegir color": galería del producto en el color elegido (lazy: solo carga estando en el paso) */
    swapElegirImage(key);
    render();
    $$(".agc-cpsw").forEach(function (x) { x.classList.toggle("on", x.dataset.c === key); });
    syncSoldPill();
    updateCta();
    if (window.__agc3dSync) window.__agc3dSync();   /* si el 3D está activo, recargar el GLB del color */
  }
  /* pickers GLOBALES (swatches + toprail pill) = color maestro → propaga a todas las duchas para que el color step lo herede (Pedro 2026-06-21) */
  /* Los colores se actualizan ANTES de selectColor: selectColor llama a render(), y render
     lee state.colors. Al revés (como estaba) el render veía el color viejo — por eso el aviso
     de pre-venta se quedaba encendido al volver a plata. Medido 2026-08-08. */
  function setGlobalColor(key) { for (var i = 0; i < state.colors.length; i++) state.colors[i] = key; selectColor(key); }
  $('#agcSwatches').addEventListener('click', function (e) {
    var s = e.target.closest('.agc-sw'); if (!s) return;
    cfgTrack('cfg_color_selected', { color: s.dataset.c });
    setGlobalColor(s.dataset.c);
  });
  var colorPill = $('#agcColorPill');
  if (colorPill) colorPill.addEventListener('click', function (e) {
    var b = e.target.closest('.agc-cpsw'); if (!b) return;
    cfgTrack('cfg_color_selected', { color: b.dataset.c });
    setGlobalColor(b.dataset.c);
  });

  /* ═══ Paso de color POR DUCHA (T2/T3) — Pedro 2026-06-21 ═══ */
  function colorByVariant(vid) {
    for (var i = 0; i < CFG.colors.length; i++) { if (Number(CFG.colors[i].variantId) === Number(vid)) return CFG.colors[i]; }
    return null;
  }
  function firstColorKey() { return (CFG.colors.filter(function (x) { return x.available; })[0] || CFG.colors[0]).key; }
  /* mantiene state.colors con largo = tier; rellena nuevas con el 1er color */
  function ensureColorsLen() {
    var fk = firstColorKey();
    if (!state.colors.length) state.colors = [fk];
    /* Duchas 4-6 (control "¿Necesitas más?", Pedro 2026-08-11): REPITEN el patrón ya elegido —
       la 4ª toma el color de la 1ª, la 5ª el de la 2ª, la 6ª el de la 3ª. Sin esto se rellenaban
       con el primer color disponible y el pedido salía con un acabado que nadie eligió. Las
       duchas 1-3 conservan el relleno original. */
    while (state.colors.length < state.tier) state.colors.push(state.colors.length >= 3 ? state.colors[state.colors.length % 3] : fk);
    if (state.colors.length > state.tier) state.colors = state.colors.slice(0, state.tier);
  }
  function _csSwatches(rowAttr, selKey) {
    var h = '';
    for (var i = 0; i < CFG.colors.length; i++) {
      var col = CFG.colors[i];
      var on = col.key === selKey ? ' on' : '';
      var so = col.available ? '' : ' soldout';
      h += '<div class="agc-cssw' + on + so + '" data-row="' + rowAttr + '" data-c="' + col.key + '">' + (colorUpList(col.key) ? '<em class="agc-cs-up">+' + fmt(colorUpNow(colorUpList(col.key), Math.max(1, state.tier))) + (rowAttr === 'all' ? '<small> c/u</small>' : '') + '</em>' : '')   /* Pedro 2026-09-23: en "Tus N duchas" el recargo es por ducha → "c/u"; con el % del tier elegido */ + '<img src="' + (col.img || '') + '" alt="" loading="lazy"><span>' + (col.name.split(' ')[0]) + '</span></div>';
    }
    return h;
  }
  /* T2/T3: por default UNA fila global (92% pide todas iguales — data 2026-06). Toggle opt-in para colores distintos por ducha (el 8%). Pedro 2026-06-27 */
  function buildColorStepRows() {
    ensureColorsLen();
    var host = $('#agcColorStepRows'); if (!host) return;
    var title = $('#agcColorStepTitle');
    var html = '';
    /* El nombre del color ya vive bajo cada acabado (paso de color v2) → se sale de los labels
       para no decir lo mismo dos veces (Pedro 2026-08-12). En T1 el label desaparece entero:
       sin el color no aportaba nada. En T2/T3 se queda porque identifica la fila Y sostiene el
       toggle "Color distinto / Mismo color" — quitarlo ahí rompería la selección por ducha. */
    if (state.tier === 1) {
      if (title) title.textContent = '¿Qué color deseas?';
      html = '<div class="agc-csrow" data-row="0"><div class="agc-csrow-sw">' + _csSwatches('0', state.colors[0]) + '</div></div>';
    } else if (!state.colorPerDucha) {
      if (title) title.textContent = '¿Qué color quieres?';
      var allSame = state.colors.slice(0, state.tier).every(function (k) { return k === state.colors[0]; });
      var tgOn = '<button type="button" class="agc-csperducha" data-perducha="on">Color distinto<span class="agc-cspd-chev" aria-hidden="true">›</span></button>';
      /* "mezcla" SÍ se queda: cuando las duchas traen colores distintos ningún acabado sale
         marcado, y sin esta palabra la clienta ve 4 frames apagados sin explicación. El nombre
         del color cuando son todas iguales sí se fue — ese ya está bajo el frame. 2026-08-12 */
      html = '<div class="agc-csrow" data-row="all"><div class="agc-csrow-lb"><span class="agc-csrow-t">Tus ' + state.tier + ' duchas' + (allSame ? '' : ': mezcla') + '</span>' + tgOn + '</div><div class="agc-csrow-sw">' + _csSwatches('all', allSame ? state.colors[0] : null) + '</div></div>';
    } else {
      if (title) title.textContent = '¿Qué color para cada ducha?';
      var tgOff = '<button type="button" class="agc-csperducha" data-perducha="off">Mismo color<span class="agc-cspd-chev" aria-hidden="true">›</span></button>';
      if (ROWS()) {
        /* MOCK filas, ronda 7 (Pedro 2026-09-19: "corrijamos lo feo de elegir color distinto…
           ¿qué haría Apple?"): UNA sola fila de acabados sin importar cuántas duchas, y arriba
           pestañas 1·2·3… con la miniatura del acabado que lleva cada una. Elegir color salta sola
           a la siguiente ducha. La fila conserva data-row=n, así que el handler de siempre
           (state.colors[n], agotados, paintDents) sigue mandando. */
        var cd = Math.min(state.cdIdx || 0, state.tier - 1); state.cdIdx = cd;
        var tabs = '';
        for (var t = 0; t < state.tier; t++) {
          var tc = colorByKey(state.colors[t]);
          tabs += '<button type="button" class="agc-cdtab' + (t === cd ? ' on' : '') + '" data-cdtab="' + t + '" aria-label="Ducha ' + (t + 1) + (tc ? ': ' + tc.name : '') + '"><img src="' + ((tc && tc.img) || '') + '" alt=""><span>' + (t + 1) + '</span></button>';
        }
        html = '<div class="agc-csrow" data-row="' + cd + '"><div class="agc-csrow-lb agc-cdhead"><div class="agc-cdtabs' + (state.tier > 4 ? ' is-tight' : '') + '" role="tablist" aria-label="Ducha ' + (cd + 1) + ' de ' + state.tier + '">' + tabs + '</div>' + tgOff + '</div>'
             + '<div class="agc-csrow-sw">' + _csSwatches('' + cd, state.colors[cd]) + '</div></div>';
      } else
      for (var n = 0; n < state.tier; n++) {
        html += '<div class="agc-csrow" data-row="' + n + '"><div class="agc-csrow-lb"><span class="agc-csrow-t">Ducha ' + (n + 1) + '</span>' + (n === 0 ? tgOff : '') + '</div><div class="agc-csrow-sw">' + _csSwatches('' + n, state.colors[n]) + '</div></div>';
      }
    }
    host.innerHTML = html;
    paintDents();
  }
  /* `restoring` = el paso se está REPINTANDO desde sessionStorage (recarga / regreso del
     checkout), no lo pidió una persona. Solo apaga el armado del carrito. Pedro 2026-09-19. */
  function setStep(step, restoring) {
    /* Salir de Care YA NO invalida el carrito: el re-armado ahora lo decide la firma de la
       configuración (ver careEntry). Si el usuario vuelve a entrar sin haber cambiado nada, no
       se toca el carrito; si cambió color/tier/plan, la firma cambia y se re-arma — con su ATC.
       Antes eran 2 llamadas a /cart/*.js en CADA entrada y un usuario indeciso se ganaba solo
       el 429 de Shopify. 2026-08-06 */
    /* dirección de la transición (Pedro 2026-08-18): avanzar = el paso entra desde la
       derecha, regresar = desde la izquierda. Las clases solo GATEAN animaciones CSS
       (transform+opacity, GPU) — cero costo de layout. */
    var _ord = { config: 0, color: 1, care: 2, anual: 2 };
    root.classList.remove('agc-anim-fwd', 'agc-anim-back');
    root.classList.add((_ord[step] || 0) >= (_ord[state.step] || 0) ? 'agc-anim-fwd' : 'agc-anim-back');
    state.step = step;
    if (step === 'care') cfgTrackOnce('cfg_step_shown');
    /* con la fila, el "step" de Care ES el paso de color: ahí se muestra la oferta */
    if (step === 'color' && careRowOn()) cfgTrackOnce('cfg_step_shown');
    root.classList.toggle('agc-step-color', step === 'color');
    root.classList.toggle('agc-step-care', step === 'care');
    root.classList.toggle('agc-step-anual', step === 'anual');
    /* LATENCIA (Pedro 2026-09-21: "del click de ACEPTAR OFERTA o NO GRACIAS se tarda mucho en llevar al checkout"):
       los atributos del carrito (pixel + extras) se mandan AL ENTRAR al último paso, no en el clic. Si después
       hay un clear.js (cambio de color/tier, pageshow) el flag se apaga y goCheckout los vuelve a mandar. */
    if (step === 'anual') {
      Promise.resolve(state.careAddPromise).then(function () {
        if (!state.cartBuilt) return;
        var xa0 = checkoutExtraAttrs(), px0;
        try {
          if (window.AGCAttr && AGCAttr.setExtras) AGCAttr.setExtras(xa0);
          px0 = window.AGCAttr ? AGCAttr.beforeCheckout().catch(function () { return { reason: 'error' }; }) : Promise.resolve({ reason: 'disabled' });
        } catch (e) { px0 = Promise.resolve({ reason: 'disabled' }); }
        var sigAt = state.cartSig;
        return px0.then(function (r) { if (r && r.reason === 'disabled') return jpost('/cart/update.js', { attributes: xa0 }); })
          .then(function () { if (state.cartBuilt && state.cartSig === sigAt) state.attrsSig = sigAt; })
          .catch(function () { });
      });
    }
    try { syncShowroomPad(); } catch (e) { }
    /* la isla de gotas entra deslizando (.42s): se dibuja al llegar y otra vez al asentarse, con las posiciones finales */
    requestAnimationFrame(function () { requestAnimationFrame(paintDents); });
    setTimeout(paintDents, 520);
    /* el aro del CTA da 1 vuelta por paso (en vez de girar infinito): reinicio sin reflow forzado */
    root.classList.add('agc-glow-reset');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.remove('agc-glow-reset'); }); });
    if (step === 'color') {
      buildColorStepRows(); selectColor(state.colors[0]);
      /* RED DE SEGURIDAD (Pedro 2026-09-20: "se rompió el step 2 y no mostró las imágenes de las
         variantes de arriba"). swapElegirImage() se rinde si el color cambió fuera de este paso, si
         no hay strip para esa llave o si el decode nunca resuelve; entonces la banda de arriba queda
         VACÍA. Aquí se pone la imagen directo, sin decode ni condiciones, y se revisa otra vez al
         asentarse el paso. La imagen trae su propia animación (agcElegirPan), así que al aparecer
         ya viene animada. */
      (function () {
        var ei = $('#agcElegirImg');
        if (!ei) return;
        function rescate() {
          if (!root.classList.contains('agc-step-color')) return;
          var k = state.colorKey || (state.colors && state.colors[0]);
          var sc = CFG.elegirStrips && CFG.elegirStrips[k];
          if (sc && !ei.getAttribute('src')) ei.src = sc;
        }
        rescate();
        setTimeout(rescate, 700);
      })();
      /* RESTAURAR NO ES COMPRAR (Pedro 2026-09-19): repintar el paso tras una recarga o al
         volver del checkout armaba el carrito sin humano → AddToCart fantasma en Meta, y
         carrera con el clear de pageshow (carrito VACÍO con cartBuilt=true → al pago sin
         productos). Al restaurar se deja el carrito sin armar y la firma en null: el armado
         —y su ATC— lo dispara el clic de IR AL PAGO en proceedCheckout, que sí re-arma cuando
         cartBuilt es false. Entrar por el botón del paso 1 no pasa por aquí: sigue armando. */
      if (restoring) { state.cartBuilt = false; state.cartSig = null; state.attrsSig = null; }
      else colorEntryCart();   /* arma el carrito aquí = el AddToCart de Meta sigue siendo mid-funnel */
      /* 2ª oportunidad del Set Anual (Pedro 2026-08-18; TODOS los tiers desde 2026-09-14: "en el
         2do step no muestra ritual para t1 y t2, añadelos también") solo si NO lo tomaron en
         el step 1. Si lo agregaron AQUÍ (ritualViaRow), la fila sigue visible en re-entradas
         para poder quitarlo. Un set por ducha (buildBaseItems mete qty = tier). */
      var _rr = $('#agcRitRow');
      if (_rr) {
        var _rrShow = CFG.anual && CFG.anual.variantId && (!state.ritualSel || state.ritualViaRow);
        _rr.hidden = !_rrShow;
        if (_rrShow) paintRitRow();
      }
      /* cada vez que entran al paso color, el plan se resetea a Plus+ (default). Si eligieron Base y se salieron, al volver vuelve a Plus+ preseleccionado. Pedro 2026-06-27 */
      window.__agcPlan = 'plus';
      var _pw = document.getElementById('agcPlan');
      if (_pw) { _pw.setAttribute('data-plan', 'plus'); _pw.querySelectorAll('.agc-plan-row').forEach(function (r) { r.classList.toggle('is-sel', r.getAttribute('data-plan') === 'plus'); }); }
    }
    updateCta();
    renderCupon();   /* el stack de precio depende del paso: Care entra al Total en el paso color y su línea aparece/desaparece (Pedro 2026-08-19 v3) */
    requestAnimationFrame(placeAnnBar);   /* el card cambia de altura al entrar/salir del paso color → reanclar el annbar 12px arriba (Pedro 2026-06-21) */
  }
  (function () {
    var host = $('#agcColorStepRows');
    if (host) host.addEventListener('click', function (e) {
      var tg = e.target.closest('.agc-csperducha');
      if (tg) {   /* toggle entre color único (global) y distinto por ducha */
        state.colorPerDucha = tg.getAttribute('data-perducha') === 'on';
        if (!state.colorPerDucha) setGlobalColor(state.colors[0]);   /* al volver a "mismo", unifica al 1ro */
        buildColorStepRows();
        selectColor(state.colors[0]);
        return;
      }
      var sw = e.target.closest('.agc-cssw'); if (!sw) return;
      var key = sw.getAttribute('data-c');
      cfgTrack('cfg_color_selected', { color: key });
      if (sw.getAttribute('data-row') === 'all') {   /* fila global → aplica a TODAS las duchas */
        var swg = colorByKey(key);
        if (swg && !swg.available) { selectColor(key); return; }   /* agotado: no se propaga a las duchas (2026-08-06) */
        setGlobalColor(key);
        sw.closest('.agc-csrow-sw').querySelectorAll('.agc-cssw').forEach(function (x) { x.classList.toggle('on', x.getAttribute('data-c') === key); });
        paintDents();
        return;
      }
      var n = +sw.getAttribute('data-row');
      /* Un acabado agotado elegido para la ducha 2 se quedaba en state.colors y viajaba al
         /cart/add.js, que lo tumbaba con 422 (colorSoldOut() solo mira el último color tocado).
         Aquí no se asigna: la swatch no toma 'on' y sigue marcada como agotada. 2026-08-06 */
      var swc = colorByKey(key);
      if (swc && !swc.available) { selectColor(key); return; }
      state.colors[n] = key;
      host.querySelectorAll('.agc-cssw[data-row="' + n + '"]').forEach(function (x) { x.classList.toggle('on', x.getAttribute('data-c') === key); });
      selectColor(key); /* el hero refleja el último color tocado */
      paintDents();
    });
    if (host) host.addEventListener('click', function (e) {
      if (!ROWS() || !state.colorPerDucha) return;
      var tb = e.target.closest('.agc-cdtab');
      if (tb) { state.cdIdx = +tb.getAttribute('data-cdtab'); buildColorStepRows(); selectColor(state.colors[state.cdIdx]); return; }
      var sw = e.target.closest('.agc-cssw'); if (!sw) return;
      var n = +sw.getAttribute('data-row'), key = sw.getAttribute('data-c');
      if (state.colors[n] !== key) return;   /* agotado: el handler original no lo asignó → no se avanza */
      clearTimeout(state._cdT);
      state._cdT = setTimeout(function () {
        if (!state.colorPerDucha) return;
        if (n < state.tier - 1) state.cdIdx = n + 1;
        buildColorStepRows();
        selectColor(state.colors[state.cdIdx]);
      }, 420);
    });
    var back = $('#agcColorStepBack');
    if (back) back.addEventListener('click', function () { setStep('config'); });
  })();

  function syncSoldPill() {
    var sold = colorSoldOut();
    root.classList.toggle("is-soldout", sold);
    if (sold) {
      var c = colorByKey(state.colorKey);
      var span = document.querySelector('#agcSoldPill span');
      if (span && c) span.textContent = (c.name.split(' ')[0]) + ' agotado';
    }
  }

  /* ═══════════════ CART ENGINE (cart-morph) ═══════════════ */
  var CC = CFG.cart || {};
  var LASTCART = null;
  /* RED ROBUSTA (2026-08-06, bug "Dirigiendo al pago…"): Shopify contesta 429 con HTML
     ("Verifying your connection…") a /cart/*.js cuando llegan varios seguidos desde una IP —
     entrar y salir del step Care un par de veces desde el webview de Instagram o red móvil
     compartida basta. El r.json() sobre ese HTML reventaba y los CTA quedaban congelados.
     Ahora: timeout, reintento con backoff en 429/5xx/red, y r.ok obligatorio → un 422 ya no
     se puede confundir con éxito (antes mandaba al checkout con el carrito vacío). */
  var JPOST_TIMEOUT_MS = 8000, JPOST_RETRIES = 2;
  function jfetch(url, opts, timeoutMs) {
    var ctl = null, tid = null;
    try { if (typeof AbortController === 'function') ctl = new AbortController(); } catch (e) { ctl = null; }
    if (ctl) opts.signal = ctl.signal;
    var timer = new Promise(function (_, rej) {
      tid = setTimeout(function () { try { if (ctl) ctl.abort(); } catch (e) {} rej(new Error('timeout')); }, timeoutMs);
    });
    function done(v) { if (tid) clearTimeout(tid); return v; }
    return Promise.race([fetch(url, opts), timer])
      .then(done, function (e) { done(); throw e; });
  }
  function jbackoff(n) { return new Promise(function (res) { setTimeout(res, 600 * Math.pow(2, n)); }); }
  function jpost(url, body, _try) {
    _try = _try || 0;
    var opts = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) };
    return jfetch(url, opts, JPOST_TIMEOUT_MS).then(function (r) {
      if (r.ok) return r.json();
      if ((r.status === 429 || r.status >= 500) && _try < JPOST_RETRIES) {
        return jbackoff(_try).then(function () { return jpost(url, body, _try + 1); });
      }
      var err = new Error('http_' + r.status);
      err.status = r.status;
      return r.json().then(function (j) { err.body = j; throw err; }, function () { throw err; });
    }, function (netErr) {
      if (_try < JPOST_RETRIES) return jbackoff(_try).then(function () { return jpost(url, body, _try + 1); });
      throw netErr;
    });
  }
  function getCart() {
    return jfetch('/cart.js', {}, JPOST_TIMEOUT_MS).then(function (r) {
      if (!r.ok) { var e = new Error('http_' + r.status); e.status = r.status; throw e; }
      return r.json();
    });
  }
  function refreshCount() {
    getCart().then(function (c) { var el = $('#agcCartCount'); if (el) el.textContent = c.item_count; }).catch(function () {});
  }

  /* compare-at por item (hardcodes verificados del live) */
  function itemCompare(it) {
    if (it.product_id === CFG.duchaProductId) return CC.duchaCompareUnit * it.quantity;
    if (it.variant_id === CC.annualVariant) return CC.annualCompare * it.quantity;
    if (it.variant_id === CC.careVariant) return CC.careCompare * it.quantity;
    if (it.product_id === CC.tapeteProductId) return CC.tapeteCompare * it.quantity;
    return it.original_line_price;
  }
  function findItem(cart, pred) {
    for (var i = 0; i < cart.items.length; i++) if (pred(cart.items[i])) return cart.items[i];
    return null;
  }
  function duchaQty(cart) {
    var q = 0;
    cart.items.forEach(function (it) { if (it.product_id === CFG.duchaProductId && it.original_price !== 0) q += it.quantity; });
    return q;
  }

  /* render de una línea de carrito (glass) */
  function cartItemRow(it) {
    var el = document.createElement('div');
    el.className = 'agc-citem';
    el.setAttribute('data-key', it.key);
    var compare = itemCompare(it);
    /* FIX (Pedro 2026-06-21): el sufijo de resize va ANTES de la extensión (_120x$1$2), no reemplazándola — antes generaba "...png?"→"..._120x?" (sin .png) = imagen rota (Set Anual y cualquier item con it.image) */
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : (it.featured_image && it.featured_image.url) || '';
    /* ducha usa el render limpio del color elegido */
    var isDucha = it.product_id === CFG.duchaProductId;
    /* en el carrito la ducha conserva la foto con fondo cream (cartImg), no el render transparente */
    if (isDucha) { var cc = colorByVariant(it.variant_id) || colorByKey(state.colorKey); if (cc && (cc.cartImg || cc.img)) img = cc.cartImg || cc.img; }
    var sub = '';
    if (isDucha) {
      var cname = (it.options_with_values && it.options_with_values[0] && it.options_with_values[0].value) || (colorByVariant(it.variant_id) || colorByKey(state.colorKey)).name;
      sub = cname + (it.selling_plan_allocation ? ' · ' + it.selling_plan_allocation.selling_plan.name : '');
    } else if (it.selling_plan_allocation) {
      sub = it.selling_plan_allocation.selling_plan.name;
    } else if (it.variant_title && it.variant_title !== 'Default Title') {
      sub = it.variant_title;
    }
    var priceHtml = '<b>' + fmt(it.final_line_price) + '</b>' + (compare > it.final_line_price ? '<s>' + fmt(compare) + '</s>' : '');

    /* FILTRO INICIAL INCLUIDO (aguacero08): bundled/locked — sin qty, sin eliminar.
       1 por ducha, sincronizado por setDuchaQty. El cliente no lo edita directamente. */
    /* FILTRO INICIAL A-0 (compra única, $387 desde 22-sep): también bloqueado — sin "Quitar" ni qty.
       Si el cliente lo pudiera borrar pagaría la ducha al 30 % sin suscripción (fuga detectada 2026-09-22). */
    if (CFG.filtroOnceVariantId && it.variant_id === CFG.filtroOnceVariantId) {
      el.classList.add('agc-citem--locked');
      el.innerHTML =
        '<div class="agc-cithumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="agc-citinfo">' +
          '<div class="agc-cittitle">' + (it.product_title || it.title) + '</div>' +
          '<div class="agc-citsub">' + it.quantity + '× Compra única</div>' +
        '</div>' +
        '<div class="agc-citright">' +
          '<div class="agc-citprice"><b>' + fmt(it.final_line_price) + '</b><s>' + fmt((CFG.filtroCompare || 59000) * it.quantity) + '</s></div>' +
        '</div>';
      return el;
    }
    if (it.product_id === CFG.filtroProductId) {
      el.classList.add('agc-citem--locked');
      /* precio: $0 con el valor real del filtro ($590 c/u) tachado al lado (ancla de valor) */
      var fCompare = (CFG.filtroCompare || 59000) * it.quantity;
      var fPriceHtml = '<b>' + fmt(it.final_line_price) + '</b><s>' + fmt(fCompare) + '</s>';
      el.innerHTML =
        '<div class="agc-cithumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="agc-citinfo">' +
          '<div class="agc-cittitle">' + (it.product_title || it.title) + '</div>' +
          '<div class="agc-citsub">' + it.quantity + '× Incluido con tu ducha</div>' +
        '</div>' +
        '<div class="agc-citright">' +
          '<div class="agc-citprice">' + fPriceHtml + '</div>' +
          '<div class="agc-citlocked" style="font-size:10.5px;opacity:.55;font-weight:600;letter-spacing:.03em;text-transform:uppercase;text-align:right;margin-top:2px">Incluido</div>' +
        '</div>';
      return el;
    }

    el.innerHTML =
      '<div class="agc-cithumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
      '<div class="agc-citinfo">' +
        '<div class="agc-cittitle">' + (it.product_title || it.title) + '</div>' +
        (sub ? '<div class="agc-citsub">' + sub + '</div>' : '') +
      '</div>' +
      '<div class="agc-citright">' +
        '<div class="agc-citprice">' + priceHtml + '</div>' +
        '<div class="agc-citqtyrow">' +
          '<div class="agc-citqty"><button class="m" data-act="dec" aria-label="Restar">−</button><span>' + it.quantity + '</span><button class="p" data-act="inc" aria-label="Sumar">+</button></div>' +
          '<button class="agc-citrm" data-act="rm" aria-label="Quitar"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M4 7h16M9 7V5h6v2m1 0-1 13H8L7 7"/></svg></button>' +
        '</div>' +
      '</div>';
    return el;
  }

  function renderCart(cart) {
    LASTCART = cart;
    /* estado VACÍO (espejo del cart live): oculta scroll+totales, muestra el empty con CTA "Seguir comprando" */
    var isEmpty = cart.item_count === 0;
    /* cart vacío → ocultar el "Finalizar pedido" + el ticker eta (no hay qué finalizar). Scopeado a cart-mode por CSS. */
    if (island) island.classList.toggle('cart-empty', isEmpty);
    var emptyEl = $('#agcCartEmpty');
    var scrollEl = root.querySelector('.agc-cartscroll');
    var totalsEl = root.querySelector('.agc-carttotals');
    if (emptyEl) emptyEl.hidden = !isEmpty;
    if (scrollEl) scrollEl.style.display = isEmpty ? 'none' : '';
    if (totalsEl) totalsEl.style.display = isEmpty ? 'none' : '';
    if (isEmpty) {
      var hn0 = $('#agcCartHeadN'); if (hn0) hn0.textContent = '';
      var cn0 = $('#agcCartCount'); if (cn0) cn0.textContent = '0';
      return;
    }
    var dq = duchaQty(cart);
    /* INVARIANTE (Pedro 2026-06-23): el Filtro Inicial Incluido = 1 por ducha, SIEMPRE.
       Red de seguridad self-healing: si quedó desincronizado por cualquier ruta (ej. quitar una
       ducha de un tier 2/3 sin que el sync corriera), reconciliar la qty del filtro AL # de duchas
       antes de pintar. Idempotente: el flag _filtroFixed en el cart evita re-entrar en loop si la
       corrección falla; tras un cambio exitoso getCart ya trae la qty correcta → no re-corre. */
    var fItem = findFiltro(cart);
    if (fItem && fItem.quantity !== dq && !cart._filtroFixed) {
      return jpost('/cart/change.js', { id: fItem.key, quantity: Math.max(0, dq) })
        .then(getCart)
        .then(function (c) { c._filtroFixed = true; return renderCart(c); })
        .catch(function () { cart._filtroFixed = true; return renderCart(cart); });
    }
    var hasAnnual = !!findItem(cart, function (i) { return i.variant_id === CC.annualVariant; });
    var hasCare = !!findItem(cart, function (i) { return i.variant_id === CC.careVariant; });
    var hasTapete = !!findItem(cart, function (i) { return i.product_id === CC.tapeteProductId; });

    /* líneas: ducha + annual + tapete (care y demás extras no se listan, viven en cross-sell) */
    var grid = $('#agcCartItems');
    grid.innerHTML = '';
    cart.items.forEach(function (it) {
      if (it.variant_id === CC.careVariant) return; /* care = toggle, no línea */
      grid.appendChild(cartItemRow(it));
    });

    /* cross-sell visibility */
    /* Set Anual de filtros: SOLO en tier 1 (qty ducha === 1). En tier 2+ no se ofrece. */
    var xAnnual = $('#agcXAnnual');
    if (xAnnual) xAnnual.hidden = !(dq === 1 && !hasAnnual);
    var xTapete = $('#agcXTapete');
    if (xTapete) xTapete.hidden = hasTapete;
    /* Care: al agregarlo la card DESAPARECE y aparecen las líneas de garantía */
    var xCare = $('#agcXCare');
    if (xCare) xCare.hidden = hasCare;
    var careToggle = $('#agcXCareToggle');
    if (careToggle) { careToggle.classList.toggle('on', hasCare); careToggle.setAttribute('aria-checked', hasCare ? 'true' : 'false'); }
    $$('.agc-ct-care').forEach(function (r) { r.hidden = !hasCare; });
    var warr = $('#agcCtWarr'); if (warr) { warr.textContent = hasCare ? '100 días' : '60 días'; warr.classList.toggle('agc-ct-on', hasCare); }

    /* totales */
    var compareTotal = 0;
    cart.items.forEach(function (it) { compareTotal += itemCompare(it); });
    $('#agcCtCount').textContent = cart.item_count;

    /* MODELO NUEVO: el descuento de tier vive en el precio del selling plan →
       cart.total_price YA es el precio correcto (no se computa nada, no hay RITUAL-A0).
       Subtotal real = cart.total_price. Tachado = compareTotal (precio lista). */
    var finalSub = cart.total_price;
    $('#agcCtSubFinal').textContent = fmt(finalSub);
    var sc = $('#agcCtSubCompare');
    if (compareTotal > finalSub) { sc.textContent = fmt(compareTotal); sc.style.display = ''; }
    else { sc.style.display = 'none'; }

    /* Línea de descuento: LEE el cart real (cart_level_discount_applications), igual que
       cart-drawer.liquid. Con selling plans no hay cart-level discount → queda oculta (correcto).
       Si en el futuro hay un código de cupón, lo muestra automáticamente. */
    var disc = $('#agcCtDiscount');
    if (disc) {
      var cdis = (cart.cart_level_discount_applications || []).filter(function (d) { return (d.total_allocated_amount || 0) > 0; });
      if (cdis.length) {
        var dTotal = 0;
        cdis.forEach(function (d) { dTotal += (d.total_allocated_amount || 0); });
        $('#agcCtDiscountLabel').textContent = 'Código Aplicado · ' + (cdis[0].title || cdis[0].code || '');
        $('#agcCtDiscountAmt').textContent = '−' + fmt(dTotal);
        disc.hidden = false;
      } else { disc.hidden = true; }
    }

    var headN = $('#agcCartHeadN'); if (headN) headN.textContent = cart.item_count + (cart.item_count === 1 ? ' artículo' : ' artículos');
    var cnt = $('#agcCartCount'); if (cnt) cnt.textContent = cart.item_count;
  }

  function reloadCart() { return getCart().then(renderCart); }

  /* mutaciones */
  function cartChange(key, qty) {
    return jpost('/cart/change.js', { id: key, quantity: qty }).then(renderCart);
  }
  /* Set Anual quitado (basura) o bajado con «−» cuando llevaba su plan «Cada año» (Plus+ prendido): esas duchas regresan del
     A-0 al Filtro Inicial con Plus+. Antes el A-0 se quedaba solo y el pedido salía sin Set y sin renovación (20 pedidos
     10-20 oct, Pedro 2026-10-20). Misma regla que el cajón (cart-drawer.liquid, _agcSetQuitadoSwap). Sin plan no toca nada. */
  function setQuitadoSwap(cart, item, q) {
    if (!q || !cart || !(item.sku === 'aguacero12' || item.variant_id === CC.annualVariant) || !item.selling_plan_allocation) return null;
    if (!CFG.filtroVariantId || !CFG.filtroPlanId || !CFG.filtroOnceVariantId) return null;
    var a0 = cart.items.filter(function (i) { return i.variant_id === CFG.filtroOnceVariantId; });
    a0.sort(function (x, y) { return ((y.properties || {})['Va dentro de'] ? 1 : 0) - ((x.properties || {})['Va dentro de'] ? 1 : 0); });
    var falta = q, quita = [];
    a0.forEach(function (i) { if (falta <= 0) return; var k = Math.min(falta, i.quantity); quita.push({ key: i.key, quantity: i.quantity - k }); falta -= k; });
    var n = q - falta;
    return n ? { quita: quita, n: n } : null;
  }
  function aplicaSetQuitado(sw) {
    return sw.quita.reduce(function (ch, x) {
      return ch.then(function () { return jpost('/cart/change.js', { id: x.key, quantity: x.quantity }); });
    }, Promise.resolve()).then(function () {
      return jpost('/cart/update.js', { attributes: { '_agc_set_quitado': sw.n + ' · Plus+' } });
    }).then(function () {
      return jpost('/cart/add.js', { items: [{ id: CFG.filtroVariantId, quantity: sw.n, selling_plan: CFG.filtroPlanId }] });
    }).then(reloadCart);
  }
  /* tier↔plan sync DENTRO del cart: el tier = qty de la ducha, y CADA tier tiene su PROPIO
     selling plan (descuento creciente vía Kaching). /cart/change.js NO cambia selling_plan →
     al subir O bajar qty hay que remover la línea ducha y re-agregarla con el plan correcto,
     o el cliente baja a tier 1 conservando el descuento de tier 2/3 (bug). tier 3 y arriba =
     mismo plan (índice 2). qty 0 = quitar la línea. Preserva el color actual. */
  /* Filtro Inicial Incluido: 1 por ducha, bundled. Se sincroniza a la qty de la ducha
     y se elimina con ella. NUNCA editable por el cliente directamente. */
  function findFiltro(cart) {
    return findItem(cart, function (i) { return i.product_id === CFG.filtroProductId; });
  }
  function setDuchaQty(n) {
    if (!LASTCART) return Promise.resolve();
    var d = findItem(LASTCART, function (i) { return i.product_id === CFG.duchaProductId && i.original_price !== 0; });
    if (!d) return Promise.resolve();
    var f = findFiltro(LASTCART);
    if (n <= 0) {
      /* quitar ducha = quitar también su filtro inicial (bundled) */
      return jpost('/cart/change.js', { id: d.key, quantity: 0 })
        .then(function () { return f ? jpost('/cart/change.js', { id: f.key, quantity: 0 }) : null; })
        .then(reloadCart)
        .then(function () { startCartBar(); loadTapeteSheet(); });
    }
    /* MODELO NUEVO (2026-06-21): ducha one-time → cambiar qty directo. El Filtro Inicial
       (1 por ducha) se sincroniza a la misma qty. El descuento de tier (30/33/40%) lo
       re-evalúa el descuento automático de Kaching según la qty de duchas. /cart/change.js
       por key preserva el selling_plan del filtro. */
    state.tier = Math.min(n, 6);   /* 6 = tope real del carrito (cart-drawer) desde el control 4-6 */
    return jpost('/cart/change.js', { id: d.key, quantity: n })
      .then(function () { return f ? jpost('/cart/change.js', { id: f.key, quantity: n }) : null; })
      .then(function () { return reloadCart(); })
      .then(function () { startCartBar(); loadTapeteSheet(); })
      .catch(function () { reloadCart(); });
  }
  /* MULTI-COLOR (Pedro 2026-06-21): cambia una línea de ducha ESPECÍFICA (por key) y
     re-sincroniza el filtro al TOTAL de duchas (1 filtro por ducha). Correcto para 1 línea
     (single color) o varias (colores mixtos). El descuento de tier lo re-evalúa Kaching. */
  function setDuchaLineQty(key, n) {
    return jpost('/cart/change.js', { id: key, quantity: Math.max(0, n) })
      .then(function () { return getCart(); })
      .then(function (cart) {
        var total = duchaQty(cart);
        state.tier = Math.min(Math.max(total, 1), 6);
        var f = findFiltro(cart);
        if (f && f.quantity !== total) return jpost('/cart/change.js', { id: f.key, quantity: Math.max(0, total) }).then(getCart);
        return cart;
      })
      .then(renderCart)
      .then(function () { startCartBar(); loadTapeteSheet(); })
      .catch(function () { reloadCart(); });
  }

  /* eventos del carrito (delegación) */
  $('#agcCartItems').addEventListener('click', function (e) {
    var btn = e.target.closest('[data-act]'); if (!btn) return;
    var row = btn.closest('.agc-citem'); if (!row) return;
    var key = row.getAttribute('data-key');
    var item = findItem(LASTCART, function (i) { return i.key === key; });
    if (!item) return;
    var act = btn.dataset.act;
    /* #2 feedback: press táctil + loading durante el cambio async (patrón cart LIVE) */
    btn.classList.add('is-pressed'); setTimeout(function () { btn.classList.remove('is-pressed'); }, 130);
    var qtyCtl = btn.closest('.agc-citqty'); if (qtyCtl) qtyCtl.classList.add('is-loading');
    /* la basurita vive FUERA de .agc-citqty → su propio spinner (Pedro 2026-06-21: el delete tarda ~2s sin feedback) */
    if (btn.dataset.act === 'rm') btn.classList.add('is-removing');
    /* la DUCHA enruta su qty por setDuchaQty → re-mapea el selling plan al tier nuevo (subir Y bajar).
       Los demás ítems cambian qty normal. */
    var isDuchaItem = item.product_id === CFG.duchaProductId && item.original_price !== 0;
    var p;
    var sw = isDuchaItem ? null : act === 'rm' ? setQuitadoSwap(LASTCART, item, item.quantity) : act === 'dec' ? setQuitadoSwap(LASTCART, item, 1) : null;
    if (sw) p = cartChange(key, act === 'rm' ? 0 : item.quantity - 1).then(function () { return aplicaSetQuitado(sw); });
    else if (act === 'rm') p = isDuchaItem ? setDuchaLineQty(key, 0) : cartChange(key, 0);
    else if (act === 'dec') { var dq = Math.max(0, item.quantity - 1); p = isDuchaItem ? setDuchaLineQty(key, dq) : cartChange(key, dq); }
    else if (act === 'inc') { var iq = item.quantity + 1; p = isDuchaItem ? setDuchaLineQty(key, iq) : cartChange(key, iq); }
    if (p && p.catch) p.catch(function () { if (qtyCtl) qtyCtl.classList.remove('is-loading'); btn.classList.remove('is-removing'); });
  });

  /* cross-sell: Set Anual */
  var xAnnualBtn = $('#agcXAnnualBtn');
  if (xAnnualBtn) xAnnualBtn.addEventListener('click', function () {
    if (xAnnualBtn.hasAttribute('disabled')) return;
    xAnnualBtn.setAttribute('disabled', ''); xAnnualBtn.classList.add('is-loading'); xAnnualBtn.textContent = 'Agregando…';   /* feedback inmediato (Pedro 2026-06-21) */
    jpost('/cart/add.js', { items: [{ id: CC.annualVariant, quantity: 1 }] })
      .then(reloadCart).then(function () { xAnnualBtn.removeAttribute('disabled'); xAnnualBtn.classList.remove('is-loading'); xAnnualBtn.textContent = 'Agregar'; })
      .catch(function () { xAnnualBtn.removeAttribute('disabled'); xAnnualBtn.classList.remove('is-loading'); xAnnualBtn.textContent = 'Agregar'; });
  });

  /* cross-sell: Aguacero Care (opt-in toggle, sin auto-add) */
  var careToggle = $('#agcXCareToggle');
  if (careToggle) careToggle.addEventListener('click', function () {
    if (careToggle.classList.contains('is-loading')) return;
    var on = careToggle.classList.contains('on');
    careToggle.classList.add('is-loading');   /* feedback inmediato (Pedro 2026-06-21) */
    if (on) {
      var c = findItem(LASTCART, function (i) { return i.variant_id === CC.careVariant; });
      var p = c ? cartChange(c.key, 0) : Promise.resolve();
      p.then(function () { careToggle.classList.remove('is-loading'); });
    } else {
      careToggle.classList.add('on');   /* optimista: el check aparece al instante */
      jpost('/cart/add.js', { items: [{ id: CC.careVariant, quantity: 1 }] }).then(reloadCart)
        .then(function () { careToggle.classList.remove('is-loading'); })
        .catch(function () { careToggle.classList.remove('on'); careToggle.classList.remove('is-loading'); });
    }
  });
  var careRemove = $('#agcCtCareRemove');
  if (careRemove) careRemove.addEventListener('click', function () {
    var c = findItem(LASTCART, function (i) { return i.variant_id === CC.careVariant; });
    if (c) cartChange(c.key, 0);
  });

  /* cross-sell: Tapete (sheet de detalles) — réplica del modal HOT SALE (Pedro 2026-08-18).
     El overlay se MUDA a <body> (mismo patrón que el modal de Care): dentro de la isla el
     overflow:hidden + backdrop-filter lo capaban y las fotos salían cortadas. Por eso estos
     nodos se consultan con document, no con $ (que está scopeado a #agc-cfg). */
  var TAP_IMGS = null;
  var tapOv = (function () {
    var ov = document.getElementById('agcTapSheet');
    if (ov && ov.parentElement !== document.body) document.body.appendChild(ov); /* idempotente */
    return ov;
  })();
  function tapEl(id) { return document.getElementById(id); }
  function loadTapeteSheet() {
    var box = tapEl('agcTapImgs');
    if (TAP_IMGS || !box) return;
    fetch('/products/' + CC.tapeteHandle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      TAP_IMGS = (p.images || []).slice(0, 5).map(function (u) { return u.indexOf('//') === 0 ? 'https:' + u : u; });
      box.innerHTML = TAP_IMGS.map(function (u) { return '<img src="' + u + '&width=560" alt="" loading="lazy">'; }).join('');
      var th = $('#agcXTapeteThumb');   /* el thumb del xcard SÍ vive dentro de la isla */
      if (th && TAP_IMGS[0]) th.innerHTML = '<img src="' + TAP_IMGS[0] + '&width=120" alt="" loading="lazy">';
      var pr = tapEl('agcTapPrice'); if (pr && p.price) pr.textContent = fmt(p.price);
      var cm = tapEl('agcTapCompare'); if (cm && CC.tapeteCompare) cm.textContent = fmt(CC.tapeteCompare);
    }).catch(function () {});
  }
  function openTapeteOrCare(which) {
    loadTapeteSheet();   /* venga de donde venga el open, las fotos siempre cargan */
    if (tapOv) { tapOv.classList.remove('closing'); tapOv.classList.add('show'); }
  }
  var xTapBtn = $('#agcXTapeteBtn');
  if (xTapBtn) xTapBtn.addEventListener('click', function () { openTapeteOrCare('tapete'); });
  var tapClose = tapEl('agcTapClose');
  if (tapClose) tapClose.addEventListener('click', function () { animClose(tapOv); });
  var tapSkip = tapEl('agcTapSkip');
  if (tapSkip) tapSkip.addEventListener('click', function () { animClose(tapOv); });
  var tapNext = tapEl('agcTapNext');
  if (tapNext) tapNext.addEventListener('click', function () {
    var b = tapEl('agcTapImgs');
    if (!b) return;
    /* paso = ancho de foto + gap(10): desde un snap point aterriza EXACTO en la
       siguiente (0.8*clientWidth dejaba la foto asomada a la izq — Pedro 2026-08-18) */
    var im = b.querySelector('img');
    b.scrollBy({ left: im ? im.offsetWidth + 10 : Math.round(b.clientWidth * 0.8), behavior: 'smooth' });
  });
  if (tapOv) tapOv.addEventListener('click', function (e) { if (e.target === tapOv) animClose(tapOv); });
  var tapAdd = tapEl('agcTapAdd');
  if (tapAdd) tapAdd.addEventListener('click', function () {
    /* Si el sheet se abrió desde la FILA del paso de color (Pedro 2026-08-13), agregar = marcar
       la fila — el carrito lo arma buildBaseItems, igual que Care. El add directo solo aplica
       en la vista de carrito del configurador (donde el carrito ya existe). */
    if ($('#agcTapRow') && careRowOn() && !inCart()) {
      state.tapeteSel = true;
      cfgTrack('cfg_addon_added', { addon: 'tapete_row' });
      paintTapRow();
      renderCupon();
      animClose(tapOv);
      return;
    }
    tapAdd.setAttribute('disabled', '');
    cfgTrack('cfg_addon_added', { addon: 'tapete' });
    jpost('/cart/add.js', { items: [{ id: CC.tapeteVariant, quantity: 1 }] })
      .then(reloadCart).then(function () { animClose(tapOv); tapAdd.removeAttribute('disabled'); })
      .catch(function () { tapAdd.removeAttribute('disabled'); });
  });

  /* barra social rotativa del carrito */
  var cbIdx = 0, cbTimer = null;
  function startCartBar() {
    var items = $$('#agcCartBar span');
    if (!items.length || cbTimer) return;
    cbTimer = setInterval(function () {
      items[cbIdx].classList.remove('on');
      cbIdx = (cbIdx + 1) % items.length;
      items[cbIdx].classList.add('on');
    }, 5000);
  }
  function stopCartBar() { if (cbTimer) { clearInterval(cbTimer); cbTimer = null; } }

  /* ── CTA principal: collapsed→config, config→ATC+morph, cart→checkout ── */
  /* ── ÚLTIMO PASO "Tus 3 filtros del año." (Pedro 2026-09-14) ───────────────────────────────
     Paso DENTRO de la isla, después del de color, con la anatomía del viejo step de Care: hero +
     "Sí, agregar +$" + "No, continuar al pago" (Pedro: "un step muy, muy sencillo, como el que
     teníamos antes de Aguacero Care, pero ahora para el ritual… Solo es hacer que le piquen, ¿no
     o sí?"). Sí = state.ritualSel, el MISMO contrato de la fila (buildBaseItems mete aguacero12
     ×duchas, compra única) → el cobro sigue la ruta ya probada de proceedCheckout. El CTA
     principal está oculto en este paso (CSS inline del step). Se pregunta una vez por sesión de
     configuración; si el pago falla, careStepFail destraba los botones y dice el motivo aquí. */
  var ystep = { asked: false, prevRitual: false, prevViaRow: false };
  /* RITUAL A $1190 CON BAJADA A $990 (Pedro 2026-09-30: "el step de ritual en la pdp… meterle lo que hicimos con el step de
     ritual en encuesta, de primero en 1190 y luego en 990"). CFG.anualHi = el gemelo caro de la encuesta (mismo SKU aguacero12);
     con Aguacero Plus+ prendido solo vale si trae su plan "Cada año" (si no, quien lo compre se quedaría sin renovación). Quien
     dice que no ve la bajada UNA vez; de ahí en adelante (mismo navegador) entra directo a $990, igual que en la encuesta.
     Sin CFG.anualHi nada cambia: el paso ofrece solo el Set de $990. ritNow() = lo que el paso MUESTRA; ritPaid() = lo que se
     COBRA: el gemelo solo si lo aceptó a $1190 en este paso (state.ritAlto), nunca por una bandera heredada. */
  /* AGC-RIT-LOGIC:START (lógica pura; la prueba tests/theme/test_agc_ritual_bajada.mjs evalúa este bloque) */
  function ritSeen() { if (!state.ritBaj) { try { state.ritBaj = localStorage.getItem('agcRitBajada') === '1'; } catch (e) { } } return !!state.ritBaj; }
  function ritHi() { var H = CFG.anualHi; return (H && H.variantId && CFG.anual && H.price > CFG.anual.price && (state.subOff || H.planId)) ? H : null; }
  function ritTier() { return ritHi() ? (ritSeen() ? 'bajada' : 'alto') : 'normal'; }
  function ritNow() { return ritTier() === 'alto' ? ritHi() : CFG.anual; }
  function ritPaid() { return (state.ritAlto && ritHi()) || CFG.anual; }
  /* AGC-RIT-LOGIC:END */
  function yStepShould() {
    return !!(CFG.anualStep && !anivOn() && !ystep.asked && !state.ritualSel
      && CFG.anual && CFG.anual.variantId && CFG.anual.price > 0 && $('#agcRitStepSect'));
  }
  function yStepEnter() {
    ystep.prevRitual = state.ritualSel; ystep.prevViaRow = state.ritualViaRow;
    state.anualQty = null;   /* cada entrada al paso arranca en cobertura completa */
    paintRitStep();
    careStepClearMsg();
    setStep('anual');
    cfgTrack('cfg_anual_step_view', { tier: state.tier, rit: ritTier() });
  }
  /* Pinta el paso con la oferta vigente (ritNow). `from` = precio del que cae, solo en el instante de la bajada: el número baja
     contando frente a sus ojos, «Última oportunidad», y el mismo botón acepta. */
  function paintRitStep(from) {
    var A = ritNow(), baj = ritTier() === 'bajada', n = Math.max(1, state.tier);
    root.classList.toggle('agc-rit-bajada', baj);
    var t = $('#agcRitStepT'); if (t) t.textContent = baj ? 'Te lo dejamos en ' + fmt(A.price) + '.' : 'Set anual A-0';   /* Pedro 2026-09-21 13:50 (antes "Tu año, resuelto.") */   /* una sola línea (Pedro 2026-09-17); el "por ducha" lo dice la isla de cobertura */
    var bar = $('#agcRitReadyRow .agc-readybar-tx'); if (bar) bar.textContent = baj ? 'ÚLTIMA OPORTUNIDAD' : 'POR TIEMPO LIMITADO';
    /* Ancla POR DUCHA (Pedro 2026-09-16: "en t2 y t3 los rituales salen muy caros, pueden asustar"): el número grande es el
       precio de UN set, y el total va chico abajo. El CTA sí dice el total: es lo que se cobra. En la bajada el tachado es el
       $1190 que acaba de rechazar. */
    var was = $('#agcRitStepWas'); if (was) was.textContent = fmt(baj ? ritHi().price : (A.compare > A.price ? A.compare : A.price));
    var off = A.compare > A.price ? Math.floor((A.compare - A.price) * 100 / A.compare) + '% OFF' : '';
    if (off) $$('#agcRitHero .agc-rit3x2').forEach(function (b) { b.textContent = off; });
    var sub = $('#agcRitHero .agc-rit-sub2'); if (sub && baj) sub.textContent = from ? 'Solo en esta pantalla. Si sales, vuelve a ' + fmt(from) + '.' : 'Tu precio de última oportunidad sigue aquí.';
    var yl = $('#agcRitStepYes span'); if (yl) yl.textContent = baj ? 'Sí, lo quiero' : 'Aceptar oferta';
    buildRitCov(n);
    var px = $('#agcRitStepPx'), anim = ystep.anim = (ystep.anim || 0) + 1, t0 = null;
    if (px) px.classList.remove('is-hit');
    if (!px || !(from > A.price) || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) { if (px) px.textContent = fmt(A.price); paintRitStepPx(); return; }
    requestAnimationFrame(function step(ts) {
      if (anim !== ystep.anim) return;   /* salió del paso o volvió a entrar: esta caída ya no pinta */
      if (t0 === null) t0 = ts;
      var x = Math.min(1, (ts - t0) / 900), e = 1 - Math.pow(1 - x, 3);
      var v = x < 1 ? Math.round((from - (from - A.price) * e) / 100) * 100 : A.price;
      px.textContent = fmt(v); paintRitStepPx(v);
      if (x < 1) requestAnimationFrame(step); else px.classList.add('is-hit');
    });
  }
  /* Primer "No" a $1190: queda registrado (cfg_anual_step_no con rit 'alto' = rechazó el caro y vio la bajada) y el precio cae. */
  function ritDrop() {
    var from = ritNow().price;
    cfgTrack('cfg_anual_step_no', { tier: state.tier, qty: 0, price: 0, rit: 'alto' });
    state.ritBaj = true; try { localStorage.setItem('agcRitBajada', '1'); } catch (e) { }
    careStepClearMsg();
    paintRitStep(from);
  }
  /* Isla de cobertura "PARA 1 DUCHA / PARA 2 DUCHAS…" (Pedro 2026-09-16). La elegida vive en state.anualQty y manda en el CTA
     y en buildBaseItems. Con 1 ducha no se arma: no hay nada que elegir. */
  function buildRitCov(n) {
    var box = $('#agcRitCov'); if (!box) return;
    if (n < 2) { box.hidden = true; box.innerHTML = ''; return; }
    var h = '', i, A = ritNow(), sel = Math.max(1, Math.min(state.anualQty || n, n));   /* A = $1190 o $990 (bajada); sel = la cobertura elegida sobrevive al repintado */
    if (ANUALV4()) {
      /* card-fila: mismos datos que ya manda CFG.anual (precio/compare del variant del Set Anual),
         nada hardcodeado — % y precio-por-filtro se derivan de ahí. */
      var per = fmt(A.price / 3);
      var hasCmp = A.compare > A.price;
      var pct = hasCmp ? Math.floor((A.compare - A.price) * 100 / A.compare) : 0;
      for (i = 1; i <= n; i++) {
        var full = (i === n);
        /* Pasada Fable 2026-09-19: UN solo badge, corto ("COMPLETA"), siempre en la línea del título:
           a 390px "COBERTURA COMPLETA" no cabía junto al título y engordaba la card con un 3er renglón. */
        var badgeT = full ? '<span class="agc-ritcov-badge agc-ritcov-badge--t" aria-label="Cobertura completa">COMPLETA</span>' : '';
        var badgeS = '';
        var cmp = hasCmp
          ? '<span class="agc-ritcov-cmp">' + fmt(A.compare * i) + '</span><span class="agc-ritcov-off">' + pct + '% OFF</span>'
          : '';
        h += '<div class="agc-ritcov-opt' + (i === sel ? ' on' : '') + '" data-q="' + i + '" role="button" tabindex="0">' +
               '<span class="agc-ritcov-radio"></span>' +
               '<span class="agc-ritcov-mid">' +
                 '<span class="agc-ritcov-trow"><span class="agc-ritcov-lb">Para ' + i + (i > 1 ? ' duchas' : ' ducha') + '</span>' + badgeT + '</span>' +
                 '<span class="agc-ritcov-sub"><span class="agc-ritcov-subtxt">' + (3 * i) + ' filtros · <b>' + per + '</b> c/u</span>' + badgeS + '</span>' +
               '</span>' +
               '<span class="agc-ritcov-right">' +
                 '<span class="agc-ritcov-px">' + fmt(A.price * i) + '</span>' +
                 '<span class="agc-ritcov-cmprow">' + cmp + '</span>' +
               '</span>' +
             '</div>';
      }
    } else {
      for (i = 1; i <= n; i++) {
        h += '<div class="agc-ritcov-opt' + (i === sel ? ' on' : '') + '" data-q="' + i + '" role="button" tabindex="0">' +
             '<span class="agc-ritcov-lb">Para ' + i + (i > 1 ? ' duchas' : ' ducha') + '</span>' +   /* "Para…" (Pedro 2026-09-17: si no, parece que compran otras duchas) */
             '<span class="agc-ritcov-px">' + fmt(A.price * i) + '</span></div>';
      }
    }
    box.innerHTML = h; box.hidden = false;
  }
  function paintRitStepPx(p) {   /* p = precio de un set a medio caer (solo durante la bajada) */
    var n = Math.max(1, state.tier), q = Math.max(1, Math.min(state.anualQty || n, n)), u = p || ritNow().price;
    var add = $('#agcRitStepAddPx'); if (add) add.textContent = '+' + fmt(u * q);
    var tot = $('#agcRitStepTot');
    if (tot) { tot.textContent = q > 1 ? q + ' duchas · ' + fmt(u * q) + ' en total' : ''; tot.hidden = q < 2; }
  }
  (function () {
    var cov = $('#agcRitCov');
    if (cov) cov.addEventListener('click', function (e) {
      var o = e.target.closest('.agc-ritcov-opt'); if (!o || state.busy) return;
      var q = Number(o.getAttribute('data-q')) || state.tier;
      state.anualQty = q;
      cov.querySelectorAll('.agc-ritcov-opt').forEach(function (x) { x.classList.toggle('on', x === o); });
      paintRitStepPx();
      cfgTrack('cfg_anual_step_cov', { tier: state.tier, qty: q });
    });
  })();
  (function () {
    var yes = $('#agcRitStepYes'), no = $('#agcRitStepNo'), back = $('#agcRitStepBack');
    if (!yes || !no) return;
    function answer(sel, btn, ev) {
      if (state.busy) return;
      careStepClearMsg(); btn.classList.add('is-busy');
      ystep.asked = true; state.ritualSel = sel; state.ritualViaRow = false; state.ritAlto = sel && ritTier() === 'alto';
      var qty = Math.max(1, Math.min(state.anualQty || state.tier, state.tier));
      cfgTrack(ev, { tier: state.tier, qty: qty, price: Math.round(ritNow().price * qty / 100), rit: ritTier() });
      if (state.careSel) cfgTrack('cfg_step_yes', { price: Math.round((CC.carePrice || 9000) / 100) });
      else cfgTrack('cfg_step_no');
      proceedCheckout(false);
    }
    yes.addEventListener('click', function () { answer(true, yes, 'cfg_anual_step_yes'); });
    no.addEventListener('click', function () {
      if (state.busy) return;
      if (ritTier() === 'alto') { ritDrop(); return; }   /* primer "No": la bajada; el segundo sí continúa al pago */
      answer(false, no, 'cfg_anual_step_no');
    });
    if (back) back.addEventListener('click', function () {
      if (state.busy) return;
      state.ritualSel = ystep.prevRitual; state.ritualViaRow = ystep.prevViaRow;
      ystep.anim = (ystep.anim || 0) + 1;
      cfgTrack('cfg_anual_step_back', { rit: ritTier() });
      setStep('color');
    });
  })();

  $('#agcAddBtn').addEventListener('click', function () {
    if (state.busy) return;
    if (inCart()) { checkoutOrCare(); return; }
    /* fuera de la primera pantalla: "Comprar Aguacero" desliza al usuario de regreso al above-the-fold Y abre la card (1 click). slideUpToCard detecta scroll de ventana O scroller (en embed scrollea la ventana, no el scroller — por eso el viejo check de .scrolled no disparaba). Pedro 2026-06-22 */
    if (!islandOpen() && slideUpToCard()) { closeMenu(); setMode('config'); return; }
    /* "Comprar ahora" SIEMPRE expande la card (nunca se bloquea) */
    if (!islandOpen()) { closeMenu(); setMode('config'); return; }
    /* paso de color (Pedro 2026-06-21): card abierta en step 'config' → 1er click abre el
       paso de elegir color(es). En step 'color' → procede al ATC. */
    if (state.step === 'config') { setStep('color'); return; }
    /* card abierta + color agotado → guía a elegir un color disponible */
    if (colorSoldOut()) {
      var availC = CFG.colors.filter(function (x) { return x.available; })[0];
      if (sanitizeColors()) { try { buildColorStepRows(); } catch (e) {} }   /* corrige también el color de cada ducha, no solo el maestro */
      if (availC) selectColor(availC.key);
      return;
    }
    /* color step (Pedro 2026-06-29): T1/T2 → step Care (upsell de protección); T3 → checkout directo (Care ya va GRATIS). */
    /* Care step para TODOS los tiers desde 2026-07-22 (T3 perdió su Care gratis con el reset baseline → ahora también ve el upsell pagado). */
    /* CARE COMO FILA (Pedro 2026-08-11): sin step intermedio — del color al pago. La respuesta al
       upsell ya está tomada en la fila, así que aquí se reporta y se cobra lo que quedó marcado. */
    if (state.step === 'color' && careRowOn()) {
      if (yStepShould()) { yStepEnter(); return; }
      if (state.careSel) cfgTrack('cfg_step_yes', { price: Math.round((CC.carePrice || 9000) / 100) });
      else cfgTrack('cfg_step_no');
      proceedCheckout(false);
      return;
    }
    if (state.step === 'color') { careEntry(); return; }
    proceedCheckout(false);
  });

  /* ATC + checkout factorizado (Pedro 2026-06-29). addCare = agregar Aguacero Care PAGADO (solo T1/T2 desde el step). */
  /* Bundle BASE (sin Care pagado): duchas por color + filtro (sub o única) + regalos por tier. Fuente única para el add de entrada a Care y el fallback de T3. */
  /* Garantía dura: ningún acabado agotado sale hacia el carrito. La auto-corrección de
     colorSoldOut() solo cambiaba state.colorKey (el color "maestro"), nunca state.colors[] —
     el color de CADA ducha —, así que un agotado propagado desde la fila global seguía viajando
     al /cart/add.js y lo tumbaba con 422. Aquí se sustituye por el primero disponible. 2026-08-06 */
  function sanitizeColors() {
    var availC = CFG.colors.filter(function (x) { return x.available; })[0];
    if (!availC) return false;
    var changed = false;
    for (var i = 0; i < state.colors.length; i++) {
      var ci = colorByKey(state.colors[i]);
      if (!ci || !ci.available) { state.colors[i] = availC.key; changed = true; }
    }
    return changed;
  }
  function giftTapQty() { var gv = (CFG.cart || {}).tapeteGiftVariant; return !gv ? 0 : (state.tier >= 3 ? 2 : (state.tier >= 2 ? 1 : 0)); }   /* no depende de CC (se asigna más abajo) */
  function buildBaseItems() {
    ensureColorsLen();
    sanitizeColors();
    var counts = {};
    state.colors.forEach(function (k) { var vid = colorByKey(k).variantId; counts[vid] = (counts[vid] || 0) + 1; });
    var items = Object.keys(counts).map(function (vid) { return { id: Number(vid), quantity: counts[vid] }; });
    /* PLAN (Pedro 2026-06-27): Plus+ = filtro suscripción ($0 1ª vez → $590/90d); Única = filtro $290 SIN plan, 1 por ducha. Default 'plus'. */
    var _agcPlan = window.__agcPlan || 'plus';
    /* Sin suscripción si el switch está OFF **o si aceptaron el Set Anual** (Pedro 2026-09-21: "a todos los que aceptan ritual anual, quítales suscripción, eso lo quiero testear"):
       va el Filtro Inicial A-0 a $0 y SIN plan, 1 por ducha (Pedro: "sí quiero que aparezca en el carrito, Emissary ya sabe que ese no se despacha").
       Al aceptar con el switch ON la firma cambia en dos líneas → proceedCheckout re-arma completo (clear + add): +1 llamada solo en ese caso. */
    if (state.ritualSel) {
      /* Set Anual aceptado (Pedro 2026-09-22 18:30): el Filtro Inicial va como A-0 $0 SIN plan (no se queda sin filtro en el carrito);
         la recurrencia la lleva el Set: con switch ON entra con el plan "Cada año" de Recharge, con OFF es compra única. */
      if (CFG.filtroOnceVariantId) items.push({ id: Number(CFG.filtroOnceVariantId), quantity: state.tier });
    } else if (state.subOff) {
      if (CFG.filtroOnceVariantId) items.push({ id: Number(CFG.filtroOnceVariantId), quantity: state.tier });
    } else if (_agcPlan === 'once' && CFG.filtroOnceVariantId) {
      items.push({ id: Number(CFG.filtroOnceVariantId), quantity: state.tier });
    } else if (CFG.filtroVariantId) {
      var fItem = { id: CFG.filtroVariantId, quantity: state.tier };
      if (CFG.filtroPlanId) fItem.selling_plan = CFG.filtroPlanId;
      items.push(fItem);
    }
    /* TAPETE DE REGALO desde 2 duchas (Pedro 2026-09-22 17:00: "30-30-30, t2 en adelante con tapete de regalo, como en Hot Sale"):
       variante $0 49666160165112, 1 por pedido. La fila pagada del tapete se oculta en T2+ para no cobrarlo dos veces. */
    if (giftTapQty()) items.push({ id: Number((CFG.cart || {}).tapeteGiftVariant), quantity: giftTapQty() });
    /* Regalos RETIRADOS 2026-07-22 (reset baseline pre-aniversario 08-ago, Pedro: "offers se quedan sin regalos").
       Los variants $0 (tapeteGift 49666160165112 / careGift 49666160689400) quedan vivos en Shopify para reusarse el 08-ago. */
    /* ANIVERSARIO: Set Anual prepagado, 1 por ducha. Compra única (sin selling_plan) — es lo que
       hace que el año NO genere cobros trimestrales. */
    if (anivOn() && state.careSel && CC.careVariant) {
      items.push({ id: Number(CC.careVariant), quantity: 1 });
    }
    /* CARE fila (Pedro 2026-08-11): viaja en la base por la misma razón que el Set Anual —
       entra a la firma del carrito, así quitarla o volverla a poner re-arma solo, sin lógica
       nueva de checkout. Cantidad 1 por pedido (idéntico al step que reemplaza). */
    if (careRowOn() && state.careSel && CC.careVariant) {
      items.push({ id: Number(CC.careVariant), quantity: 1 });
    }
    /* TAPETE fila (Pedro 2026-08-13): mismo mecanismo que Care — viaja en la base, el toggle
       re-arma solo. Compra única, 1 por pedido. */
    if (careRowOn() && state.tapeteSel && CC.tapeteVariant && state.tier < 2) {
      items.push({ id: Number(CC.tapeteVariant), quantity: 1 });
    }
    /* Set Anual cross-sell (Pedro 2026-08-09; extendido a todos los tiers el 2026-08-12):
       compra única, sin selling plan. Vive en buildBaseItems A PROPÓSITO — entra a la firma del
       carrito y el toggle re-arma solo. Cantidad = duchas: un set por regadera, que es lo que
       sostiene el "Primer cobro día 365". */
    if (!anivOn() && state.ritualSel && CFG.anual && CFG.anual.variantId) {
      /* cobertura: completa por default; `anualQty` la baja cuando eligen "solo 1 ducha" en el último paso */
      var RA = ritPaid();   /* gemelo de $1190 si lo aceptó de entrada; el Set de $990 en la bajada (Pedro 2026-09-30) */
      var setItem = { id: Number(RA.variantId), quantity: Math.max(1, Math.min(state.anualQty || state.tier, state.tier)) };
      if (!state.subOff && RA.planId) setItem.selling_plan = Number(RA.planId);   /* switch ON → Set con renovación anual */
      items.push(setItem);
    }
    return items;
  }

  /* Entrada al PASO DE COLOR con la fila de Care (Pedro 2026-08-11): sin el step de Care, el
     armado del carrito se quedaba pegado al checkout y el AddToCart de Meta dejaba de ser una
     señal propia (medido: 840 sesiones llegaban al step vs 349 que tocan "Ir al pago").
     Aquí se arma UNA SOLA VEZ por sesión de configuración → el ATC vuelve a ser mid-funnel y
     para MÁS gente que antes. El candado es `state.cartBuilt`: sin él se re-armaría en cada
     cambio de color (4.3 clicks de color por sesión medidos) y el dataset se llenaría de ATCs
     duplicados. Si después cambian color/tier/plan, proceedCheckout detecta la firma distinta
     y re-arma antes de pagar — el cobro nunca depende de este armado temprano. */
  function colorEntryCart() {
    if (!careRowOn() || state.cartBuilt || colorSoldOut()) return;
    var items = buildBaseItems();
    var sig = JSON.stringify(items);
    state.attrsSig = null;
    state.careAddPromise = jpost('/cart/clear.js', {})
      .then(function () { return jpost('/cart/add.js', { items: items }); })
      .then(function () { state.cartBuilt = true; state.cartSig = sig; recheckCupon(); })
      .catch(function (err) { console.error('[AGC-CFG] colorEntryCart error', err); state.cartBuilt = false; state.cartSig = null; });
  }

  /* Entrada al step Care (T1/T2, Pedro 2026-07-22): arma el carrito base AHORA (clear+add) → el web pixel de
     Shopify dispara AddToCart en este momento (mid-funnel), NO hasta el checkout. clear en cada entrada = si el
     usuario regresa y cambia color/tier, el carrito se reconstruye sin duchas duplicadas. El Care PAGADO se
     agrega aparte en su botón. UX instantánea: mostramos el step ya; el add corre en background (proceedCheckout lo espera). */
  function careEntry() {
    if (colorSoldOut()) {
      var availC = CFG.colors.filter(function (x) { return x.available; })[0];
      if (sanitizeColors()) { try { buildColorStepRows(); } catch (e) {} }   /* corrige también el color de cada ducha, no solo el maestro */
      if (availC) selectColor(availC.key);
      return;
    }
    setStep('care');
    var items = buildBaseItems();
    var sig = JSON.stringify(items);
    /* Ya está EXACTAMENTE esto en el carrito → no se vuelve a armar. Esto es lo que corta las
       llamadas repetidas a /cart/*.js (y de paso los AddToCart duplicados del mismo carrito).
       Cualquier cambio de color, tier o plan cambia la firma → se re-arma y el ATC vuelve a
       dispararse. cartBuilt se invalida en pageshow, que es donde el carrito se vacía por fuera. */
    if (state.cartBuilt && state.cartSig === sig) return;
    state.cartBuilt = false; state.attrsSig = null;
    state.careAddPromise = jpost('/cart/clear.js', {})
      .then(function () { return jpost('/cart/add.js', { items: items }); })
      .then(function () { state.cartBuilt = true; state.cartSig = sig; recheckCupon(); })
      .catch(function (err) { console.error('[AGC-CFG] careEntry error', err); state.cartBuilt = false; state.cartSig = null; });
  }

  /* Un fallo dentro del step Care era MUDO: el aviso de error vive en #agcCtaLabel, que está
     oculto en este paso, y los CTA se quedaban con el "Dirigiendo al pago…" del is-busy para
     siempre (reporte de clienta 2026-08-06). Ahora se destraban los dos y el motivo se dice
     aquí mismo. El aviso se crea desde JS a propósito: así el fix vive en un solo archivo. */
  /* anchorSel: el botón "Sí" del paso vigente (Care o Set Anual) — el aviso se crea una vez y se
     mueve al paso que lo necesita. */
  function careStepMsg(text, anchorSel) {
    var anchor = $(anchorSel || '#agcCareStepYes'); if (!anchor || !anchor.parentNode) return;
    var box = $('#agcCareStepErr');
    if (!box) {
      box = document.createElement('div');
      box.id = 'agcCareStepErr';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:0 2px 12px;padding:10px 12px;border-radius:12px;background:rgba(255,86,86,.12);border:1px solid rgba(255,86,86,.38);color:#ff9a9a;font-size:13px;line-height:1.35;text-align:center';
    }
    if (box.nextSibling !== anchor) anchor.parentNode.insertBefore(box, anchor);
    box.textContent = text;
    box.style.display = '';
  }
  function careStepClearMsg() { var b = $('#agcCareStepErr'); if (b) b.style.display = 'none'; }
  function careStepFail(err) {
    var ids = ['#agcCareStepYes', '#agcCareStepNo', '#agcRitStepYes', '#agcRitStepNo'];
    for (var i = 0; i < ids.length; i++) { var b = $(ids[i]); if (b) b.classList.remove('is-busy'); }
    var inAnual = root.classList.contains('agc-step-anual');
    if (!inAnual && !root.classList.contains('agc-step-care')) return;
    var st = err && err.status;
    careStepMsg(st === 429 ? 'La tienda está saturada en este momento. Espera unos segundos y vuelve a intentar.'
      : st === 422 ? 'Ese color se acaba de agotar. Elige otro acabado y sigue con tu pedido.'
      : 'No pudimos llevarte al pago. Revisa tu conexión e intenta de nuevo.', inAnual ? '#agcRitStepYes' : '#agcCareStepYes');
  }

  /* ATC + checkout factorizado. addCare = agregar Aguacero Care PAGADO (solo T1/T2 desde el step).
     Si el bundle base ya está en el carrito (armado en color→Care) solo agrega el Care pagado; si no (T3 o fallback) arma todo. */
  /* Atributos que la ORDEN debe cargar y que el carrito no puede guardar por su cuenta
     (Pedro 2026-09-19): `_agc_ui` = la variante visual con la que se configuró, y el ref de
     socia, que cada clear.js del configurador borra del carrito. Prefijo "_" = no se le
     muestran a la clienta. Sin ref vigente no se escribe ninguna de las dos llaves. */
  /* A/B suscripción (Pedro 2026-09-21): switch en la tarjeta del paso 1 (snippet agc-sub-switch). Solo vive con la
     clase agc-subsw en #agc-cfg (?sub=switch); sin ella subOff siempre es false y el carrito es el de siempre. */
  function syncSubSw() {
    var r = document.getElementById('agc-cfg'), inp = document.getElementById('agcSubSwIn'), note = document.getElementById('agcSubSwNote');
    if (!r || !r.classList.contains('agc-subsw')) { state.subOff = false; return; }
    if (inp) inp.checked = !state.subOff;
    r.classList.toggle('agc-suboff', !!state.subOff);
    /* Pedro 2026-09-21: precio en la línea de Pausa SIN "+" ("es mentira, el + es hasta los 3 meses"), oculto al apagar; T2/T3 en plural y con su precio (la suscripción es POR ducha: $590 × duchas) */
    var n = Math.max(1, state.tier || 1), tt = document.getElementById('agcSubSwT');
    if (tt) tt.textContent = 'Cada 3 meses';   /* Pedro 22-sep 16:25: "Filtro nuevo · $590" pasa al renglón chico */
    if (tt) { tt.style.fontSize = ''; try { requestAnimationFrame(function () { var f = parseFloat(getComputedStyle(tt).fontSize) || 13; while (tt.scrollWidth > tt.clientWidth + 1 && f > 10) { f -= 0.5; tt.style.fontSize = f + 'px'; } }); } catch (e) { } }   /* una sola línea también con 4-6 duchas en 360 px */
    var dOn = (CFG.deals || [])[n - 1] || {}, dOff = (CFG.dealsOnce || [])[n - 1] || {};
    /* Fila "Filtro" de los totales del paso 2: con el switch apagado el A-0 se cobra (precio real del Admin) */
    var ctf = document.getElementById('agcCtFiltro');
    if (ctf) {
      if (!ctf.dataset.h0) ctf.dataset.h0 = ctf.innerHTML;
      ctf.innerHTML = (state.subOff && CFG.filtroOncePrice) ? (fmt(CFG.filtroOncePrice * n) + ' <s style="font-size:10.5px;color:var(--lt-faint);font-weight:400;margin-left:6px">' + fmt((CFG.filtroCompare || 59000) * n) + '</s>') : ctf.dataset.h0;
    }
    /* Pedro 2026-09-22 04:00: nunca "suscripción" → "Aguacero Plus+"; "pausa o cancela cuando quieras" completo; sin "sin cargos futuros" */
    /* Pedro 2026-09-24: sin título "Cada 3 meses" ni "Apagado"; el texto NO cambia al prender/apagar: "+ Filtro nuevo por $590 cada 3 meses" / "Pausa o cancela cuando quieras" */
    if (note) note.innerHTML = '<span class="agc-subsw-l1">+ ' + (n > 1 ? n + ' filtros nuevos' : 'Filtro nuevo') + ' por ' + fmt(59000 * n) + ' cada 3 meses</span><br>Pausa o cancela cuando quieras';
    /* paso 3 (Set Anual) habla distinto a quien apagó la suscripción: es su único camino a filtros futuros (Pedro 2026-09-21: "intentar que tomen ritual anual lo máximo posible") */
    /* Subtítulo del paso 3: se queda el del Liquid ("Adelántate: el filtro se cambia cada 3 meses. Nosotros te avisamos cuándo.", Pedro 2026-09-21 22:10); la variante "Sin suscripción…" de las 19:35 se retiró a petición suya */
    /* "Primer cobro día 365" (card del Set Anual del paso 1 y fila oculta del paso 2) sería falso sin suscripción: sin ella no hay ningún cobro */
    document.querySelectorAll('.agc-aniv-micro, #agcRitRow .agc-rit-sub .agc-carerow-on').forEach(function (el) { el.textContent = (state.subOff || !(CFG.anual && CFG.anual.planId)) ? 'Sin cargos futuros' : '365 días de agua limpia'; });   /* ON = Set con plan anual (Pedro 22-sep: sin recordar la suscripción) */
    /* Paso 3 para quien apagó la suscripción: el Set devuelve el 30 % (Pedro 2026-09-22) */
    var rs = document.querySelector('.agc-rit-sub2'), dO = (CFG.deals || [])[n - 1] || {};
    if (rs) { if (!rs.dataset.t0) rs.dataset.t0 = rs.textContent; rs.textContent = (CFG.dealsOnce && state.subOff && !state.ritualSel && dO.now && dO.off) ? ('Acepta el Set anual y ' + (n > 1 ? 'tus duchas bajan a ' + fmt(Math.round(dO.now / n)) + ' c/u' : 'tu ducha baja a ' + fmt(dO.now)) + ' (' + (dO.off || '') + '), sin Aguacero Plus+.') : rs.dataset.t0; }
  }
  (function () {
    var sw = document.getElementById('agcSubSw'), inp = document.getElementById('agcSubSwIn');
    if (!sw || !inp) return;
    sw.addEventListener('click', function (e) { e.stopPropagation(); });
    inp.addEventListener('change', function () {
      state.subOff = !inp.checked; syncSubSw();
      cfgTrack('sub_toggle', { sub_on: !state.subOff });
      try { render(); } catch (e) { }
      saveCfg();
    });
  })();
  function checkoutExtraAttrs() {
    var uv = uiVariant();
    var a = { '_agc_ui': uv.ui_tiers + '|' + uv.ui_anual + '|' + uv.ui_sub };
    try {
      var af = (window.AGCAfil && typeof AGCAfil.attrs === 'function') ? AGCAfil.attrs() : null;
      if (af) for (var k in af) a[k] = af[k];
    } catch (e) { }
    try {
      /* LP split (test astra vs PDP, 2026-09-23): celda de la landing (snippets/agc-lp-split.liquid → AGCLp.attrs), mismo contrato que AGCAfil */
      var lp = (window.AGCLp && typeof AGCLp.attrs === 'function') ? AGCLp.attrs() : null;
      if (lp) for (var k2 in lp) a[k2] = lp[k2];
    } catch (e) { }
    return a;
  }

  function proceedCheckout(addCare) {
    if (colorSoldOut()) {
      var availC = CFG.colors.filter(function (x) { return x.available; })[0];
      if (sanitizeColors()) { try { buildColorStepRows(); } catch (e) {} }   /* corrige también el color de cada ducha, no solo el maestro */
      if (availC) selectColor(availC.key);
      return;
    }
    state.busy = true;
    var btn = $('#agcAddBtn');
    if (btn) btn.setAttribute('disabled', '');
    var label = $('#agcCtaLabel');
    if (label) label.textContent = CTA_DIRECT_CHECKOUT ? 'Cambiando tu agua…' : 'Agregando…';
    /* SEGURO ANTI-TRABA (Pedro 2026-09-23: "el configurador se trabó, no puedo picarle a nada" con "Dirigiendo al pago…"):
       si 15 s después la página sigue visible y ocupada (navegación cancelada con "atrás", promesa colgada, red), se
       destraba sola — mismo destrabe que el pageshow, sin vaciar el carrito. Si sí navegó, el timer muere con la página. */
    var _busyWd = state.busyWd = (state.busyWd || 0) + 1;
    setTimeout(function () {
      if (!state.busy || state.busyWd !== _busyWd || document.visibilityState !== 'visible') return;
      state.busy = false;
      if (btn) btn.removeAttribute('disabled');
      if (label) { label.style.opacity = '1'; label.dataset.cur = ''; }
      try { updateCta(); } catch (x) { }
      ['#agcCareStepYes', '#agcCareStepNo', '#agcRitStepYes', '#agcRitStepNo'].forEach(function (s) { var e = $(s); if (e) e.classList.remove('is-busy'); });
      cfgTrack('cfg_checkout_stuck');
    }, 15000);

    function goCheckout() {
      /* EL BOLETO: re-adjuntar la predicción como cart attributes (el clear de pageshow los borra) → viajan a note_attributes de la orden */
      var mp = null; try { mp = JSON.parse(localStorage.getItem('agcMunPick') || sessionStorage.getItem('agcMunPick') || 'null'); } catch (e) {}
      var attach = (mp && mp.pick && (!mp.kickoff || Date.now() < mp.kickoff))
        ? (window.__agcMunAttach ? window.__agcMunAttach({ 'Mundial partido': mp.partido, 'Mundial marcador': mp.pick, 'Mundial WhatsApp aviso': mp.phone }) : jpost('/cart/update.js', { attributes: { 'Mundial partido': mp.partido, 'Mundial marcador': mp.pick, 'Mundial WhatsApp aviso': mp.phone } })).catch(function () {})
        : Promise.resolve();
      return attach.then(function () {
        /* F35 PIXEL: commit de atribución DESPUÉS del attach Mundial y ANTES de navegar. Fail-open: nunca bloquea la venta. */
        if (CTA_DIRECT_CHECKOUT) {
          /* funnel: ESTA es la salida real del flujo del configurador (goCheckout). El evento
             vivía solo en _agcPxGo — la salida del cart-island, por donde casi nadie pasa: 2
             registros vs ~136 órdenes el 09-ago. keepalive en cfgTrack porque la página navega. */
          cfgTrack('cfg_checkout_click');
          /* Atributos extra (variante visual + ref de socia) viajan DENTRO del mismo
             cart/update.js del pixel: AGCAttr.setExtras los fusiona y fuerza el envío aunque no
             haya touch guardado. Cero llamadas nuevas. Si el pixel está apagado nunca manda
             nada — solo ahí, y solo entonces, el configurador hace esa única llamada. */
          var xa = checkoutExtraAttrs(), px;
          if (state.attrsSig && state.attrsSig === state.cartSigAtGo) { return Promise.resolve().then(function () { window.location.href = '/checkout'; }); }   /* ya enviados al entrar al último paso (2026-09-21) */
          try {
            if (window.AGCAttr && AGCAttr.setExtras) AGCAttr.setExtras(xa);
            px = window.AGCAttr ? AGCAttr.beforeCheckout().catch(function () { return { reason: 'error' }; }) : Promise.resolve({ reason: 'disabled' });
          } catch (e) { px = Promise.resolve({ reason: 'disabled' }); }
          return px
            .then(function (r) { if (r && r.reason === 'disabled') return jpost('/cart/update.js', { attributes: xa }).catch(function () { }); })
            .then(function () { window.location.href = '/checkout'; });
        }
        return reloadCart().then(function () { loadTapeteSheet(); setMode('cart'); startCartBar(); state.busy = false; if (btn) btn.removeAttribute('disabled'); });
      });
    }
    function fail(err) { console.error('[AGC-CFG] checkout error', err); cfgTrack('cfg_checkout_error', { error: String((err && (err.status || err.message)) || err || '').slice(0, 120) }); if (label) label.textContent = 'Error — intenta de nuevo'; setTimeout(updateCta, 2200); state.busy = false; if (btn) btn.removeAttribute('disabled'); careStepFail(err); }

    /* espera a que termine el add de la entrada a Care (si venimos de ahí) para no correr una carrera */
    Promise.resolve(state.careAddPromise).then(function () {
      /* ANIVERSARIO: el step es del RITUAL → "yes" agrega el ritual (×q duchas). Care viaja en la base (card). */
      var stepItem = null;
      if (addCare) {
        stepItem = anivOn()
          ? { id: Number(CFG.anual.variantId), quantity: Math.max(1, Math.min(state.anualQty || state.tier, state.tier)) }
          : (CC.careVariant ? { id: Number(CC.careVariant), quantity: 1 } : null);
      }
      /* La configuración pudo cambiar DESPUÉS del armado — con la fila el carrito se arma al
         ENTRAR al paso de color, o sea antes de elegir acabado. Si la firma ya no coincide se
         re-arma: sin esto, cambiar de color mandaría al pago la ducha vieja. 2026-08-11 */
      var items = buildBaseItems();
      var sig = JSON.stringify(items);
      state.cartSigAtGo = state.cartBuilt ? state.cartSig : null;
      /* Solo cambió que se SUMÓ el Set Anual (clic en "Aceptar oferta"): se agrega esa línea y ya; sin clear
         los atributos ya enviados sobreviven. Antes: clear + add de todo (2026-09-21). */
      if (state.cartBuilt && state.cartSig !== sig && CFG.anual && CFG.anual.variantId) {
        var old = null; try { old = JSON.parse(state.cartSig); } catch (e) { }
        var _rv = Number(ritPaid().variantId);
        var extra = items.filter(function (it) { return Number(it.id) === _rv; });
        var rest = items.filter(function (it) { return Number(it.id) !== _rv; });
        if (old && extra.length === 1 && JSON.stringify(rest) === JSON.stringify(old)) {
          state.cartBuilt = false; state.cartSig = null;
          return jpost('/cart/add.js', { items: extra }).then(goCheckout).catch(fail);
        }
      }
      if (state.cartBuilt && state.cartSig !== sig) { state.cartBuilt = false; state.cartSig = null; state.cartSigAtGo = null; }
      if (state.cartBuilt) {
        if (stepItem) {
          /* el carrito deja de ser solo la base: si este intento falla y la clienta reintenta
             con "continuar sin protección", debe re-armarse limpio y NO llevarse el Care que
             acaba de rechazar. 2026-08-06 */
          state.cartBuilt = false; state.cartSig = null;
          return jpost('/cart/add.js', { items: [stepItem] }).then(goCheckout).catch(fail);
        }
        return goCheckout().catch(fail);
      }
      /* T3 o fallback (careEntry falló): arma todo el carrito ahora (clear+add) */
      if (stepItem) items.push(stepItem);
      return jpost('/cart/clear.js', {}).then(function () { return jpost('/cart/add.js', { items: items }); }).then(goCheckout).catch(fail);
    });
  }

  /* ANIVERSARIO: card de Care (toggle) + selector de duchas del Ritual (delegado). */
  (function () {
    var cc = $('#agcCareCard');
    if (cc) cc.addEventListener('click', function () {
      if (state.busy) return;
      state.careSel = !state.careSel;
      cfgTrack(state.careSel ? 'cfg_addon_added' : 'cfg_addon_removed', { addon: 'care' });
      render();
    });
    var rc = $('#agcRitualCard');
    if (rc) rc.addEventListener('click', function () {
      if (state.busy) return;
      state.ritualSel = !state.ritualSel; state.ritAlto = false;   /* por card o fila siempre es el Set de $990, el precio que ahí se ve */
      cfgTrack(state.ritualSel ? 'cfg_addon_added' : 'cfg_addon_removed', { addon: 'set_anual' });
      render();
    });
    var btns = $('#agcAnivQtyBtns');
    if (btns) btns.addEventListener('click', function (e) {
      var b = e.target.closest('.agc-aniv-q'); if (!b || state.busy) return;
      state.anualQty = Number(b.dataset.q) || state.tier;
      state.anualQtyTouched = true;
      render();
    });
  })();

  /* Fila de Care en el paso de color (Pedro 2026-08-11): llega MARCADA.
     Quitarla es un tap y se RESPETA mientras dure la página — nunca se re-agrega sola.
     (Una clienta que la quita y la vuelve a ver cobrada es un contracargo esperando.) */
  (function () {
    var row = $('#agcCareRow'); if (!row) return;
    /* ROLLBACK (CARE_AS_ROW=false o aniversario): el markup de la fila lo renderiza Liquid siempre,
       así que aquí se retira del DOM visible. Sin esto la clienta vería la fila diciendo "Care
       incluido" Y el step preguntándoselo otra vez — y la fila no agrega nada (buildBaseItems la
       ignora): sería una mentira en pantalla. El [hidden] necesita su regla !important en el CSS
       (cro-patterns §7: [hidden] 0,0,1 pierde contra .agc-carerow display:flex). */
    if (!careRowOn()) { row.hidden = true; return; }
    var btn = $('#agcCareRowBtn');
    /* Aguacero Care vuelve a nacer MARCADO (Pedro 2026-09-17: "vamos a preseleccionar de nuevo aguacero care"),
       ahora como card blanca visible con ✕ para quitarlo en un tap. Estuvo apagado del 16-sep 09:55 al 17-sep
       ~22:40 (ventana de medición de CVR sin Care). buildBaseItems solo lo mete si state.careSel. */
    state.careSel = false;   /* Pedro 2026-09-22 05:25: Care nace APAGADO — "quiero medir clean sin cobrarles más de repente"; supersede el 2026-09-17 */
    function paintCareRow() {
      row.classList.toggle('is-on', !!state.careSel);
      if (btn) {
        btn.setAttribute('aria-pressed', state.careSel ? 'true' : 'false');
        btn.setAttribute('aria-label', (state.careSel ? 'Quitar' : 'Agregar') + ' Aguacero Care');
      }
    }
    paintCareRow();
    /* "¿Qué es?" despliega el detalle en una 2ª línea. Es solo revelar texto: NO toca la
       selección de Care ni el carrito (Pedro 2026-08-12). */
    var what = $('#agcCareRowWhat');
    if (what) what.addEventListener('click', function () {
      var abierto = row.classList.toggle('is-open');
      what.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    });
    if (btn) btn.addEventListener('click', function () {
      if (state.busy) return;
      state.careSel = !state.careSel;
      cfgTrack(state.careSel ? 'cfg_addon_added' : 'cfg_addon_removed', { addon: 'care' });
      paintCareRow();
      renderCupon();   /* el ahorro incluye Care: si lo quitan, el número tiene que bajar */
    });
  })();

  /* Fila TAPETE (Pedro 2026-08-13) — hermana de la fila de Care, mismo contrato:
     solo estado + pintura; buildBaseItems la mete al carrito al (re)armar. Nace OFF. */
  function paintTapRow() {
    var row = $('#agcTapRow'); if (!row) return;
    /* T2+ = tapete de REGALO (Pedro 22-sep 17:00): la tarjeta se muestra marcada, "De regalo", sin toggle */
    var gift = giftTapQty() > 0;
    row.classList.toggle('is-gift', gift);
    var on = row.querySelector('.agc-carerow-on'), px = row.querySelector('.agc-carerow-px');
    if (on) { if (on.dataset.t0 == null) on.dataset.t0 = on.textContent; on.textContent = gift ? (state.tier >= 3 ? '2 tapetes de regalo' : 'Tapete de regalo') : on.dataset.t0; }
    if (px) { if (px.dataset.t0 == null) px.dataset.t0 = px.textContent; px.textContent = gift ? 'Regalo' : px.dataset.t0; }
    row.classList.toggle('is-on', gift || !!state.tapeteSel);
    var btn = $('#agcTapRowBtn');
    if (btn) {
      btn.setAttribute('aria-pressed', state.tapeteSel ? 'true' : 'false');
      btn.setAttribute('aria-label', (state.tapeteSel ? 'Quitar' : 'Agregar') + ' Tapete DiatoMAT');
    }
  }
  (function () {
    var row = $('#agcTapRow'); if (!row) return;
    if (!careRowOn()) { row.hidden = true; return; }   /* mismo rollback que la fila de Care */
    paintTapRow();
    var btn = $('#agcTapRowBtn');
    if (btn) btn.addEventListener('click', function () {
      if (state.busy) return;
      if (giftTapQty()) return;   /* regalo: no se quita ni se cobra */
      state.tapeteSel = !state.tapeteSel;
      cfgTrack(state.tapeteSel ? 'cfg_addon_added' : 'cfg_addon_removed', { addon: 'tapete_row' });
      paintTapRow();
      renderCupon();
    });
    /* "Ver fotos" abre el sheet existente del tapete — nadie compra lo que no ha visto */
    var what = $('#agcTapRowWhat');
    if (what) what.addEventListener('click', function () {
      loadTapeteSheet();
      openTapeteOrCare('tapete');
      cfgTrack('cfg_addon_detail', { addon: 'tapete_row' });
    });
  })();

  /* Fila SET ANUAL — 2ª oportunidad en el paso de color (Pedro 2026-08-18): hermana del tapete,
     mismo contrato (estado + pintura; buildBaseItems ya mete el set al carrito vía ritualSel).
     La visibilidad vive en la ENTRADA al paso (setStep 'color'). Tracking: 'set_anual_row'
     (vs 'set_anual' del step 1) — la comparación de exposiciones sale del funnel cfg_*. */
  function paintRitRow() {
    var row = $('#agcRitRow'); if (!row) return;
    row.classList.toggle('is-on', !!state.ritualSel);
    var btn = $('#agcRitRowBtn');
    if (btn) {
      btn.setAttribute('aria-pressed', state.ritualSel ? 'true' : 'false');
      btn.setAttribute('aria-label', (state.ritualSel ? 'Quitar' : 'Agregar') + ' Set Anual de Filtros');
    }
    /* precio y conteo por ducha: T2 = 2 sets = +$1980, nunca "+$990" que el checkout no cobra */
    /* MISMO precio que el paso final (Pedro 2026-09-30, Ritual $1190 → bajada $990): antes de la bajada la fila y su mini-tarjeta
       dicen $1190; ya vista la bajada, $990; agregado, lo que se cobra. Sin esto el paso de acabados decía +$990 y el siguiente +$1190. */
    var n = Math.max(1, state.tier), A = (state.ritualSel ? ritPaid() : ritNow()) || {};
    var px = $('#agcRitRowPx');
    if (px && A.price) px.textContent = '+' + fmt(A.price * n);
    var was = $('#agcRitRowWas');
    if (was) was.textContent = (A.compare > A.price) ? fmt(A.compare * n) : '';
    var bd = row.querySelector('.agc-rit3x2'); if (bd && A.compare > A.price) bd.textContent = Math.floor((A.compare - A.price) * 100 / A.compare) + '% OFF';
    var nEl = $('#agcRitRowN'); if (nEl) nEl.textContent = n > 1 ? ' ×' + n : '';
    var onEl = $('#agcRitRowOn'); if (onEl) onEl.textContent = n > 1 ? n + ' Sets Anuales agregados' : 'Set Anual agregado';
  }
  (function () {
    var row = $('#agcRitRow'); if (!row) return;
    var btn = $('#agcRitRowBtn');
    if (btn) btn.addEventListener('click', function () {
      if (state.busy) return;
      state.ritualSel = !state.ritualSel; state.ritAlto = state.ritualSel && ritTier() === 'alto';   /* se cobra el precio que la fila muestra: $1190 antes de la bajada, $990 después */
      state.ritualViaRow = state.ritualSel;   /* al quitarlo, vuelve a ser candidata a ocultarse */
      cfgTrack(state.ritualSel ? 'cfg_addon_added' : 'cfg_addon_removed', { addon: 'set_anual_row' });
      paintRitRow();
      renderCupon();
    });
  })();

  /* Línea VIVA de Care (v5, Pedro 2026-08-19): la tachita/+ hace PROXY al botón real de la
     card oculta — un solo dueño del toggle (tracking cfg_addon_*, carrito y repintado ya
     viven ahí). "¿Qué es?" solo despliega el detalle local. */
  (function () {
    var ln = $('#agcCareLine'); if (!ln) return;
    var x = $('#agcCareLineBtn');
    if (x) x.addEventListener('click', function () {
      var real = $('#agcCareRowBtn'); if (real) real.click();
    });
    var what = $('#agcCareLineWhat'), det = $('#agcCareLineDet');
    if (what && det) what.addEventListener('click', function () {
      var abrir = det.hidden;
      det.hidden = !abrir;
      what.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      ln.classList.toggle('is-open', abrir);
      if (abrir) cfgTrack('cfg_addon_detail', { addon: 'care' });   /* mismo evento que "Ver fotos" del tapete — interés en la explicación (la card vieja nunca lo midió) */
    });
  })();

  /* Step Care: sus propios botones (Pedro 2026-06-29) */
  (function () {
    var yes = $('#agcCareStepYes'), no = $('#agcCareStepNo'), back = $('#agcCareStepBack');
    if (yes) yes.addEventListener('click', function () {
      if (state.busy) return; careStepClearMsg(); yes.classList.add('is-busy');
      /* funnel: precio TOTAL agregado por el step (ritual × q duchas, o Care) — sin él el panel no calcula el ingreso del step */
      var _px = anivOn() ? Math.round(((CFG.anual.price || 0) * Math.max(1, Math.min(state.anualQty || state.tier, state.tier))) / 100) : 90;
      cfgTrack('cfg_step_yes', { price: _px });
      proceedCheckout(true);
    });
    if (no) no.addEventListener('click', function () { if (state.busy) return; careStepClearMsg(); no.classList.add('is-busy'); cfgTrack('cfg_step_no'); proceedCheckout(false); });
    if (back) back.addEventListener('click', function () { setStep('color'); });
  })();

  /* DIRECT-CHECKOUT (Pedro 2026-06-25): el cart es EFÍMERO (solo vehículo a checkout). Se vacía cada vez que se MUESTRA la landing (carga inicial + "back" del checkout — pageshow cubre ambos, incl. bfcache de webviews in-app Meta/IG) y se ponen en 0 AMBOS badges: el del configurador (#agcCartCount) y el del menú de arriba ([data-agcn-count] de agc-nav). Así el form POST nunca acumula y el badge no queda "lleno". */
  window.addEventListener('pageshow', function () {
    if (!CTA_DIRECT_CHECKOUT) return;
    /* RESET DEL CTA (Pedro 2026-06-26): al volver del checkout con "back", el bfcache restaura el DOM tal cual → el botón queda disabled + opaco con label "Cambiando tu agua…" y state.busy=true. Hay que destrabarlo. Como el click setea label.textContent directo (sin setCtaLabel), el cache dataset.cur NO se actualizó → invalidarlo para forzar el re-render del label correcto vía updateCta(). */
    state.busy = false;
    var _b = $('#agcAddBtn'); if (_b) _b.removeAttribute('disabled');
    var _l = $('#agcCtaLabel'); if (_l) { _l.style.opacity = '1'; _l.dataset.cur = ''; }
    try { updateCta(); } catch (x) {}
    var _cy = $('#agcCareStepYes'); if (_cy) _cy.classList.remove('is-busy');   /* back desde checkout en step Care → destraba el loading; el cart se limpia abajo → Care se quita (Pedro 2026-06-29) */
    var _cn = $('#agcCareStepNo'); if (_cn) _cn.classList.remove('is-busy');
    var _ry = $('#agcRitStepYes'); if (_ry) _ry.classList.remove('is-busy');   /* mismo destrabe para el último paso (Set Anual) */
    var _rn = $('#agcRitStepNo'); if (_rn) _rn.classList.remove('is-busy');
    /* El carrito se vacía aquí → la firma de careEntry deja de ser válida. Sin esto, volver del
       checkout con "back" y re-entrar a Care saltaría el armado y mandaría al pago un carrito
       VACÍO. Es la pieza que hace seguro el skip. 2026-08-06 */
    state.cartBuilt = false; state.cartSig = null;
    ystep.asked = false;   /* volver del checkout no debe saltarse el último paso (Pedro 2026-09-16) */
    /* AGCCartReset (Pedro 2026-10-11, velocidad al pago): la pantalla única (agc-encuesta.js) espera a que ESTE vaciado termine para armar
       su carrito, en lugar de 2.5 s fijos tras volver del checkout. Siempre se resuelve (el catch de abajo). */
    window.AGCCartReset = jpost('/cart/clear.js', {}).then(function () {
      document.querySelectorAll('#agcCartCount, [data-agcn-count]').forEach(function (el) { el.textContent = '0'; });
      try { reloadCart(); } catch (x) {}
      recheckCupon();   /* el carrito viejo que se leyó al cargar ya no existe (línea SORPRESA oculta, 2026-09-14) */
    }).catch(function () {});
  });

  /* ══ EL BOLETO — STEP NATIVO dentro del configurador (Pedro 2026-07-03).
     Gemelo del step Care: root.agc-step-mun muestra #agcMunStepSect y oculta el resto.
     Data pipeline INTACTO: localStorage + cart attributes con retry + Klaviyo + kickoff guard. ══ */
  (function () {
    var mun = document.getElementById('agcMunStepSect'); if (!mun) return;
    window.__agcMunAttach = function (attrs) {
      return jpost('/cart/update.js', { attributes: attrs }).catch(function () {
        return new Promise(function (res) { setTimeout(res, 900); }).then(function () {
          return jpost('/cart/update.js', { attributes: attrs });
        });
      });
    };
    var kickoff = Date.parse(mun.getAttribute('data-kickoff') || '') || 0;
    var partido = mun.getAttribute('data-partido') || 'MEX-ENG';
    var flapM = document.getElementById('agcFlapMex'), flapE = document.getElementById('agcFlapEng');
    var phone = document.getElementById('agcMunPhone'), listo = document.getElementById('agcMunListo');
    if (phone) phone.addEventListener('input', function () { phone.value = phone.value.replace(/\D/g, '').slice(0, 10); });
    var countEl = document.getElementById('agcMunCount');
    var vals = { mex: null, eng: null }, cIv = null;

    function pickToAnnbar(pick) {
      var bar = document.getElementById('agcAnnBar'); if (!bar) return;
      var sp = bar.querySelector('.agc-annbar-mun');
      if (!sp) { sp = document.createElement('span'); sp.className = 'agc-annbar-msg agc-annbar-mun'; bar.appendChild(sp); }
      sp.textContent = '\ud83c\udf9f\ufe0f Tu boleto ' + String(pick).replace('-', '\u2013') + ' queda activo con esta compra';
    }
    var inline = document.getElementById('agcMunInline'), inlineScore = document.getElementById('agcMunInlineScore');
    function syncInline(pick) {
      if (!inline) return;
      if (inlineScore) inlineScore.textContent = 'MEX ' + String(pick).replace('-', '\u2013') + ' ENG';
      inline.hidden = false;
    }
    function syncListo() { if (listo) listo.disabled = (vals.mex === null || vals.eng === null); }
    function applyPick(pick) {
      var m = String(pick).split('-');
      vals.mex = +m[0]; vals.eng = +m[1];
      if (flapM) { flapM.querySelector('.fv').textContent = vals.mex; flapM.classList.remove('is-empty'); }
      if (flapE) { flapE.querySelector('.fv').textContent = vals.eng; flapE.classList.remove('is-empty'); }
      syncListo();
    }
    var saved = null; try { saved = JSON.parse(localStorage.getItem('agcMunPick') || sessionStorage.getItem('agcMunPick') || 'null'); } catch (e) {}
    if (saved && saved.partido === partido) { pickToAnnbar(saved.pick); syncInline(saved.pick); applyPick(saved.pick); if (phone && saved.phone) phone.value = saved.phone; }

    function stepOpen(force) {
      if (kickoff && Date.now() >= kickoff) return false;
      if (!force) {
        try { if (sessionStorage.getItem('agcMunSeen')) return false; } catch (e) {}
        /* ya selló un boleto → no re-mostrar el step (su pick vive en el mini-boleto de tiers; "Cambiar" lo reabre) */
        try { var sp = JSON.parse(localStorage.getItem('agcMunPick') || 'null'); if (sp && sp.pick && sp.partido === partido) return false; } catch (e) {}
      }
      root.classList.add('agc-step-mun'); tickCount();
      return true;
    }
    function stepClose() {
      root.classList.remove('agc-step-mun');
      try { sessionStorage.setItem('agcMunSeen', '1'); } catch (e) {}
      requestAnimationFrame(placeAnnBar);
    }
    window.__agcMunMaybeOpen = function () { return stepOpen(false); };
    var skip = document.getElementById('agcMunSkip2'); if (skip) skip.addEventListener('click', stepClose);
    var inlineEdit = document.getElementById('agcMunInlineEdit');
    if (inlineEdit) inlineEdit.addEventListener('click', function () {
      var sv = null; try { sv = JSON.parse(localStorage.getItem('agcMunPick') || sessionStorage.getItem('agcMunPick') || 'null'); } catch (e) {}
      if (sv && sv.pick) { applyPick(sv.pick); if (phone && sv.phone) phone.value = sv.phone; }
      stepOpen(true);   /* reabrir ignora el seen: es acción explícita */
    });
    var terms = document.getElementById('agcMunTerms'), legal = document.getElementById('agcMunLegal');
    if (terms && legal) terms.addEventListener('click', function () {
      legal.hidden = !legal.hidden;
      terms.textContent = legal.hidden ? 'Términos' : 'Cerrar términos ↑';
      if (!legal.hidden) legal.scrollTop = 0;
    });

    function setFlap(el, side, d) {
      var v = vals[side] === null ? (d > 0 ? 1 : 0) : Math.max(0, Math.min(7, vals[side] + d));
      if (vals[side] !== null && v === vals[side]) return;
      vals[side] = v;
      el.classList.remove('flip'); void el.offsetWidth; el.classList.add('flip'); el.classList.remove('is-empty');
      setTimeout(function () { el.querySelector('.fv').textContent = v; }, 95);
      syncListo();
    }
    mun.addEventListener('click', function (e) {
      var b = e.target.closest('.agc-mun-step'); if (!b) return;
      setFlap(b.getAttribute('data-side') === 'mex' ? flapM : flapE, b.getAttribute('data-side'), +b.getAttribute('data-d'));
    });

    function tickCount() {
      if (!countEl || cIv) return;
      function t() {
        var diff = kickoff - Date.now();
        if (diff <= 0) { countEl.textContent = '\u00a1ya rueda!'; stepClose(); clearInterval(cIv); cIv = null; return; }
        var sec = Math.floor(diff / 1000), dd = Math.floor(sec / 86400); sec -= dd * 86400;
        var h = Math.floor(sec / 3600); sec -= h * 3600; var m = Math.floor(sec / 60); sec -= m * 60;
        countEl.textContent = (dd > 0 ? dd + 'D ' : '') + String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
      }
      t(); cIv = setInterval(t, 1000);
    }
    /* Contador de boletos: determinista (mismo valor para todos según la hora). VOLUMEN, nunca distribución. */
    function boletosNow() {
      var t0 = Date.UTC(2026, 6, 3, 2, 0, 0);
      var now = Date.now(), n = 340, t = t0;
      if (now <= t0) return n;
      var hrs = (now - t0) / 3600000;
      for (var h = 0; h < Math.floor(hrs); h++) {
        var cdmxH = (20 + h) % 24;
        n += (cdmxH >= 8 && cdmxH < 24) ? 55 : 14;
      }
      var frac = hrs - Math.floor(hrs), curH = (20 + Math.floor(hrs)) % 24;
      n += Math.floor(frac * ((curH >= 8 && curH < 24) ? 55 : 14));
      return n;
    }
    var volEl = document.getElementById('agcMunVol');
    function syncVol() { if (volEl) volEl.textContent = boletosNow().toLocaleString('en-US'); }
    syncVol(); setInterval(syncVol, 45000);

    if (listo) listo.addEventListener('click', function () {
      if (vals.mex === null || vals.eng === null) return;
      /* captura de WhatsApp (Pedro 2026-07-05: más confianza que correo): aviso al ganador + alta Klaviyo por teléfono. 10 dígitos requeridos para sellar. */
      var ph = (phone && phone.value || '').replace(/\D/g, '');
      if (ph.length !== 10) { if (phone) { phone.classList.remove('err'); void phone.offsetWidth; phone.classList.add('err'); phone.focus(); } return; }
      listo.classList.add('is-busy');
      var pick = vals.mex + '-' + vals.eng;
      try { localStorage.setItem('agcMunPick', JSON.stringify({ pick: pick, partido: partido, phone: ph, kickoff: kickoff })); } catch (e) {}
      window.__agcMunAttach({ 'Mundial partido': partido, 'Mundial marcador': pick, 'Mundial WhatsApp aviso': ph }).catch(function () {});
      try {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + ((CFG && CFG.klaviyoCompany) || 'SFNwUe'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { phone_number: '+52' + ph, properties: { mundial_partido: partido, mundial_marcador: pick, mundial_whatsapp: ph } } } } }, relationships: { list: { data: { type: 'list', id: (CFG && CFG.klaviyoList) || 'TmrPHJ' } } } } })
        }).catch(function () {});
      } catch (e) {}
      setTimeout(function () {
        listo.classList.remove('is-busy');
        listo.querySelector('span').textContent = 'Boleto sellado \u2713';
        setTimeout(function () {
          pickToAnnbar(pick); syncInline(pick); stepClose();
          listo.querySelector('span').textContent = 'Sellar mi boleto';
        }, 850);
      }, 650);
    });
  })();

  /* ── NUDGE del CTA (Pedro 2026-08-01) ──────────────────────────────────────
     5s sin interacción → .agc-idle en el root y el borde de luz se enciende
     (todo el efecto vive en agc-cfg.css). Cualquier señal de avance lo apaga.
     A propósito NO escucha pointermove: quien mueve el mouse leyendo el precio
     es justo a quien hay que empujar. Sin rAF — un timer y ya. */
  (function () {
    var IDLE_MS = 5000, timer = null;

    function wake() {
      root.classList.remove('agc-idle');
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        if (!state.busy) root.classList.add('agc-idle');
      }, IDLE_MS);
    }

    ['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach(function (evt) {
      root.addEventListener(evt, wake, { passive: true });
    });
    window.addEventListener('scroll', wake, { passive: true });

    /* pestaña en segundo plano: nada que empujar, y no gastamos frames */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        root.classList.remove('agc-idle');
        if (timer) { clearTimeout(timer); timer = null; }
      } else { wake(); }
    });

    wake();
  })();

  whenCfgNear(function () {
    buildStrip(state.colorKey);
    setHeroColor(state.colorKey);
  });
  syncThumb();
  syncSoldPill();
  render();
  paintRowsStatic(); paintRowsMarginal();   /* MOCK filas (?tiers=rows, Pedro 2026-09-18): no depende de state, se pinta una vez */
  refreshCount();

  /* ══ VOLVER DEL CHECKOUT SIN PERDER LO ELEGIDO (Pedro 2026-09-16: "si voy a checkout dando en AGREGAR, luego vuelvo, ya no
     llego al mismo paso"). Medido: al regresar, la página se re-ejecuta y el estado nacía en blanco (tier 1, sin color, sin
     add-ons) mientras el carrito se vaciaba. Ahora la configuración vive en sessionStorage (solo esta pestaña, sin datos
     personales) y se restaura al cargar. El carrito se sigue armando al ir al pago: aquí no se toca dinero. ══ */
  var CFG_KEY = 'agcCfgState';
  var _saveT = 0;
  function saveCfg() {
    if (_saveT) return;
    _saveT = setTimeout(function () {
      _saveT = 0;
      try {
        sessionStorage.setItem(CFG_KEY, JSON.stringify({
          v: 1, tier: state.tier, colors: state.colors, colorKey: state.colorKey, colorPerDucha: !!state.colorPerDucha,
          careSel: !!state.careSel, ritualSel: !!state.ritualSel, ritualViaRow: !!state.ritualViaRow, ritAlto: !!state.ritAlto, tapeteSel: !!state.tapeteSel,
          anualQty: state.anualQty || null, plan: window.__agcPlan || 'plus', subOff: !!state.subOff, step: state.step
        }));
      } catch (e) { }
    }, 250);
  }
  function restoreCfg() {
    var raw = null;
    try { raw = sessionStorage.getItem(CFG_KEY); } catch (e) { }
    if (!raw) return;
    var d; try { d = JSON.parse(raw); } catch (e) { return; }
    if (!d || d.v !== 1 || !d.tier) return;
    state.tier = Math.max(1, Math.min(d.tier, 3));   /* sin 4-6 desde 22-sep (fila "¿Necesitas más?" retirada) */
    if (Array.isArray(d.colors) && d.colors.length) state.colors = d.colors.slice(0, state.tier);
    state.colorPerDucha = !!d.colorPerDucha;
    state.careSel = !!d.careSel; state.ritualSel = !!d.ritualSel; state.ritualViaRow = !!d.ritualViaRow; state.ritAlto = !!d.ritAlto;
    state.tapeteSel = !!d.tapeteSel; state.anualQty = d.anualQty || null;
    window.__agcPlan = d.plan || 'plus';
    state.subOff = !!d.subOff; syncSubSw();
    ensureColorsLen();
    $$('.agc-opt[data-tier]').forEach(function (x) { x.classList.toggle('on', +x.dataset.tier === state.tier); });
    if (d.colorKey) { state.colorKey = d.colorKey; setHeroColor(d.colorKey); syncThumb(); }
    try { paintCareRow(); } catch (e) { }
    try { paintTapRow(); } catch (e) { }
    render();
    updateCta();
    /* el paso final se vuelve a ofrecer; quien regresa del checkout NO debe saltárselo por una bandera vieja */
    ystep.asked = false;
    if (d.step === 'color' || d.step === 'anual') { setMode('config'); setStep('color', true); }
  }
  restoreCfg();
  ['click', 'change'].forEach(function (ev) { root.addEventListener(ev, saveCfg, true); });
  window.addEventListener('pagehide', function () { if (_saveT) { clearTimeout(_saveT); _saveT = 0; } try { sessionStorage.setItem(CFG_KEY, JSON.stringify({ v: 1, tier: state.tier, colors: state.colors, colorKey: state.colorKey, colorPerDucha: !!state.colorPerDucha, careSel: !!state.careSel, ritualSel: !!state.ritualSel, ritualViaRow: !!state.ritualViaRow, ritAlto: !!state.ritAlto, tapeteSel: !!state.tapeteSel, anualQty: state.anualQty || null, plan: window.__agcPlan || 'plus', subOff: !!state.subOff, step: state.step })); } catch (e) { } });
  document.dispatchEvent(new Event('agc:config-ready'));
})();
